var ed = Object.defineProperty;
var td = (e, t, n) => t in e ? ed(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var bs = (e, t, n) => td(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as i, jsxs as m, Fragment as re } from "react/jsx-runtime";
import * as ft from "@radix-ui/react-accordion";
import { ChevronDown as Qo, ChevronRight as ea, ChevronLeft as nd, SearchIcon as rd, Calendar as ta, Check as na, Circle as id, ChevronUp as sd } from "lucide-react";
import * as T from "react";
import Y, { useReducer as od, useCallback as Re, useEffect as Ue, useMemo as en, useState as ne, useRef as Me, createContext as It, useLayoutEffect as ad, useContext as xe, useId as si, Fragment as ra, createElement as ld, useInsertionEffect as ia, forwardRef as cd, Component as dd } from "react";
import { clsx as ud } from "clsx";
import { extendTailwindMerge as hd } from "tailwind-merge";
import { cva as Be } from "class-variance-authority";
import { create as sa } from "zustand";
import { Slot as tn } from "@radix-ui/react-slot";
import * as Ct from "@radix-ui/react-tooltip";
import * as oa from "@radix-ui/react-separator";
import { DayPicker as fd } from "react-day-picker";
import * as We from "@radix-ui/react-tabs";
import * as oi from "recharts";
import { Command as pt } from "cmdk";
import * as J from "@radix-ui/react-dialog";
import * as ct from "@radix-ui/react-scroll-area";
import * as Wt from "@radix-ui/react-popover";
import { format as Bt } from "date-fns";
import * as ee from "@radix-ui/react-dropdown-menu";
import pd, { BasePlugin as md } from "@uppy/core";
import { UppyContextProvider as gd, useUppyContext as aa } from "@uppy/react";
import { useDropzone as yd } from "react-dropzone";
import * as xs from "@radix-ui/react-progress";
import * as la from "@radix-ui/react-label";
import { useFormContext as vd, FormProvider as bd, Controller as xd } from "react-hook-form";
import * as ws from "@radix-ui/react-checkbox";
import wd from "react-dom";
import * as Mr from "@radix-ui/react-radio-group";
import * as ae from "@radix-ui/react-select";
import * as ks from "@radix-ui/react-switch";
import { flexRender as Ft, useReactTable as kd, getExpandedRowModel as Sd, getPaginationRowModel as Nd, getSortedRowModel as Td, getCoreRowModel as Cd } from "@tanstack/react-table";
import { useVirtualizer as Md } from "@tanstack/react-virtual";
import { toast as Ss, Toaster as Pd } from "sonner";
const Dd = hd({
  extend: {
    classGroups: {
      "font-size": [
        "text-size-display-xl",
        "text-size-display-lg",
        "text-size-h1",
        "text-size-h2",
        "text-size-h3",
        "text-size-h4",
        "text-size-body-lg",
        "text-size-body-sm",
        "text-size-caption",
        "text-size-label",
        "text-size-section-label"
      ],
      shadow: [
        "shadow-small-grey",
        "shadow-small-orange",
        "shadow-md-grey",
        "shadow-md-orange",
        "shadow-system"
      ]
    }
  }
});
function g(...e) {
  return Dd(ud(...e));
}
const O0 = ft.Root, Id = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  ft.Item,
  {
    ref: n,
    className: g(" ", e),
    ...t
  }
));
Id.displayName = "AccordionItem";
const Ad = T.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ i(ft.Header, { className: "flex", children: /* @__PURE__ */ m(
  ft.Trigger,
  {
    ref: r,
    className: g(
      "flex flex-1 cursor-pointer items-center gap-2 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ i(Qo, { className: "w-4 h-4 mb-1 transition-transform duration-200 stroke-current shrink-0" })
    ]
  }
) }));
Ad.displayName = ft.Trigger.displayName;
const Ed = T.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ i(
  ft.Content,
  {
    ref: r,
    className: "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...n,
    children: /* @__PURE__ */ i("div", { className: g("pb-4 pt-0", e), children: t })
  }
));
Ed.displayName = ft.Content.displayName;
const Vd = T.forwardRef(({ className: e, number: t, hasError: n, ...r }, s) => {
  const a = t.toString().padStart(2, "0");
  return /* @__PURE__ */ i(
    "div",
    {
      ref: s,
      className: g(
        "flex items-center justify-center text-lg tracking-tightest text-ink-primary font-sentric font-extrabold opacity-10 dark:opacity-30 shrink-0 w-8",
        n && "text-ink-accent opacity-75 dark:opacity-100",
        e
      ),
      ...r,
      children: /* @__PURE__ */ i("div", { children: a })
    }
  );
});
Vd.displayName = "AccordionItemNumber";
const H = sa((e) => ({
  isTunecore: !1,
  setIsTunecore: (t) => {
    typeof document < "u" && (t ? document.documentElement.setAttribute("data-theme", "tunecore") : document.documentElement.removeAttribute("data-theme")), e({ isTunecore: t });
  }
}));
function Ld(e) {
  const t = g("text-ink-primary", e ? "font-tunecore" : "font-sentric");
  return e ? {
    h1: g(t, "text-[2rem] font-black leading-[1.167] tracking-[-0.025rem]"),
    h2: g(t, "text-[1.3rem] lg:text-[1.5rem] shrink font-black"),
    h3: g(t, "text-[1.875rem] font-black"),
    h4: g(t, "text-[1rem] font-bold"),
    // Display sizes are a new-design-system-only addition (hero/landing
    // surfaces); tunecore has no equivalent spec, so these are size-only
    // placeholders — revisit if/when a tunecore surface needs them.
    displayLg: g(t, "text-[3.05rem] font-normal"),
    displayXl: g(t, "text-[4rem] font-normal")
  } : {
    // Sentric Design System v1.0 (June 2026) type scale — values confirmed
    // against live Figma text styles, not just the PDF doc. H3 and H4 are
    // both Semibold (600) despite the PDF and Figma's own printed dev-spec
    // labels both stating 500 — confirmed against the underlying Figma
    // style data (font-name "Semibold", weight 600), same stale-label
    // pattern as Body LG's printed "18px" vs its real 20px.
    h1: g(t, "text-size-h1 font-normal leading-[1.15] tracking-[-0.01em]"),
    h2: g(t, "text-size-h3 lg:text-size-h2 shrink font-normal leading-[1.15] tracking-[-0.01em]"),
    h3: g(t, "text-size-h3 font-semibold leading-[1.2] tracking-[-0.01em]"),
    h4: g(t, "text-size-h4 font-semibold leading-[1.25] tracking-[-0.01em]"),
    // Hero/landing surfaces only (Figma: "Hero headlines, landing page
    // primary" / "Section heroes, feature intros") — still H1-level
    // semantically, so both render as <h1> via the Component map below.
    displayLg: g(t, "text-size-display-lg font-normal leading-[1.08] tracking-[-0.01em]"),
    displayXl: g(t, "text-size-display-xl font-normal leading-[1.05] tracking-[-0.01em]")
  };
}
function ai(e, t) {
  return Ld((t == null ? void 0 : t.isTunecore) ?? !1)[e];
}
const ca = Y.forwardRef(({
  children: e,
  as: t = "h1",
  className: n = "",
  ...r
}, s) => {
  const a = H((c) => c.isTunecore), o = t === "displayLg" || t === "displayXl" ? "h1" : t, l = ai(t, { isTunecore: a });
  return /* @__PURE__ */ i(o, { ref: s, className: g(l, n), ...r, children: e });
});
ca.displayName = "Heading";
const Rd = Be(
  "relative w-full rounded-sm border p-4",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-stroke-error bg-layer-error text-ink-error",
        warning: "border-stroke-warning bg-layer-warning text-ink-warning",
        success: "border-stroke-success bg-layer-success text-ink-success",
        info: "border-stroke-info bg-layer-info text-ink-info"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), da = T.forwardRef(({ className: e, variant: t, ...n }, r) => {
  const s = H((o) => o.isTunecore), a = T.useMemo(() => {
    if (!s)
      return "";
    switch (t) {
      case "destructive":
        return "text-white bg-[rgba(244,67,54,0.2)] font-tunecore border-none";
      case "warning":
        return "border-yellow-400 bg-layer-inverse text-white";
      case "success":
        return "border-stroke-primary bg-layer-inverse text-white";
      case "info":
        return "border-blue-400 bg-layer-inverse text-white";
      case "default":
      case void 0:
      case null:
      default:
        return "bg-layer-inverse text-white border-stroke-subtle";
    }
  }, [s, t]);
  return /* @__PURE__ */ i(
    "div",
    {
      ref: r,
      role: "alert",
      className: g(
        Rd({ variant: t }),
        // TuneCore predates this radius token system and has no radius spec
        // of its own — restore the exact rounded-lg (8px) it always rendered
        // at, rather than silently inheriting Sentric's new rounded-sm (6px).
        s && "rounded-lg",
        s && a,
        e
      ),
      ...n
    }
  );
});
da.displayName = "Alert";
const Pr = T.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ i(
  ca,
  {
    as: "h4",
    ref: r,
    className: g(
      "mb-2 font-semibold",
      e
    ),
    ...n,
    children: t
  }
));
Pr.displayName = "AlertTitle";
const Dr = T.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ i(
  "p",
  {
    ref: r,
    className: g(
      "font-sentric-alt",
      e
    ),
    ...n,
    children: t
  }
));
Dr.displayName = "AlertDescription";
const zd = ({
  message: e,
  formErrors: t,
  validationIssues: n,
  title: r,
  showDebug: s = !0,
  className: a,
  variant: o = "destructive"
}) => {
  const l = H((f) => f.isTunecore), c = e != null && e.trim() !== "", d = t != null && Object.keys(t).length > 0, u = n != null && n.length > 0;
  if (!c && !d && !u)
    return null;
  const h = l ? "font-tunecore" : "font-sentric-alt";
  return /* @__PURE__ */ m(da, { variant: o, className: a, children: [
    c && !d && !u && /* @__PURE__ */ m(re, { children: [
      /* @__PURE__ */ i(Pr, { children: r != null && r.trim() !== "" ? r : "Error" }),
      /* @__PURE__ */ i(Dr, { children: /* @__PURE__ */ i("p", { className: h, children: e }) })
    ] }),
    (d || u) && /* @__PURE__ */ m(re, { children: [
      /* @__PURE__ */ i(Pr, { children: r != null && r.trim() !== "" ? r : "Please fix the following issues:" }),
      /* @__PURE__ */ i(Dr, { children: /* @__PURE__ */ m("div", { className: "space-y-1", children: [
        d && Object.entries(t).map(([f, y]) => {
          let p = "Unknown error";
          if (y != null && typeof y == "object" && "message" in y) {
            const v = y;
            typeof v.message == "string" && (p = v.message);
          }
          return /* @__PURE__ */ m("div", { children: [
            /* @__PURE__ */ m("p", { className: h, children: [
              "•",
              " ",
              p
            ] }),
            s && !1
          ] }, f);
        }),
        u && n.map((f) => /* @__PURE__ */ m("p", { className: h, children: [
          "•",
          " ",
          f
        ] }, f))
      ] }) })
    ] })
  ] });
}, Bd = Be(
  "inline-flex items-center justify-center rounded-lg border px-3 py-1 text-sm font-medium font-sentric-alt w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] transition-[color,box-shadow] overflow-hidden",
  {
    variants: {
      variant: {
        default: "border-transparent bg-layer-raised text-ink-primary",
        primary: "border-transparent bg-action-primary text-white",
        secondary: "border-transparent bg-layer-strong text-ink-primary",
        success: "border-transparent bg-layer-success text-ink-success",
        warning: "border-transparent bg-layer-warning text-ink-warning",
        danger: "border-transparent bg-layer-error text-ink-error",
        info: "border-transparent bg-layer-info text-ink-info",
        neutral: "border-transparent bg-ink-secondary text-white",
        muted: "border-transparent bg-ink-secondary text-white",
        outline: "text-ink-primary border-stroke-subtle"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function jd({
  className: e,
  variant: t,
  asChild: n = !1,
  ...r
}) {
  return /* @__PURE__ */ i(
    n ? tn : "span",
    {
      "data-slot": "badge",
      className: g(Bd({ variant: t }), e),
      ...r
    }
  );
}
const Fd = {
  md: "w-4 h-4",
  lg: "w-6 h-6",
  xl: "w-8 h-8"
};
function P({
  children: e,
  height: t,
  className: n,
  width: r,
  viewBox: s = "0 0 24 24",
  disabled: a = !1,
  size: o = "md",
  ...l
}) {
  return /* @__PURE__ */ i(
    "svg",
    {
      className: g(Fd[o], "transition ease-out duration-200", a && "opacity-15", n),
      xmlns: "http://www.w3.org/2000/svg",
      width: r,
      height: t,
      viewBox: s,
      fill: "none",
      strokeWidth: "1.75",
      preserveAspectRatio: "xMidYMid meet",
      ...l,
      children: e
    }
  );
}
function _d(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M3 19V5" }),
    /* @__PURE__ */ i("path", { d: "m13 6-6 6 6 6" }),
    /* @__PURE__ */ i("path", { d: "M7 12h14" })
  ] });
}
function Od(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M17 12H3" }),
    /* @__PURE__ */ i("path", { d: "m11 18 6-6-6-6" }),
    /* @__PURE__ */ i("path", { d: "M21 5v14" })
  ] });
}
function Hd(e) {
  return /* @__PURE__ */ i(P, { ...e, children: /* @__PURE__ */ i("path", { d: "m9 18 6-6-6-6" }) });
}
function $d(e) {
  return /* @__PURE__ */ i(P, { ...e, children: /* @__PURE__ */ i("path", { d: "m15 18-6-6 6-6" }) });
}
function H0(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }),
    /* @__PURE__ */ i("path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }),
    /* @__PURE__ */ i("path", { d: "M2 15h10" }),
    /* @__PURE__ */ i("path", { d: "m9 18 3-3-3-3" })
  ] });
}
function Ud(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "10", cy: "10", r: "6" }),
    /* @__PURE__ */ i("path", { d: "M14 14L20 20" })
  ] });
}
function Wd(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m13.5 8.5-5 5" }),
    /* @__PURE__ */ i("path", { d: "m8.5 8.5 5 5" }),
    /* @__PURE__ */ i("circle", { cx: "11", cy: "11", r: "8" }),
    /* @__PURE__ */ i("path", { d: "m21 21-4.3-4.3" })
  ] });
}
function Gd(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M11 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5" }),
    /* @__PURE__ */ i("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }),
    /* @__PURE__ */ i("path", { d: "m15 17 5 5" }),
    /* @__PURE__ */ i("path", { d: "m20 17-5 5" })
  ] });
}
function $0(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "10", cy: "8", r: "5" }),
    /* @__PURE__ */ i("path", { d: "M2 21a8 8 0 0 1 10.434-7.62" }),
    /* @__PURE__ */ i("circle", { cx: "18", cy: "18", r: "3" }),
    /* @__PURE__ */ i("path", { d: "m22 22-1.9-1.9" })
  ] });
}
function U0(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m11 17 2 2a1 1 0 1 0 3-3" }),
    /* @__PURE__ */ i("path", { d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" }),
    /* @__PURE__ */ i("path", { d: "m21 3 1 11h-2" }),
    /* @__PURE__ */ i("path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" }),
    /* @__PURE__ */ i("path", { d: "M3 4h8" })
  ] });
}
function W0(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M2 10v3" }),
    /* @__PURE__ */ i("path", { d: "M6 6v11" }),
    /* @__PURE__ */ i("path", { d: "M10 3v18" }),
    /* @__PURE__ */ i("path", { d: "M14 8v7" }),
    /* @__PURE__ */ i("path", { d: "M18 5v13" }),
    /* @__PURE__ */ i("path", { d: "M22 10v3" })
  ] });
}
function G0(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }),
    /* @__PURE__ */ i("path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }),
    /* @__PURE__ */ i("path", { d: "M12 11h4" }),
    /* @__PURE__ */ i("path", { d: "M12 16h4" }),
    /* @__PURE__ */ i("path", { d: "M8 11h.01" }),
    /* @__PURE__ */ i("path", { d: "M8 16h.01" })
  ] });
}
function K0(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { x: "3", y: "5", width: "6", height: "6", rx: "1" }),
    /* @__PURE__ */ i("path", { d: "m3 17 2 2 4-4" }),
    /* @__PURE__ */ i("path", { d: "M13 6h8" }),
    /* @__PURE__ */ i("path", { d: "M13 12h8" }),
    /* @__PURE__ */ i("path", { d: "M13 18h8" })
  ] });
}
function X0(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { width: "20", height: "14", x: "2", y: "5", rx: "2" }),
    /* @__PURE__ */ i("line", { x1: "2", x2: "22", y1: "10", y2: "10" })
  ] });
}
function Y0(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("line", { x1: "12", x2: "12", y1: "2", y2: "22" }),
    /* @__PURE__ */ i("path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" })
  ] });
}
function Z0(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M18 21a8 8 0 0 0-16 0" }),
    /* @__PURE__ */ i("circle", { cx: "10", cy: "8", r: "5" }),
    /* @__PURE__ */ i("path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" })
  ] });
}
function q0(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" }),
    /* @__PURE__ */ i("path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" }),
    /* @__PURE__ */ i("path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" }),
    /* @__PURE__ */ i("path", { d: "M10 6h4" }),
    /* @__PURE__ */ i("path", { d: "M10 10h4" }),
    /* @__PURE__ */ i("path", { d: "M10 14h4" }),
    /* @__PURE__ */ i("path", { d: "M10 18h4" })
  ] });
}
function J0(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" }),
    /* @__PURE__ */ i("path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }),
    /* @__PURE__ */ i("path", { d: "M8 12h8" }),
    /* @__PURE__ */ i("path", { d: "M10 11v2" }),
    /* @__PURE__ */ i("path", { d: "M8 17h8" }),
    /* @__PURE__ */ i("path", { d: "M14 16v2" })
  ] });
}
function Q0(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2" }),
    /* @__PURE__ */ i("path", { d: "M8.5 2h7" }),
    /* @__PURE__ */ i("path", { d: "M7 16h10" })
  ] });
}
function ev(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9" }),
    /* @__PURE__ */ i("path", { d: "M20 3v4" }),
    /* @__PURE__ */ i("path", { d: "M22 5h-4" })
  ] });
}
function tv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "4" }),
    /* @__PURE__ */ i("path", { d: "M12 2v2" }),
    /* @__PURE__ */ i("path", { d: "M12 20v2" }),
    /* @__PURE__ */ i("path", { d: "m4.93 4.93 1.41 1.41" }),
    /* @__PURE__ */ i("path", { d: "m17.66 17.66 1.41 1.41" }),
    /* @__PURE__ */ i("path", { d: "M2 12h2" }),
    /* @__PURE__ */ i("path", { d: "M20 12h2" }),
    /* @__PURE__ */ i("path", { d: "m6.34 17.66-1.41 1.41" }),
    /* @__PURE__ */ i("path", { d: "m19.07 4.93-1.41 1.41" })
  ] });
}
function nv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
    /* @__PURE__ */ i("path", { d: "M9 3v18" }),
    /* @__PURE__ */ i("path", { d: "m16 15-3-3 3-3" })
  ] });
}
function rv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
    /* @__PURE__ */ i("path", { d: "M15 3v18" }),
    /* @__PURE__ */ i("path", { d: "m8 9 3 3-3 3" })
  ] });
}
function iv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("line", { x1: "4", x2: "20", y1: "12", y2: "12" }),
    /* @__PURE__ */ i("line", { x1: "4", x2: "20", y1: "6", y2: "6" }),
    /* @__PURE__ */ i("line", { x1: "4", x2: "20", y1: "18", y2: "18" })
  ] });
}
function sv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
    /* @__PURE__ */ i("polyline", { points: "7 10 12 15 17 10" }),
    /* @__PURE__ */ i("line", { x1: "12", x2: "12", y1: "15", y2: "3" })
  ] });
}
function ov(e) {
  return /* @__PURE__ */ i(P, { strokeWidth: 2, ...e, children: /* @__PURE__ */ i("path", { d: "M5 12h14" }) });
}
function ua(e) {
  return /* @__PURE__ */ i(P, { strokeWidth: 2, ...e, children: /* @__PURE__ */ i("path", { d: "m18 15-6-6-6 6" }) });
}
function li(e) {
  return /* @__PURE__ */ i(P, { strokeWidth: 2, ...e, children: /* @__PURE__ */ i("path", { d: "m15 18-6-6 6-6" }) });
}
function ci(e) {
  return /* @__PURE__ */ i(P, { strokeWidth: 2, ...e, children: /* @__PURE__ */ i("path", { d: "m9 18 6-6-6-6" }) });
}
function _t(e) {
  return /* @__PURE__ */ i(P, { strokeWidth: 2, ...e, children: /* @__PURE__ */ i("path", { d: "m6 9 6 6 6-6" }) });
}
function dt(e) {
  return /* @__PURE__ */ i(P, { strokeWidth: 2, ...e, children: /* @__PURE__ */ i("path", { d: "M20 6 9 17l-5-5" }) });
}
function ha(e) {
  return /* @__PURE__ */ m(P, { strokeWidth: 2, ...e, children: [
    /* @__PURE__ */ i("path", { d: "M18 6 6 18" }),
    /* @__PURE__ */ i("path", { d: "m6 6 12 12" })
  ] });
}
function Kd(e) {
  return /* @__PURE__ */ i(
    P,
    {
      strokeWidth: 0.2,
      className: "transition duration-200 ease-out fill-canvas-inverse group-active:invert",
      width: 17,
      height: 14,
      viewBox: "0 0 17 14",
      ...e,
      children: /* @__PURE__ */ i("path", { d: "M10.7679 13.5L9.63085 12.5702L14.8874 7.70746H0V6.29831H14.8812L9.63085 1.42981L10.7679 0.5L17 6.29254V7.70169L10.7679 13.4942V13.5Z" })
    }
  );
}
function av(e) {
  return /* @__PURE__ */ i(P, { ...e, children: /* @__PURE__ */ i("path", { d: "m15 18-6-6 6-6" }) });
}
function Xd(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" }),
    /* @__PURE__ */ i("path", { d: "M21 3v5h-5" }),
    /* @__PURE__ */ i("path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" }),
    /* @__PURE__ */ i("path", { d: "M8 16H3v5" })
  ] });
}
function lv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" }),
    /* @__PURE__ */ i("path", { d: "M12 8v5" }),
    /* @__PURE__ */ i("path", { d: "M12 17h.01", strokeLinecap: "round", strokeWidth: "2" })
  ] });
}
function cv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" }),
    /* @__PURE__ */ i("path", { d: "M12 8v5" }),
    /* @__PURE__ */ i("path", { d: "M12 17h.01", strokeLinecap: "round", strokeWidth: "2" }),
    /* @__PURE__ */ i("path", { d: "M2 2l20 20", strokeWidth: "2" })
  ] });
}
function Yd(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M3 6h18" }),
    /* @__PURE__ */ i("path", { d: "M7 12h10" }),
    /* @__PURE__ */ i("path", { d: "M10 18h4" })
  ] });
}
function fa(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M18 6 6 18" }),
    /* @__PURE__ */ i("path", { d: "m6 6 12 12" })
  ] });
}
function Zd(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "1" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "5", r: "1" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "19", r: "1" })
  ] });
}
function qd(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m15 15 6 6" }),
    /* @__PURE__ */ i("path", { d: "m15 9 6-6" }),
    /* @__PURE__ */ i("path", { d: "M21 16v5h-5" }),
    /* @__PURE__ */ i("path", { d: "M21 8V3h-5" }),
    /* @__PURE__ */ i("path", { d: "M3 16v5h5" }),
    /* @__PURE__ */ i("path", { d: "m3 21 6-6" }),
    /* @__PURE__ */ i("path", { d: "M3 8V3h5" }),
    /* @__PURE__ */ i("path", { d: "M9 9 3 3" })
  ] });
}
function dv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
    /* @__PURE__ */ i("path", { d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" })
  ] });
}
function Jd(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M5 12h14" }),
    /* @__PURE__ */ i("path", { d: "M12 5v14" })
  ] });
}
function uv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M11.5 15H7a4 4 0 0 0-4 4v2" }),
    /* @__PURE__ */ i("path", { d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" }),
    /* @__PURE__ */ i("circle", { cx: "10", cy: "7", r: "4" })
  ] });
}
function pa(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M3 6h18" }),
    /* @__PURE__ */ i("path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
    /* @__PURE__ */ i("path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" }),
    /* @__PURE__ */ i("line", { x1: "10", x2: "10", y1: "11", y2: "17" }),
    /* @__PURE__ */ i("line", { x1: "14", x2: "14", y1: "11", y2: "17" })
  ] });
}
function Qd(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "7", r: "4" })
  ] });
}
function eu(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
    /* @__PURE__ */ i("circle", { cx: "9", cy: "7", r: "4" }),
    /* @__PURE__ */ i("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }),
    /* @__PURE__ */ i("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
  ] });
}
function hv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72" }),
    /* @__PURE__ */ i("path", { d: "m14 7 3 3" }),
    /* @__PURE__ */ i("path", { d: "M5 6v4" }),
    /* @__PURE__ */ i("path", { d: "M19 14v4" }),
    /* @__PURE__ */ i("path", { d: "M10 2v2" }),
    /* @__PURE__ */ i("path", { d: "M7 8H3" }),
    /* @__PURE__ */ i("path", { d: "M21 16h-4" }),
    /* @__PURE__ */ i("path", { d: "M11 3H9" })
  ] });
}
function tu(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "1" }),
    /* @__PURE__ */ i("circle", { cx: "19", cy: "12", r: "1" }),
    /* @__PURE__ */ i("circle", { cx: "5", cy: "12", r: "1" })
  ] });
}
function fv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0" }),
    /* @__PURE__ */ i("path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0" }),
    /* @__PURE__ */ i("path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7" }),
    /* @__PURE__ */ i("path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8" }),
    /* @__PURE__ */ i("path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69" }),
    /* @__PURE__ */ i("path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8" }),
    /* @__PURE__ */ i("path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69" }),
    /* @__PURE__ */ i("path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7" })
  ] });
}
function pv(e) {
  return /* @__PURE__ */ i(P, { ...e, children: /* @__PURE__ */ i("path", { d: "M128 0C57.308 0 0 57.309 0 128c0 70.696 57.309 128 128 128 70.697 0 128-57.304 128-128C256 57.314 198.697.007 127.998.007l.001-.006Zm58.699 184.614c-2.293 3.76-7.215 4.952-10.975 2.644-30.053-18.357-67.885-22.515-112.44-12.335a7.981 7.981 0 0 1-9.552-6.007 7.968 7.968 0 0 1 6-9.553c48.76-11.14 90.583-6.344 124.323 14.276 3.76 2.308 4.952 7.215 2.644 10.975Zm15.667-34.853c-2.89 4.695-9.034 6.178-13.726 3.289-34.406-21.148-86.853-27.273-127.548-14.92-5.278 1.594-10.852-1.38-12.454-6.649-1.59-5.278 1.386-10.842 6.655-12.446 46.485-14.106 104.275-7.273 143.787 17.007 4.692 2.89 6.175 9.034 3.286 13.72v-.001Zm1.345-36.293C162.457 88.964 94.394 86.71 55.007 98.666c-6.325 1.918-13.014-1.653-14.93-7.978-1.917-6.328 1.65-13.012 7.98-14.935C93.27 62.027 168.434 64.68 215.929 92.876c5.702 3.376 7.566 10.724 4.188 16.405-3.362 5.69-10.73 7.565-16.4 4.187h-.006Z" }) });
}
function mv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M21 6H3" }),
    /* @__PURE__ */ i("path", { d: "M7 12H3" }),
    /* @__PURE__ */ i("path", { d: "M7 18H3" }),
    /* @__PURE__ */ i("path", { d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14" }),
    /* @__PURE__ */ i("path", { d: "M11 10v4h4" })
  ] });
}
function nu(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" }),
    /* @__PURE__ */ i("path", { d: "M12 9v4" }),
    /* @__PURE__ */ i("path", { d: "M12 17h.01" })
  ] });
}
function ru(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "10" }),
    /* @__PURE__ */ i("path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }),
    /* @__PURE__ */ i("path", { d: "M12 17h.01", strokeLinecap: "round", strokeWidth: "2" })
  ] });
}
function gv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "3" })
  ] });
}
function yv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i(
      "path",
      {
        d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ i(
      "path",
      {
        d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ] });
}
function vv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i(
      "rect",
      {
        width: "20",
        height: "5",
        x: "2",
        y: "3",
        rx: "1",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
      }
    ),
    /* @__PURE__ */ i(
      "path",
      {
        d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ i(
      "path",
      {
        d: "M10 12h4",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ] });
}
function bv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m11 19-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V12" }),
    /* @__PURE__ */ i("path", { d: "M15 5.764V12" }),
    /* @__PURE__ */ i("path", { d: "M18 15v6" }),
    /* @__PURE__ */ i("path", { d: "M21 18h-6" }),
    /* @__PURE__ */ i("path", { d: "M9 3.236v15" })
  ] });
}
function xv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "10", r: "3" }),
    /* @__PURE__ */ i("path", { d: "M16 18h6" }),
    /* @__PURE__ */ i("path", { d: "M19 15v6" })
  ] });
}
function wv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M18.977 14C19.6 12.701 20 11.343 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "10", r: "3" }),
    /* @__PURE__ */ i("path", { d: "M16 18h6" })
  ] });
}
function kv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m11 19-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V14" }),
    /* @__PURE__ */ i("path", { d: "M15 5.764V14" }),
    /* @__PURE__ */ i("path", { d: "M21 18h-6" }),
    /* @__PURE__ */ i("path", { d: "M9 3.236v15" })
  ] });
}
function Sv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { x: "3", y: "4", width: "18", height: "11", rx: "2", ry: "2" }),
    /* @__PURE__ */ i("line", { x1: "12", y1: "19", x2: "12", y2: "15" }),
    /* @__PURE__ */ i("line", { x1: "8", y1: "21", x2: "16", y2: "21" }),
    /* @__PURE__ */ i("path", { d: "M7 16 L15 8" }),
    /* @__PURE__ */ i("path", { d: "M15 8 L13 8" }),
    /* @__PURE__ */ i("path", { d: "M15 8 L15 10" })
  ] });
}
function Nv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }),
    /* @__PURE__ */ i("path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" }),
    /* @__PURE__ */ i("path", { d: "M16 4h2a2 2 0 0 1 2 2v4" }),
    /* @__PURE__ */ i("path", { d: "M21 14H11" }),
    /* @__PURE__ */ i("path", { d: "m15 10-4 4 4 4" })
  ] });
}
function Tv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "16", r: "1" }),
    /* @__PURE__ */ i("rect", { x: "3", y: "10", width: "18", height: "12", rx: "2" }),
    /* @__PURE__ */ i("path", { d: "M7 10V7a5 5 0 0 1 10 0v3" })
  ] });
}
function Cv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m16 17 5-5-5-5" }),
    /* @__PURE__ */ i("path", { d: "M21 12H9" }),
    /* @__PURE__ */ i("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" })
  ] });
}
function Mv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M10 5H3" }),
    /* @__PURE__ */ i("path", { d: "M12 19H3" }),
    /* @__PURE__ */ i("path", { d: "M14 3v4" }),
    /* @__PURE__ */ i("path", { d: "M16 17v4" }),
    /* @__PURE__ */ i("path", { d: "M21 12h-9" }),
    /* @__PURE__ */ i("path", { d: "M21 19h-5" }),
    /* @__PURE__ */ i("path", { d: "M21 5h-7" }),
    /* @__PURE__ */ i("path", { d: "M8 10v4" }),
    /* @__PURE__ */ i("path", { d: "M8 12H3" })
  ] });
}
function Pv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "16", r: "1" }),
    /* @__PURE__ */ i("rect", { width: "18", height: "12", x: "3", y: "10", rx: "2" }),
    /* @__PURE__ */ i("path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5" })
  ] });
}
function Dv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "10" }),
    /* @__PURE__ */ i("polyline", { points: "12 6 12 12 16 14" })
  ] });
}
function Iv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M21.801 10A10 10 0 1 1 17 3.335" }),
    /* @__PURE__ */ i("path", { d: "m9 11 3 3L22 4" })
  ] });
}
function iu(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "10" }),
    /* @__PURE__ */ i("path", { d: "M12 8v4", strokeLinecap: "round" }),
    /* @__PURE__ */ i("path", { d: "M12 16h.01", strokeLinecap: "round", strokeWidth: "2" })
  ] });
}
function su(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
    /* @__PURE__ */ i("polyline", { points: "17 8 12 3 7 8" }),
    /* @__PURE__ */ i("line", { x1: "12", x2: "12", y1: "3", y2: "15" })
  ] });
}
function Ns(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" }),
    /* @__PURE__ */ i("path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }),
    /* @__PURE__ */ i("path", { d: "M10 9H8" }),
    /* @__PURE__ */ i("path", { d: "M16 13H8" }),
    /* @__PURE__ */ i("path", { d: "M16 17H8" })
  ] });
}
function Av(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" }),
    /* @__PURE__ */ i("path", { d: "m21.854 2.147-10.94 10.939" })
  ] });
}
function Ev(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" }),
    /* @__PURE__ */ i("path", { d: "M21 3v5h-5" }),
    /* @__PURE__ */ i("path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" }),
    /* @__PURE__ */ i("path", { d: "M8 16H3v5" })
  ] });
}
function Vv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47" }),
    /* @__PURE__ */ i("path", { d: "M8 16H3v5" }),
    /* @__PURE__ */ i("path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64" }),
    /* @__PURE__ */ i("path", { d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64" }),
    /* @__PURE__ */ i("path", { d: "M21 12c0 1-.16 1.97-.47 2.87" }),
    /* @__PURE__ */ i("path", { d: "M21 3v5h-5" }),
    /* @__PURE__ */ i("path", { d: "M22 22 2 2" })
  ] });
}
function Lv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "10" }),
    /* @__PURE__ */ i("path", { d: "M4.929 4.929 19.07 19.071" })
  ] });
}
function Rv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" }),
    /* @__PURE__ */ i("path", { d: "M13 5v2" }),
    /* @__PURE__ */ i("path", { d: "M13 17v2" }),
    /* @__PURE__ */ i("path", { d: "M13 11v2" })
  ] });
}
function ou(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }),
    /* @__PURE__ */ i("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })
  ] });
}
function zv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M8 3 4 7l4 4" }),
    /* @__PURE__ */ i("path", { d: "M4 7h16" }),
    /* @__PURE__ */ i("path", { d: "m16 21 4-4-4-4" }),
    /* @__PURE__ */ i("path", { d: "M20 17H4" })
  ] });
}
function Bv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "3" })
  ] });
}
function jv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" }),
    /* @__PURE__ */ i("path", { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" }),
    /* @__PURE__ */ i("path", { d: "M7 3v4a1 1 0 0 0 1 1h7" })
  ] });
}
function Fv(e) {
  return /* @__PURE__ */ m(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "18", cy: "18", r: "3" }),
    /* @__PURE__ */ i("circle", { cx: "6", cy: "6", r: "3" }),
    /* @__PURE__ */ i("path", { d: "M6 21V9a9 9 0 0 0 9 9" })
  ] });
}
function _v({ ...e }) {
  return /* @__PURE__ */ i("nav", { "aria-label": "breadcrumb", ...e });
}
function Ov({ className: e, ...t }) {
  return /* @__PURE__ */ i(
    "ol",
    {
      "data-slot": "breadcrumb-list",
      className: g(
        "text-ink-secondary flex flex-wrap items-center gap-1.5 text-sm wrap-break-word sm:gap-2.5 font-sentric-alt",
        e
      ),
      ...t
    }
  );
}
function Hv({ className: e, ...t }) {
  return /* @__PURE__ */ i(
    "li",
    {
      "data-slot": "breadcrumb-item",
      className: g("inline-flex items-center gap-1.5", e),
      ...t
    }
  );
}
function $v({
  asChild: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ i(
    e ? tn : "a",
    {
      "data-slot": "breadcrumb-link",
      className: g("text-ink-secondary hover:text-ink-primary transition-colors font-sentric-alt", t),
      ...n
    }
  );
}
function Uv({ className: e, ...t }) {
  return /* @__PURE__ */ i(
    "span",
    {
      "data-slot": "breadcrumb-page",
      role: "link",
      "aria-disabled": "true",
      "aria-current": "page",
      className: g("text-ink-primary font-normal font-sentric-alt", e),
      ...t
    }
  );
}
function Wv({
  children: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ i(
    "li",
    {
      "data-slot": "breadcrumb-separator",
      role: "presentation",
      "aria-hidden": "true",
      className: g("text-ink-secondary", t),
      ...n,
      children: e ?? /* @__PURE__ */ i(ci, { className: "w-3.5 h-3.5 stroke-ink-secondary" })
    }
  );
}
function Gv({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ m(
    "span",
    {
      "data-slot": "breadcrumb-ellipsis",
      role: "presentation",
      "aria-hidden": "true",
      className: g("flex w-9 h-9 items-center justify-center text-ink-secondary", e),
      ...t,
      children: [
        /* @__PURE__ */ i(tu, { size: "md", className: "stroke-ink-secondary" }),
        /* @__PURE__ */ i("span", { className: "sr-only", children: "More" })
      ]
    }
  );
}
const Gt = Ct.Provider, Kt = Ct.Root, Xt = Ct.Trigger, Mt = T.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => {
  const s = H((a) => a.isTunecore);
  return (
    // Portal to document.body so the tooltip escapes ancestor overflow-hidden/
    // overflow-auto containers (e.g. Table's ScrollArea and resizable-column
    // <td> cells) and stacking contexts (e.g. the sticky table header) instead
    // of being clipped or rendered behind them — a local z-index can't fix
    // that since it only wins within its nearest containing stacking context.
    /* @__PURE__ */ i(Ct.Portal, { children: /* @__PURE__ */ i(
      Ct.Content,
      {
        ref: r,
        sideOffset: t,
        className: g(
          "z-50 overflow-hidden rounded-md border px-3 py-1.5 text-sm text-md shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          "bg-layer-default text-ink-primary border-stroke-subtle",
          s ? "font-tunecore" : "font-sentric-alt",
          e
        ),
        ...n
      }
    ) })
  );
});
Mt.displayName = Ct.Content.displayName;
function au(e) {
  const t = g("text-ink-primary", e && "font-tunecore"), n = g(
    t,
    e ? "text-sm font-normal leading-normal" : "text-size-body-sm font-normal leading-[1.6] font-sentric-alt"
  );
  return {
    p: g(
      t,
      e ? "text-[0.875rem] font-normal" : "text-base font-normal leading-[1.6] font-sentric-alt"
    ),
    pMainFont: g(t, "text-base font-normal leading-normal font-sentric"),
    semibold: g(t, "font-semibold text-base leading-6 font-sentric-alt"),
    subtitle: g(
      t,
      e ? "font-bold uppercase tracking-[0.06rem]" : "font-sentric text-base font-bold leading-7 uppercase"
    ),
    // Sentric Design System v1.0 (June 2026) additions — values confirmed
    // against live Figma text styles. Tunecore fallbacks below are rough
    // placeholders (tunecore typography is a separate, out-of-scope spec);
    // revisit if/when these variants get used on a tunecore surface.
    bodyLg: g(
      t,
      e ? "text-lg font-normal" : "text-size-body-lg font-normal leading-[1.65] font-sentric-alt"
    ),
    bodySm: n,
    // @deprecated Use `bodySm` instead — kept as an alias (same styling,
    // same rendered <small> tag) for backward compatibility with existing
    // consumers of @sentricmusic/ui outside this monorepo. Not removed
    // because at least one (sentric-sandbox) has 600+ call sites still on
    // `small`, on a pinned version that predates `bodySm`'s existence —
    // removing this would silently drop their typography styling entirely
    // (Text falls back to no className) the next time they upgrade.
    small: n,
    caption: g(
      t,
      e ? "text-xs font-normal" : "text-size-caption font-normal leading-[1.5] tracking-[0.01em] font-sentric-alt"
    ),
    label: g(
      t,
      e ? "text-xs font-medium" : "text-size-label font-medium leading-[1.4] tracking-[0.01em] font-sentric-alt"
    ),
    sectionLabel: g(
      t,
      e ? "text-[10px] font-semibold uppercase tracking-[0.12em]" : "text-size-section-label font-semibold uppercase leading-[1.4] tracking-[0.12em] font-sentric"
    )
  };
}
function di(e, t) {
  return au((t == null ? void 0 : t.isTunecore) ?? !1)[e];
}
const B = Y.forwardRef(({
  children: e,
  as: t = "p",
  className: n = "",
  ...r
}, s) => {
  const a = H((l) => l.isTunecore), o = {
    subtitle: "h2",
    p: "p",
    pMainFont: "p",
    semibold: "p",
    bodyLg: "p",
    bodySm: "span",
    small: "small",
    caption: "span",
    label: "span",
    sectionLabel: "span"
  }[t];
  return /* @__PURE__ */ i(
    o,
    {
      ref: s,
      className: g(di(t, { isTunecore: a }), n),
      ...r,
      children: e
    }
  );
});
B.displayName = "Text";
const lu = /* @__PURE__ */ new Set([
  "tunecorePrimary",
  "tunecoreSecondary",
  "tunecoreDropdown",
  "tunecoreDropdownDelete"
]), gn = ["primary", "secondary", "tertiary", "destructive"], Ir = Be(
  "group inline-flex items-center w-auto cursor-pointer font-sentric-alt whitespace-nowrap rounded-sm text-sm font-medium ring-offset-background transition ease-out duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-25 uppercase py-2 px-5",
  {
    variants: {
      variant: {
        primary: "justify-center border stroke-current bg-action-primary border-action-primary text-ink-on-accent shadow-small-grey hover:bg-action-primary-hover hover:border-action-primary-hover hover:shadow-md-grey active:bg-action-primary-pressed active:border-action-primary-pressed active:text-ink-inverse active:shadow-none disabled:bg-layer-disabled disabled:border-stroke-disabled disabled:text-ink-disabled disabled:shadow-none disabled:opacity-100",
        secondary: "justify-center border stroke-current bg-layer-default border-stroke-heavy text-ink-primary shadow-small-grey hover:bg-canvas-secondary hover:shadow-md-grey active:bg-stroke-subtle active:shadow-none disabled:bg-layer-disabled disabled:border-stroke-disabled disabled:text-ink-disabled disabled:shadow-none disabled:opacity-100",
        tertiary: "justify-center border-0 stroke-current bg-transparent text-ink-primary underline hover:text-action-primary-hover active:text-action-primary-pressed disabled:text-ink-disabled disabled:opacity-100",
        destructive: "justify-center border stroke-current bg-action-destructive border-action-destructive text-ink-inverse shadow-small-grey hover:bg-action-destructive-hover hover:border-action-destructive-hover hover:shadow-md-grey active:bg-action-destructive-pressed active:border-action-destructive-pressed active:shadow-none disabled:bg-layer-disabled disabled:border-stroke-disabled disabled:text-ink-disabled disabled:shadow-none disabled:opacity-100",
        tunecoreDestructive: "justify-center bg-action-destructive text-white hover:bg-action-destructive-hover active:bg-action-destructive-pressed",
        iconAction: "justify-center items-center gap-1 size-8 shrink-0 py-0 px-2 rounded-sm border border-stroke-heavy bg-layer-default text-ink-primary normal-case shadow-small-grey hover:bg-layer-raised active:bg-layer-disabled",
        darkSecondary: "justify-center bg-[var(--primitive-grey-800)] text-ink-disabled hover:bg-dark-secondary-hover active:bg-dark-secondary-active dark:hover:bg-action-primary",
        link: "text-ink-primary hover:text-ink-accent active:text-ink-accent p-0 stroke-canvas-inverse hover:stroke-action-primary active:stroke-action-primary disabled:text-ink-disabled",
        linkBack: "text-ink-primary hover:text-ink-accent active:text-ink-accent p-0 -ml-1 stroke-canvas-inverse hover:stroke-action-primary active:stroke-action-primary disabled:text-ink-disabled",
        dropdown: "justify-start text-ink-primary hover:bg-layer-raised border-0 normal-case rounded-sm p-2",
        dropdownDelete: "justify-start text-ink-error hover:bg-layer-raised border-0 normal-case rounded-sm p-2 w-full",
        dropdownGreen: "justify-start text-ink-success hover:bg-layer-raised border-0 normal-case rounded-sm p-2 w-full",
        tunecoreDropdown: "justify-start text-white hover:bg-layer-raised hover:text-white border-0 normal-case rounded-sm p-2",
        tunecoreDropdownDelete: "justify-start text-action-destructive hover:bg-layer-raised hover:text-action-destructive border-0 normal-case rounded-sm p-2",
        tunecoreLink: "group text-white hover:text-ink-accent active:text-ink-accent p-0 stroke-white hover:stroke-action-primary active:stroke-action-primary disabled:text-ink-secondary",
        outline: "ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
        tunecoreOutline: "ring-1 hover:ring-2 ring-stroke-subtle hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
        ghost: "hover:bg-layer-raised hover:text-ink-primary",
        tunecorePrimary: "px-5 py-2.5 text-white font-bold rounded-full uppercase tracking-wider hover:brightness-110 transition-all duration-150",
        tunecoreSecondary: "justify-center bg-transparent px-5 py-2.5 ring-2 ring-white text-white rounded-full hover:ring-stroke-primary active:ring-stroke-primary font-bold text-[13px] leading-[100%] tracking-[1px] uppercase "
      },
      size: {
        lg: "",
        sm: "",
        "icon-lg": "",
        "icon-sm": ""
      }
    },
    compoundVariants: [
      ...gn.map((e) => ({ variant: e, size: "lg", className: "h-10 text-size-body-sm font-normal" })),
      ...gn.map((e) => ({ variant: e, size: "sm", className: "h-8 text-size-label font-medium tracking-[0.12px]" })),
      ...gn.map((e) => ({ variant: e, size: "icon-lg", className: "size-10 shrink-0 p-0 text-size-body-sm font-normal" })),
      ...gn.map((e) => ({ variant: e, size: "icon-sm", className: "size-8 shrink-0 p-0 text-size-label font-medium" }))
    ],
    defaultVariants: {
      variant: "primary",
      size: "lg"
    }
  }
), O = T.forwardRef(
  ({
    className: e,
    tooltipText: t,
    tooltip: n,
    label: r,
    icon: s,
    iconPosition: a,
    variant: o = "primary",
    size: l,
    disabled: c,
    ...d
  }, u) => {
    const h = H((S) => S.isTunecore), f = o === "linkBack" ? "left" : a ?? "right", y = h ? o === "primary" ? "tunecoreSecondary" : o === "secondary" ? "tunecorePrimary" : o === "destructive" ? "tunecoreDestructive" : o === "tertiary" || o === "link" ? "tunecoreLink" : o === "outline" ? "tunecoreOutline" : o === "dropdown" ? "tunecoreDropdown" : o === "dropdownDelete" ? "tunecoreDropdownDelete" : o : o, p = lu.has(y ?? ""), v = g(
      Ir({ variant: y, size: l }),
      h && !p && "rounded-lg",
      e
    ), b = () => /* @__PURE__ */ m(re, { children: [
      s != null && f === "left" && /* @__PURE__ */ i("span", { className: g(r != null && "mr-2"), children: s }),
      y === "tunecorePrimary" ? /* @__PURE__ */ i("p", { children: r }) : r,
      s != null && f === "right" && /* @__PURE__ */ i("span", { className: g(r != null && "ml-2"), children: s })
    ] });
    if (y === "tunecorePrimary") {
      const N = /* @__PURE__ */ i(
        n ? Xt : "button",
        {
          ref: n ? void 0 : u,
          type: "button",
          className: v,
          style: {
            background: c ? "linear-gradient(to bottom right, rgba(0, 239, 134, 0.5), rgba(0, 142, 185, 0.5))" : "linear-gradient(to bottom right, #00ef86, #008eb9)",
            borderRadius: "50px",
            padding: "12px 20px"
          },
          disabled: c,
          ...d,
          children: /* @__PURE__ */ i("div", { className: "flex items-center", children: b() })
        }
      );
      return n ? /* @__PURE__ */ i(Gt, { children: /* @__PURE__ */ m(Kt, { delayDuration: 200, children: [
        N,
        /* @__PURE__ */ i(Mt, { children: /* @__PURE__ */ i(B, { className: "max-w-72", children: t }) })
      ] }) }) : N;
    }
    const w = /* @__PURE__ */ i(
      n ? Xt : "button",
      {
        ref: n ? void 0 : u,
        type: "button",
        className: v,
        disabled: c,
        ...d,
        children: b()
      }
    );
    return n ? /* @__PURE__ */ i(Gt, { children: /* @__PURE__ */ m(Kt, { delayDuration: 200, children: [
      w,
      /* @__PURE__ */ i(Mt, { children: /* @__PURE__ */ i(B, { className: "max-w-72", children: t }) })
    ] }) }) : w;
  }
);
O.displayName = "Button";
const cu = T.forwardRef(
  ({ label: e = "Confirm", ...t }, n) => /* @__PURE__ */ i(
    O,
    {
      ref: n,
      variant: "primary",
      icon: /* @__PURE__ */ i(dt, { size: "md" }),
      iconPosition: "right",
      label: e,
      ...t
    }
  )
), du = T.forwardRef(
  ({ label: e = "Cancel", ...t }, n) => /* @__PURE__ */ i(
    O,
    {
      ref: n,
      variant: "darkSecondary",
      icon: /* @__PURE__ */ i(ha, { size: "md" }),
      iconPosition: "right",
      label: e,
      ...t
    }
  )
), uu = T.forwardRef(
  ({ label: e = "Next", ...t }, n) => /* @__PURE__ */ i(
    O,
    {
      ref: n,
      variant: "primary",
      icon: /* @__PURE__ */ i(Kd, { size: "md" }),
      iconPosition: "right",
      label: e,
      ...t
    }
  )
), hu = T.forwardRef(
  ({ label: e = "Previous", ...t }, n) => /* @__PURE__ */ i(
    O,
    {
      ref: n,
      variant: "secondary",
      icon: /* @__PURE__ */ i(li, { size: "md" }),
      iconPosition: "left",
      label: e,
      ...t
    }
  )
), fu = T.forwardRef(
  ({ label: e = "Save", ...t }, n) => /* @__PURE__ */ i(
    O,
    {
      ref: n,
      variant: "primary",
      icon: /* @__PURE__ */ i(dt, { size: "md" }),
      iconPosition: "right",
      label: e,
      ...t
    }
  )
), pu = T.forwardRef(
  ({ label: e = "Delete", ...t }, n) => /* @__PURE__ */ i(
    O,
    {
      ref: n,
      variant: "darkSecondary",
      icon: /* @__PURE__ */ i(pa, { size: "md" }),
      iconPosition: "right",
      label: e,
      ...t
    }
  )
);
cu.displayName = "ConfirmButton";
du.displayName = "CancelButton";
uu.displayName = "NextButton";
hu.displayName = "PreviousButton";
fu.displayName = "SaveButton";
pu.displayName = "DeleteButton";
const ma = T.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, variant: r = "solid", ...s }, a) => /* @__PURE__ */ i(
    oa.Root,
    {
      ref: a,
      decorative: n,
      orientation: t,
      className: g(
        "shrink-0",
        t === "horizontal" ? "h-px w-full" : "h-full w-px",
        r === "solid" && "bg-stroke-subtle",
        r === "dashed" && t === "horizontal" && "border-t border-dashed border-stroke-subtle",
        r === "dashed" && t === "vertical" && "border-l border-dashed border-stroke-subtle",
        e
      ),
      ...s
    }
  )
);
ma.displayName = oa.Root.displayName;
const mu = Be(
  "flex w-full items-stretch *:focus-visible:z-10 *:focus-visible:relative [&>[data-slot=select-trigger]:not([class*='w-'])]:w-fit [&>input]:flex-1 has-[select[aria-hidden=true]:last-child]:[&>[data-slot=select-trigger]:last-of-type]:rounded-r-md has-[>[data-slot=button-group]]:gap-2",
  {
    variants: {
      orientation: {
        horizontal: "[&>*:not(:first-child)]:rounded-l-none [&>*:not(:first-child)]:border-l-0 [&>*:not(:last-child)]:rounded-r-none",
        vertical: "flex-col"
      }
    },
    defaultVariants: {
      orientation: "horizontal"
    }
  }
);
function Kv({
  className: e,
  orientation: t,
  ...n
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      role: "group",
      "data-slot": "button-group",
      "data-orientation": t,
      className: g(mu({ orientation: t }), e),
      ...n
    }
  );
}
function Xv({
  className: e,
  asChild: t = !1,
  ...n
}) {
  return /* @__PURE__ */ i(
    t ? tn : "div",
    {
      className: g(
        "bg-muted flex items-center gap-2 rounded-md border px-4 text-sm font-medium shadow-xs [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n
    }
  );
}
function Yv({
  className: e,
  orientation: t = "horizontal",
  ...n
}) {
  return /* @__PURE__ */ i(
    ma,
    {
      "data-slot": "button-group-separator",
      orientation: t,
      className: g(
        "-mx-1 my-1 w-[calc(100%+0.5rem)]! bg-layer-raised",
        e
      ),
      ...n
    }
  );
}
const gu = () => /* @__PURE__ */ i(nd, { className: "w-4 h-4" }), yu = () => /* @__PURE__ */ i(ea, { className: "w-4 h-4" }), vu = () => /* @__PURE__ */ i("span", { className: "text-lg text-ink-primary", children: "▼" });
function Ot({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  captionLayout: r,
  ...s
}) {
  const a = H((o) => o.isTunecore);
  return /* @__PURE__ */ i(
    fd,
    {
      weekStartsOn: 1,
      showOutsideDays: n,
      captionLayout: r,
      fromYear: 1900,
      toYear: 2030,
      className: g(
        "p-3",
        a ? "font-tunecore" : "font-sentric",
        "text-ink-primary",
        e
      ),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: r === "dropdown" || r === "dropdown-buttons" ? "sr-only" : `text-sm mt-[2px] text-ink-primary ${a ? "font-tunecore" : "font-sentric"}`,
        vhidden: "sr-only",
        caption_dropdowns: "flex justify-center gap-2 px-10",
        dropdown: `text-sm appearance-none cursor-pointer focus:outline-none relative bg-no-repeat bg-right bg-size-[16px] border-none rounded px-2 py-1 pr-6 ${a ? "font-tunecore bg-layer-raised text-white bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23ffffff%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpath%20d%3D%22m6%209%206%206%206-6%22/%3E%3C/svg%3E')]" : "font-sentric bg-transparent text-ink-primary bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23374151%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpath%20d%3D%22m6%209%206%206%206-6%22/%3E%3C/svg%3E')] dark:bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23faf8f5%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpath%20d%3D%22m6%209%206%206%206-6%22/%3E%3C/svg%3E')]"}`,
        nav: "space-x-1 flex items-center",
        nav_button: g(
          Ir({ variant: "outline" }),
          "px-2 py-1 rounded-md",
          a ? "bg-layer-raised text-white border-layer-raised hover:bg-action-primary hover:border-action-primary" : "bg-transparent text-ink-primary"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "rounded-md w-9 font-normal text-[0.8rem] text-ink-secondary",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-sm p-0 relative flex justify-center items-center",
        day: g(
          Ir({ variant: "ghost" }),
          "h-9 w-9 p-0 flex justify-center items-center aria-selected:opacity-100",
          a ? "text-white hover:bg-action-primary hover:text-black" : "hover:bg-layer-raised"
        ),
        day_range_end: "bg-action-primary text-black",
        day_selected: "bg-action-primary text-black! hover:bg-action-primary focus:bg-action-primary hover:text-black! focus:text-black!",
        day_today: a ? "bg-layer-raised aria-selected:bg-layer-raised aria-selected:text-white! text-white!" : "bg-action-secondary aria-selected:bg-action-secondary aria-selected:text-black! text-black!",
        day_outside: a ? "text-white/50 aria-selected:text-white aria-selected:opacity-30" : "text-ink-secondary opacity-50 aria-selected:text-black/40 aria-selected:opacity-30",
        day_disabled: "text-ink-disabled opacity-50",
        day_range_middle: a ? "aria-selected:bg-action-primary/45 aria-selected:text-white" : "aria-selected:bg-action-primary/45 aria-selected:text-black",
        day_hidden: "invisible",
        ...t
      },
      components: {
        IconLeft: gu,
        IconRight: yu,
        IconDropdown: vu
      },
      ...s
    }
  );
}
Ot.displayName = "Calendar";
const bu = Be(
  "inline-flex h-[17px] w-fit shrink-0 items-center overflow-hidden whitespace-nowrap rounded-sm border px-[7px]",
  {
    variants: {
      variant: {
        error: "border-stroke-error bg-layer-error text-ink-error",
        warning: "border-stroke-warning bg-layer-warning text-ink-warning",
        success: "border-stroke-success bg-layer-success text-ink-success",
        teal: "border-tag-teal-stroke bg-tag-teal-bg text-tag-teal-text",
        sand: "border-tag-sand-stroke bg-tag-sand-bg text-tag-sand-text",
        purple: "border-tag-purple-stroke bg-tag-purple-bg text-tag-purple-text",
        grey: "border-tag-grey-stroke bg-tag-grey-bg text-tag-grey-text",
        blue: "border-tag-blue-stroke bg-tag-blue-bg text-tag-blue-text",
        magenta: "border-tag-magenta-stroke bg-tag-magenta-bg text-tag-magenta-text"
      }
    },
    defaultVariants: {
      variant: "sand"
    }
  }
);
function Ar({
  className: e,
  variant: t,
  asChild: n = !1,
  ...r
}) {
  const s = H((o) => o.isTunecore);
  return /* @__PURE__ */ i(
    n ? tn : "span",
    {
      "data-slot": "chip",
      className: g(di("label", { isTunecore: s }), bu({ variant: t }), e),
      ...r
    }
  );
}
const Zv = We.Root, xu = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  We.List,
  {
    ref: n,
    className: g(
      "inline-flex w-full gap-1 items-center font-sentric-alt justify-evenly rounded-lg p-1 bg-layer-default border border-stroke-subtle text-ink-primary",
      e
    ),
    ...t
  }
));
xu.displayName = We.List.displayName;
const wu = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  We.Trigger,
  {
    ref: n,
    className: g(
      "inline-flex w-full items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm ring-offset-layer-raised transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      "hover:bg-layer-raised data-[state=active]:bg-layer-raised data-[state=active]:text-ink-primary data-[state=active]:shadow-sm",
      e
    ),
    ...t
  }
));
wu.displayName = We.Trigger.displayName;
const ga = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  We.Content,
  {
    ref: n,
    className: g(
      "ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
ga.displayName = We.Content.displayName;
const ku = {
  surface: "bg-layer-default border-stroke-subtle data-[state=active]:bg-layer-accent data-[state=active]:border-stroke-primary",
  count: "text-ink-primary group-data-[state=active]:text-ink-accent",
  radio: "group-data-[state=active]:border-ink-accent group-data-[state=active]:bg-action-primary"
}, Su = {
  success: {
    surface: "bg-layer-success border-stroke-success",
    count: "text-ink-success",
    radio: "group-data-[state=active]:border-ink-success group-data-[state=active]:bg-ink-success"
  }
};
function Nu({
  value: e,
  label: t,
  description: n,
  count: r,
  status: s
}) {
  const a = H((l) => l.isTunecore), o = s ? Su[s.tone] : ku;
  return /* @__PURE__ */ m(
    We.Trigger,
    {
      value: e,
      className: g(
        "group flex w-full cursor-pointer items-center gap-2 rounded-sm border p-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-action-primary/50",
        "transition-[background-color,border-color,padding,transform] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] motion-safe:active:scale-[0.98] motion-reduce:transition-[background-color,border-color]",
        o.surface,
        s && "py-2 data-[state=active]:py-4"
      ),
      children: [
        /* @__PURE__ */ m("span", { className: "flex min-w-0 flex-1 items-start gap-2", children: [
          /* @__PURE__ */ i("span", { className: "flex h-[1.6rem] shrink-0 items-center", children: /* @__PURE__ */ i(
            "span",
            {
              className: g(
                "flex size-4 items-center justify-center rounded-full border border-ink-primary text-ink-inverse",
                "transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)]",
                o.radio
              ),
              children: /* @__PURE__ */ i(
                "svg",
                {
                  className: g(
                    "size-3 scale-90 opacity-0 group-data-[state=active]:scale-100 group-data-[state=active]:opacity-100",
                    "transition-[opacity,transform] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] motion-reduce:transition-opacity"
                  ),
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  "aria-hidden": "true",
                  children: /* @__PURE__ */ i(
                    "path",
                    {
                      d: "M10 3L4.5 8.5L2 6",
                      stroke: "currentColor",
                      strokeWidth: "1.16667",
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    }
                  )
                }
              )
            }
          ) }),
          /* @__PURE__ */ m("span", { className: "flex min-w-0 flex-1 flex-col", children: [
            /* @__PURE__ */ i("span", { className: g(di("p", { isTunecore: a }), "min-w-0 wrap-break-word"), children: t }),
            !!n && /* @__PURE__ */ i(
              "span",
              {
                className: g(
                  "invisible grid grid-rows-[0fr] opacity-0 group-data-[state=active]:visible group-data-[state=active]:grid-rows-[1fr] group-data-[state=active]:opacity-100",
                  "transition-[grid-template-rows,opacity,visibility] duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] motion-reduce:transition-[opacity,visibility]"
                ),
                children: /* @__PURE__ */ i(B, { as: "label", className: "-mt-0.75 min-h-0 overflow-hidden text-ink-secondary", children: n })
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ m("span", { className: "flex shrink-0 flex-col items-end justify-center gap-2", children: [
          s && /* @__PURE__ */ i(Ar, { variant: s.tone, children: s.label }),
          /* @__PURE__ */ i("span", { className: g(ai("h4", { isTunecore: a }), "transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)]", o.count), children: r })
        ] })
      ]
    }
  );
}
function qv({
  items: e,
  value: t,
  defaultValue: n,
  onValueChange: r,
  renderPanel: s,
  ariaLabel: a,
  className: o
}) {
  const l = e.filter((c) => c.count > 0);
  return /* @__PURE__ */ m(
    We.Root,
    {
      value: t,
      defaultValue: n,
      onValueChange: r,
      orientation: "vertical",
      className: g("flex items-start gap-6", o),
      children: [
        /* @__PURE__ */ i(
          We.List,
          {
            "aria-label": a,
            className: "flex min-w-84 flex-1 flex-col gap-4",
            children: l.map((c) => /* @__PURE__ */ i(Nu, { ...c }, c.value))
          }
        ),
        l.map((c) => /* @__PURE__ */ i(ga, { value: c.value, className: "mt-0 min-w-0 flex-[2]", children: s(c) }, c.value))
      ]
    }
  );
}
const Tu = { light: "", dark: ".dark" }, ya = T.createContext(null);
function va() {
  const e = T.useContext(ya);
  if (!e)
    throw new Error("useChart must be used within a <ChartContainer />");
  return e;
}
const Cu = T.forwardRef(({ id: e, className: t, children: n, config: r, ...s }, a) => {
  const o = T.useId(), l = `chart-${e || o.replace(/:/g, "")}`, c = T.useMemo(() => ({ config: r }), [r]);
  return /* @__PURE__ */ i(ya.Provider, { value: c, children: /* @__PURE__ */ m(
    "div",
    {
      "data-chart": l,
      ref: a,
      className: g(
        // --- ADD position: relative and z-index: 1 (or similar low value) ---
        "relative z-1",
        // --- End Addition ---
        "flex aspect-video justify-center text-xs [&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none",
        t
      ),
      ...s,
      children: [
        /* @__PURE__ */ i(Mu, { id: l, config: r }),
        /* @__PURE__ */ i(oi.ResponsiveContainer, { children: n })
      ]
    }
  ) });
});
Cu.displayName = "Chart";
function Mu({ id: e, config: t }) {
  const n = Object.entries(t).filter(
    ([r, s]) => s.theme || s.color
  );
  return n.length ? /* @__PURE__ */ i(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(Tu).map(
          ([r, s]) => `
${s} [data-chart=${e}] {
${n.map(([a, o]) => {
            var c;
            const l = ((c = o.theme) == null ? void 0 : c[r]) || o.color;
            return l ? `  --color-${a}: ${l};` : null;
          }).join(`
`)}
}
`
        ).join(`
`)
      }
    }
  ) : null;
}
const Jv = oi.Tooltip, Pu = T.forwardRef(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r = "dot",
    hideLabel: s = !1,
    hideIndicator: a = !1,
    label: o,
    labelFormatter: l,
    labelClassName: c,
    formatter: d,
    color: u,
    nameKey: h,
    labelKey: f
  }, y) => {
    const { config: p } = va(), v = H((w) => w.isTunecore), b = T.useMemo(() => {
      var A;
      if (s || !(t != null && t.length))
        return null;
      const [w] = t, S = `${f || w.dataKey || w.name || "value"}`, k = Er(p, w, S), N = !f && typeof o == "string" ? ((A = p[o]) == null ? void 0 : A.label) || o : k == null ? void 0 : k.label;
      return l ? /* @__PURE__ */ i("div", { className: g("font-medium", c), children: l(N, t) }) : N ? /* @__PURE__ */ i("div", { className: g("font-medium", c), children: N }) : null;
    }, [
      o,
      l,
      t,
      s,
      c,
      p,
      f
    ]);
    if (!e || !(t != null && t.length))
      return null;
    const x = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ m(
      "div",
      {
        ref: y,
        className: g(
          "grid min-w-32 max-w-[500px] items-start gap-1.5 border border-border/50 bg-layer-default px-2.5 py-1.5 text-ink-secondary text-base shadow-xl max-h-[800px] overflow-y-auto",
          v ? "rounded-lg" : "rounded-sm",
          n
        ),
        children: [
          x ? null : b,
          /* @__PURE__ */ i("div", { className: "grid gap-1.5", children: t.map((w, S) => {
            const k = `${h || w.name || w.dataKey || "value"}`, N = Er(p, w, k), A = u || w.payload.fill || w.color;
            return /* @__PURE__ */ i(
              "div",
              {
                className: g(
                  "flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg]:text-muted-foreground",
                  r === "dot" && "items-center"
                ),
                children: d && (w == null ? void 0 : w.value) !== void 0 && w.name ? d(w.value, w.name, w, S, w.payload) : /* @__PURE__ */ m(re, { children: [
                  N != null && N.icon ? /* @__PURE__ */ i(N.icon, {}) : !a && /* @__PURE__ */ i(
                    "div",
                    {
                      className: g(
                        "shrink-0 rounded-[2px] border-(--color-border) bg-(--color-bg)",
                        {
                          "h-2.5 w-2.5": r === "dot",
                          "w-1": r === "line",
                          "w-0 border-[1.5px] border-dashed bg-transparent": r === "dashed",
                          "my-0.5": x && r === "dashed"
                        }
                      ),
                      style: {
                        "--color-bg": A,
                        "--color-border": A
                      }
                    }
                  ),
                  /* @__PURE__ */ m(
                    "div",
                    {
                      className: g(
                        "flex flex-1 justify-between leading-none",
                        x ? "items-end" : "items-center"
                      ),
                      children: [
                        /* @__PURE__ */ m("div", { className: "grid gap-1.5", children: [
                          x ? b : null,
                          /* @__PURE__ */ i("span", { className: "text-muted-foreground", children: (N == null ? void 0 : N.label) || w.name })
                        ] }),
                        w.value && /* @__PURE__ */ i("span", { className: "font-sentric-alt font-medium tabular-nums text-ink-primary", children: w.value.toLocaleString() })
                      ]
                    }
                  )
                ] })
              },
              w.dataKey
            );
          }) })
        ]
      }
    );
  }
);
Pu.displayName = "ChartTooltip";
const Qv = oi.Legend, Du = T.forwardRef(
  ({ className: e, hideIcon: t = !1, payload: n, verticalAlign: r = "bottom", nameKey: s }, a) => {
    const { config: o } = va();
    return n != null && n.length ? /* @__PURE__ */ i(
      "div",
      {
        ref: a,
        className: g(
          "flex items-center justify-center gap-4",
          r === "top" ? "pb-3" : "pt-3",
          e
        ),
        children: n.map((l) => {
          const c = `${s || l.dataKey || "value"}`, d = Er(o, l, c);
          return /* @__PURE__ */ m(
            "div",
            {
              className: g(
                "flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-muted-foreground"
              ),
              children: [
                d != null && d.icon && !t ? /* @__PURE__ */ i(d.icon, {}) : /* @__PURE__ */ i(
                  "div",
                  {
                    className: "h-2 w-2 shrink-0 rounded-[2px]",
                    style: {
                      backgroundColor: l.color
                    }
                  }
                ),
                d == null ? void 0 : d.label
              ]
            },
            l.value
          );
        })
      }
    ) : null;
  }
);
Du.displayName = "ChartLegend";
function Er(e, t, n) {
  if (typeof t != "object" || t === null)
    return;
  const r = "payload" in t && typeof t.payload == "object" && t.payload !== null ? t.payload : void 0;
  let s = n;
  return n in t && typeof t[n] == "string" ? s = t[n] : r && n in r && typeof r[n] == "string" && (s = r[n]), s in e ? e[s] : e[n];
}
function Iu(e, t, n, r, s) {
  let a = e.trim().toUpperCase();
  t !== void 0 && t !== "" && a.startsWith(t.toUpperCase()) && (a = a.slice(t.length));
  const o = n.toUpperCase();
  a.endsWith(o) && (a = a.slice(0, a.length - o.length));
  const l = s ? a.replace(/[^A-Z0-9]/g, "") : a.replace(/\D/g, "");
  return l.length === 0 ? "" : l.length <= r ? s ? l : l.padStart(r, "0") : l.slice(0, r);
}
const Au = T.forwardRef(
  ({
    prefix: e,
    suffix: t,
    digitCount: n,
    value: r,
    label: s,
    hasError: a = !1,
    errorMessage: o,
    smallFont: l = !1,
    allowLetters: c = !1,
    disabled: d = !1,
    onChange: u,
    onBlur: h
  }, f) => {
    const y = H((C) => C.isTunecore), p = T.useId(), v = `codedInput-label-${p}`, b = `codedInput-${p}`, x = a || o !== void 0 && o !== "", w = (C) => {
      const R = (c ? C.target.value.replace(/[^a-z0-9]/gi, "") : C.target.value.replace(/\D/g, "")).slice(0, n);
      u == null || u(R);
    }, S = (C) => {
      const M = C.clipboardData.getData("text");
      if (M.length === 0)
        return;
      C.preventDefault();
      const R = Iu(M, e, t, n, c);
      R !== "" && (u == null || u(R));
    }, k = g(
      "flex items-center shrink-0 select-none px-2",
      // TuneCore predates this radius token system and has no spec of its
      // own — keep its original rounded-lg (8px) rather than silently
      // inheriting Sentric's new rounded-sm (6px).
      y ? "rounded-lg" : "rounded-sm",
      l ? "text-xs" : "text-sm",
      "text-ink-primary bg-layer-raised",
      y ? "font-tunecore" : "font-sentric-alt"
    ), N = x ? y ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary" : "ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-within:ring-2 focus-within:ring-stroke-primary", A = x && !y ? "bg-red-100 dark:bg-red-800" : "";
    return /* @__PURE__ */ m("div", { className: g("flex flex-col w-full", l ? "gap-0.5" : "gap-1"), children: [
      s != null && s !== "" && /* @__PURE__ */ i(
        "label",
        {
          id: v,
          htmlFor: b,
          className: g(
            "leading-snug self-start",
            l ? "text-xs" : "text-base",
            "text-ink-primary",
            y ? "font-tunecore" : "font-sentric-alt"
          ),
          children: s
        }
      ),
      /* @__PURE__ */ m(
        "div",
        {
          className: g(
            "flex flex-row items-stretch w-full overflow-hidden transition ease-out duration-200",
            y ? "rounded-lg" : "rounded-sm",
            N,
            A,
            d ? "opacity-50 cursor-not-allowed pointer-events-none" : ""
          ),
          children: [
            e != null && e !== "" && /* @__PURE__ */ i(
              "span",
              {
                "aria-hidden": "true",
                className: g(
                  k,
                  "rounded-r-none border-r border-stroke-heavy/20 py-1.5"
                ),
                children: e
              }
            ),
            /* @__PURE__ */ i(
              "input",
              {
                ref: f,
                id: b,
                type: "text",
                inputMode: c ? "text" : "numeric",
                pattern: c ? "[A-Za-z0-9]*" : "[0-9]*",
                placeholder: c ? "0001VXKQ" : "0".repeat(n),
                value: r,
                disabled: d,
                "aria-label": s ?? `${e ?? ""}${t} code`,
                "aria-invalid": x,
                "aria-describedby": x ? `${b}-error` : void 0,
                onChange: w,
                onPaste: S,
                onBlur: h,
                className: g(
                  "flex-1 min-w-0 px-2 py-1.5 font-medium focus-visible:outline-none transition ease-out duration-200 bg-transparent",
                  l ? "text-xs" : "text-sm",
                  "text-ink-primary placeholder:text-ink-primary/50",
                  y ? "font-tunecore" : "font-sentric-alt"
                )
              }
            ),
            /* @__PURE__ */ i(
              "span",
              {
                "aria-hidden": "true",
                className: g(
                  k,
                  "rounded-l-none border-l border-stroke-heavy/20 py-1.5"
                ),
                children: t
              }
            )
          ]
        }
      ),
      x && o != null && o !== "" && /* @__PURE__ */ i(
        B,
        {
          id: `${b}-error`,
          className: g(
            "text-ink-error",
            l ? "text-[10px]" : "text-xs"
          ),
          children: o
        }
      )
    ] });
  }
);
Au.displayName = "CodedInput";
function Eu(e, t) {
  return t.type === "UPDATE" ? t.payload : e;
}
function Vu(e, t = {}) {
  const { horizontal: n = !0, vertical: r = !1 } = t, [s, a] = od(Eu, {
    canScrollLeft: !1,
    canScrollRight: !1,
    canScrollUp: !1,
    canScrollDown: !1
  }), o = Re(() => {
    const l = e.current;
    if (!l)
      return;
    const { scrollLeft: c, scrollTop: d, scrollWidth: u, scrollHeight: h, clientWidth: f, clientHeight: y } = l;
    a({
      type: "UPDATE",
      payload: {
        canScrollLeft: n && c > 5,
        // Small threshold to avoid flickering
        canScrollRight: n && c < u - f - 5,
        canScrollUp: r && d > 5,
        canScrollDown: r && d < h - y - 5
      }
    });
  }, [e, n, r]);
  return Ue(() => {
    const l = e.current;
    if (!l)
      return;
    o(), l.addEventListener("scroll", o, { passive: !0 });
    const c = new ResizeObserver(o);
    return c.observe(l), () => {
      l.removeEventListener("scroll", o), c.disconnect();
    };
  }, [o, e]), s;
}
const En = T.forwardRef(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ i(
  ct.ScrollAreaScrollbar,
  {
    ref: r,
    orientation: t,
    className: g(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-px",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-px rounded-lg",
      e
    ),
    ...n,
    children: /* @__PURE__ */ i(ct.ScrollAreaThumb, { className: "relative flex-1 rounded-full cursor-pointer bg-ink-secondary dark:bg-ink-secondary/50" })
  }
));
En.displayName = ct.ScrollAreaScrollbar.displayName;
const ui = T.forwardRef(({ className: e, children: t, "aria-label": n, showScrollIndicators: r = !1, indicatorOrientation: s = "horizontal", indicatorTopInset: a = 0, indicatorBottomInset: o = 0, ...l }, c) => {
  const d = T.useRef(null), u = H((p) => p.isTunecore), h = Vu(d, {
    horizontal: r && (s === "horizontal" || s === "both"),
    vertical: r && (s === "vertical" || s === "both")
  }), f = u ? "from-action-primary/20 via-action-primary/5 to-transparent" : "from-canvas-inverse/30 via-ink-secondary/10 to-transparent dark:from-black/80 dark:via-black/40", y = u ? "from-action-primary/20 via-action-primary/5 to-transparent" : "from-canvas-inverse/35 via-ink-secondary/12 to-transparent dark:from-black/85 dark:via-black/45";
  return /* @__PURE__ */ m(
    ct.Root,
    {
      ref: c,
      className: g("relative overflow-hidden", e),
      ...l,
      children: [
        r && h.canScrollLeft && /* @__PURE__ */ i(
          "div",
          {
            className: g(
              "absolute left-0 z-30 w-12 pointer-events-none bg-linear-to-r",
              f
            ),
            style: { top: a, bottom: o },
            "aria-hidden": "true"
          }
        ),
        r && h.canScrollRight && /* @__PURE__ */ i(
          "div",
          {
            className: g(
              "absolute right-0 z-30 w-12 pointer-events-none bg-linear-to-l",
              f
            ),
            style: { top: a, bottom: o },
            "aria-hidden": "true"
          }
        ),
        r && h.canScrollUp && /* @__PURE__ */ i(
          "div",
          {
            className: g(
              "absolute top-0 left-0 right-0 z-30 h-16 pointer-events-none bg-linear-to-b",
              y
            ),
            "aria-hidden": "true"
          }
        ),
        r && h.canScrollDown && /* @__PURE__ */ i(
          "div",
          {
            className: g(
              "absolute bottom-0 left-0 right-0 z-30 h-16 pointer-events-none bg-linear-to-t",
              y
            ),
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ i(
          ct.Viewport,
          {
            ref: r ? d : void 0,
            className: "w-full h-full scroll-viewport",
            tabIndex: 0,
            role: "region",
            "aria-label": n ?? "Scrollable content",
            children: t
          }
        ),
        /* @__PURE__ */ i(En, {}),
        /* @__PURE__ */ i(ct.Corner, {})
      ]
    }
  );
});
ui.displayName = ct.Root.displayName;
const ba = J.Root, Lu = J.Trigger, Ru = J.Portal, e1 = J.Close, xa = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  J.Overlay,
  {
    ref: n,
    className: g(
      "fixed inset-0 z-50 bg-black/10  backdrop-blur-xl data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
xa.displayName = J.Overlay.displayName;
const hi = T.forwardRef(({ className: e, children: t, showCloseButton: n = !0, ...r }, s) => {
  const a = H((o) => o.isTunecore);
  return /* @__PURE__ */ m(Ru, { children: [
    /* @__PURE__ */ i(xa, {}),
    /* @__PURE__ */ m(
      J.Content,
      {
        ref: s,
        className: g(
          `fixed left-[50%] top-4 sm:top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] sm:translate-y-[-50%] gap-4 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg max-h-[calc(100vh-2rem)] sm:max-h-[calc(100vh-4rem)] ${a ? "bg-layer-inverse text-white" : "bg-layer-default text-ink-primary"}`,
          e
        ),
        ...r,
        children: [
          /* @__PURE__ */ i(ui, { className: "w-full h-full max-h-[calc(100vh-2rem)] sm:max-h-[calc(100vh-4rem)]", children: /* @__PURE__ */ i("div", { className: "p-6", children: t }) }),
          n && /* @__PURE__ */ m(J.Close, { className: "absolute z-30 transition-opacity rounded-sm right-4 top-4 ring-stroke-primary disabled:pointer-events-none", children: [
            /* @__PURE__ */ i(fa, { size: "lg", className: "stroke-ink-primary hover:stroke-ink-accent" }),
            /* @__PURE__ */ i("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] });
});
hi.displayName = J.Content.displayName;
function fi({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: g(
        "flex flex-col space-y-1.5 text-center sm:text-left",
        e
      ),
      ...t
    }
  );
}
fi.displayName = "DialogHeader";
function zu({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: g(
        "flex justify-between space-x-4 mt-2",
        e
      ),
      ...t
    }
  );
}
zu.displayName = "DialogFooter";
const pi = T.forwardRef(({ className: e, ...t }, n) => {
  const r = H((s) => s.isTunecore);
  return /* @__PURE__ */ i(
    J.Title,
    {
      ref: n,
      className: g(ai("h3", { isTunecore: r }), e),
      ...t
    }
  );
});
pi.displayName = J.Title.displayName;
const wa = T.forwardRef(({ asChild: e, className: t, children: n, ...r }, s) => e ? /* @__PURE__ */ i(J.Description, { ref: s, asChild: !0, className: t, ...r, children: n }) : /* @__PURE__ */ i(J.Description, { ref: s, asChild: !0, ...r, children: /* @__PURE__ */ i(B, { as: "p", className: t, children: n }) }));
wa.displayName = J.Description.displayName;
function ka({
  className: e,
  ...t
}) {
  const n = H((r) => r.isTunecore);
  return /* @__PURE__ */ i(
    pt,
    {
      "data-slot": "command",
      className: g(
        `flex h-full w-full flex-col overflow-hidden rounded-md text-ink-primary ${n ? "bg-layer-inverse" : "bg-layer-default"}`,
        e
      ),
      ...t
    }
  );
}
function t1({
  title: e = "Command Palette",
  description: t = "Search for a command to run...",
  children: n,
  className: r,
  showCloseButton: s = !0,
  ...a
}) {
  return /* @__PURE__ */ m(ba, { ...a, children: [
    /* @__PURE__ */ m(fi, { className: "sr-only", children: [
      /* @__PURE__ */ i(pi, { children: e }),
      /* @__PURE__ */ i(wa, { children: t })
    ] }),
    /* @__PURE__ */ i(
      hi,
      {
        className: g("overflow-hidden p-0", r),
        showCloseButton: s,
        children: /* @__PURE__ */ i(ka, { className: "[&_[cmdk-group-heading]]:text-muted-foreground **:data-[slot=command-input-wrapper]:h-12 **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:font-medium **:[[cmdk-group]]:px-2 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 **:[[cmdk-input]]:h-12 **:[[cmdk-item]]:px-2 **:[[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: n })
      }
    )
  ] });
}
function Bu({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ m(
    "div",
    {
      "data-slot": "command-input-wrapper",
      className: "flex items-center gap-2 px-3 h-10 border-b border-stroke-subtle",
      children: [
        /* @__PURE__ */ i(rd, { className: "size-4 shrink-0 text-ink-primary/50" }),
        /* @__PURE__ */ i(
          pt.Input,
          {
            "data-slot": "command-input",
            className: g(
              "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none focus:outline-none focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 placeholder:text-ink-primary/50 text-ink-primary",
              e
            ),
            ...t
          }
        )
      ]
    }
  );
}
function ju({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    pt.List,
    {
      "data-slot": "command-list",
      className: g(
        "max-h-[300px] scroll-py-1 overflow-x-hidden overflow-y-auto text-ink-primary",
        e
      ),
      ...t
    }
  );
}
function Fu({
  ...e
}) {
  const t = H((n) => n.isTunecore);
  return /* @__PURE__ */ i(
    pt.Empty,
    {
      "data-slot": "command-empty",
      className: `py-6 text-sm text-center ${t ? "text-action-primary/70" : "text-ink-secondary"}`,
      ...e
    }
  );
}
function sr({
  className: e,
  ...t
}) {
  const n = H((r) => r.isTunecore);
  return /* @__PURE__ */ i(
    pt.Group,
    {
      "data-slot": "command-group",
      className: g(
        `overflow-hidden p-1 text-ink-primary ${n ? "**:[[cmdk-group-heading]]:text-action-primary/70" : "**:[[cmdk-group-heading]]:text-black/70 dark:**:[[cmdk-group-heading]]:text-white/70"} **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:py-1.5 **:[[cmdk-group-heading]]:text-xs **:[[cmdk-group-heading]]:font-medium`,
        e
      ),
      ...t
    }
  );
}
function n1({
  className: e,
  ...t
}) {
  const n = H((r) => r.isTunecore);
  return /* @__PURE__ */ i(
    pt.Separator,
    {
      "data-slot": "command-separator",
      className: g(
        `-mx-1 h-px ${n ? "bg-action-primary/20" : "bg-stroke-subtle"}`,
        e
      ),
      ...t
    }
  );
}
function or({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    pt.Item,
    {
      "data-slot": "command-item",
      className: g(
        "relative flex w-full cursor-pointer select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 text-ink-primary hover:bg-layer-raised hover:text-ink-primary focus:bg-layer-raised focus:text-ink-primary data-[selected=true]:bg-layer-raised data-[selected=true]:text-ink-primary",
        e
      ),
      ...t
    }
  );
}
function r1({
  className: e,
  ...t
}) {
  const n = H((r) => r.isTunecore);
  return /* @__PURE__ */ i(
    "span",
    {
      "data-slot": "command-shortcut",
      className: g(
        `ml-auto text-xs tracking-widest ${n ? "text-action-primary/50" : "text-ink-disabled"}`,
        e
      ),
      ...t
    }
  );
}
const mi = Wt.Root, gi = Wt.Trigger, Un = T.forwardRef(
  ({ className: e, side: t = "right", align: n = "center", sideOffset: r = 0, disablePortal: s = !1, ...a }, o) => {
    const l = H((d) => d.isTunecore), c = /* @__PURE__ */ i(
      Wt.Content,
      {
        ref: o,
        align: n,
        sideOffset: r,
        side: t,
        className: g(
          `z-50 rounded-md border p-4 shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 mt-1 border-stroke-subtle text-ink-primary ${l ? "bg-layer-inverse" : "bg-layer-default"}`,
          e
        ),
        ...a
      }
    );
    return s ? c : /* @__PURE__ */ i(Wt.Portal, { children: c });
  }
);
Un.displayName = Wt.Content.displayName;
function _u() {
  let e, t = [];
  return (n, r, s) => {
    if (r !== e && (e = r, t = r.trim().toUpperCase().split(/\s+/).filter((o) => o !== "")), t.length === 0)
      return 1;
    const a = s === void 0 ? "" : s.length === 1 ? s[0] : s.join(" ");
    return t.every((o) => a.includes(o)) ? 1 : 0;
  };
}
function i1({
  data: e,
  value: t,
  values: n,
  onValuesChange: r,
  maxDisplayCount: s = 3,
  multiSelectDisplay: a,
  selectAllLabel: o,
  onValueChange: l,
  clearButton: c,
  clearLabel: d = "Clear",
  placeholder: u = "Select option...",
  searchPlaceholder: h = "Search...",
  emptyText: f = "No option found.",
  className: y,
  triggerClassName: p,
  contentClassName: v,
  disabled: b = !1,
  label: x,
  smallFont: w = !1,
  customWidth: S = !1,
  searchByLabel: k = !1,
  matchAllWords: N = !1,
  disablePortal: A = !1,
  isNav: C = !1,
  popoverSide: M = "bottom",
  popoverAlign: R = "start",
  renderOption: D,
  textAlign: V = "left",
  onSearchChange: L,
  isLoading: Q = !1,
  onLoadMore: le,
  hasNextPage: _ = !1,
  isLoadingMore: G = !1,
  onSearchClear: me,
  hasError: K = !1,
  errorMessage: j,
  ...ie
}) {
  const [ue, je] = T.useState(!1), [ke, Ie] = T.useState(""), [mt] = T.useState(_u), se = H((U) => U.isTunecore), tt = ie["aria-invalid"] === !0 || K || j !== void 0 && j !== "", nt = `combobox-${T.useId()}`;
  T.useEffect(() => {
    if (L && ke !== "") {
      const U = setTimeout(() => {
        L(ke);
      }, 300);
      return () => clearTimeout(U);
    }
  }, [ke, L]);
  const gt = (U) => U.length > 0 && "groupLabel" in U[0], Ae = T.useMemo(() => gt(e) ? e.flatMap((U) => U.options) : e, [e]), Se = Ae.find((U) => U.value === t), ge = n !== void 0, yt = ge && Ae.length > 0 && Ae.every((U) => n.includes(U.value)), rt = (U) => ge ? n.includes(U) : t === U, Ne = () => {
    if (!ge)
      return;
    const U = Ae.map((de) => de.value);
    r == null || r(yt ? [] : U);
  }, Te = (U) => {
    if (ge) {
      const z = n.includes(U) ? n.filter(($) => $ !== U) : [...n, U];
      r == null || r(z);
      return;
    }
    const de = U === t ? "" : U;
    l == null || l(de), je(!1);
  }, X = (U) => {
    const de = U ? { id: nt, name: nt } : {};
    return /* @__PURE__ */ m(mi, { open: ue, onOpenChange: je, children: [
      /* @__PURE__ */ i(gi, { asChild: !0, disabled: b, children: /* @__PURE__ */ i(
        O,
        {
          type: "button",
          role: "combobox",
          "aria-expanded": ue,
          "aria-label": "Select an option",
          disabled: b,
          variant: "outline",
          label: ge ? /* @__PURE__ */ m("span", { className: "flex items-center justify-between w-full min-w-0", children: [
            /* @__PURE__ */ i("span", { className: "block min-w-0 truncate", children: n.length > 0 ? (() => {
              const z = Ae.filter(($) => n.includes($.value)).map(($) => $.label);
              return a === "count" || z.length > s ? `${z.length} selected` : z.join(", ");
            })() : u }),
            c && n.length > 0 && /* @__PURE__ */ i(
              O,
              {
                className: "ml-2 shrink-0 p-0",
                variant: "link",
                label: /* @__PURE__ */ i(ha, { size: "md", className: se || C ? "stroke-white" : "stroke-ink-primary" }),
                tooltip: !0,
                tooltipText: d,
                onClick: (z) => {
                  z.stopPropagation(), r == null || r([]);
                }
              }
            )
          ] }) : Se ? D && Se.label.includes(`
`) ? (() => {
            const [z, $] = Se.label.split(`
`);
            return /* @__PURE__ */ m("div", { className: "flex flex-col text-left min-w-0", children: [
              /* @__PURE__ */ i("span", { className: "font-medium truncate", children: z }),
              /* @__PURE__ */ i("span", { className: "text-xs opacity-75 truncate", children: $ })
            ] });
          })() : /* @__PURE__ */ i("span", { className: "block min-w-0 truncate", children: Se.label }) : /* @__PURE__ */ i("span", { className: "block min-w-0 truncate", children: u }),
          icon: /* @__PURE__ */ i(
            Ud,
            {
              size: "md",
              className: g(
                "ml-2 shrink-0",
                se || C ? "stroke-white" : "stroke-ink-primary"
              )
            }
          ),
          className: g(
            // Match FormInput styling exactly
            "flex font-medium px-2 py-1.5 focus-visible:outline-none transition ease-out duration-200 justify-between items-center normal-case overflow-hidden",
            // TuneCore predates this radius token system and has no spec of
            // its own — keep its original rounded-lg (8px) rather than
            // silently inheriting Sentric's new rounded-sm (6px).
            se ? "rounded-lg" : "rounded-sm",
            "data-disabled:cursor-not-allowed data-disabled:pointer-events-none",
            C ? "whitespace-normal" : "whitespace-nowrap",
            // Allow text wrapping in navigation mode
            S ? "" : ge ? "w-full min-w-[280px] max-w-[280px]" : "w-full",
            w ? "text-xs" : "text-sm",
            // Navigation-specific styling for dark sidebar use (publishing-dashboard)
            C && se ? "font-tunecore bg-layer-inverse border border-stroke-subtle text-white ring-0 hover:border-stroke-primary focus-visible:border-stroke-primary" : C && !se ? "font-sentric-alt border border-ink-secondary text-white ring-0" : se ? "font-tunecore bg-layer-raised text-white ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-stroke-primary data-disabled:hover:ring-layer-raised" : "font-sentric-alt text-ink-primary bg-layer-default ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary data-disabled:hover:ring-stroke-heavy",
            // Apply error styling to match FormInput (not for navigation mode)
            !C && tt && (se ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary bg-layer-error"),
            // Apply placeholder-like styling when no option is selected (match FormInput placeholder colors exactly)
            !Se && !ge && (se || C) ? "!text-white/35" : "",
            ge && n.length === 0 && (se || C) ? "!text-white/35" : "",
            !Se && !ge && !se && !C ? "!text-ink-secondary" : "",
            ge && n.length === 0 && !se && !C ? "!text-ink-secondary" : "",
            p
          ),
          ...de
        }
      ) }),
      /* @__PURE__ */ i(
        Un,
        {
          className: g(
            "relative z-50 max-h-96 min-w-32 overflow-hidden rounded-md border border-stroke-subtle shadow-md p-0 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
            se ? "font-tunecore bg-layer-inverse text-white" : "font-sentric-alt bg-layer-default text-ink-primary",
            S ? "" : "w-(--radix-popover-trigger-width)",
            v
          ),
          side: M,
          align: R,
          disablePortal: A,
          onWheel: (z) => {
            z.stopPropagation();
          },
          children: /* @__PURE__ */ m(
            ka,
            {
              className: "flex flex-col",
              shouldFilter: !L,
              filter: N ? mt : void 0,
              children: [
                /* @__PURE__ */ i(
                  Bu,
                  {
                    placeholder: h,
                    value: ke,
                    onValueChange: (z) => {
                      Ie(z), z === "" && me && me();
                    }
                  }
                ),
                /* @__PURE__ */ m(
                  ju,
                  {
                    className: "max-h-[300px] overflow-y-auto flex-1",
                    onWheel: (z) => {
                      z.stopPropagation();
                    },
                    onScroll: (z) => {
                      if (_ && !G && le) {
                        const $ = z.currentTarget;
                        $.scrollHeight - $.scrollTop <= $.clientHeight + 50 && le();
                      }
                    },
                    children: [
                      /* @__PURE__ */ i(Fu, { children: Q ? "Loading..." : f }),
                      ge && o !== void 0 && /* @__PURE__ */ i(
                        sr,
                        {
                          className: g(
                            "p-1 border-b",
                            "border-stroke-subtle"
                          ),
                          children: /* @__PURE__ */ m(
                            or,
                            {
                              value: "__select_all__",
                              onSelect: Ne,
                              style: { pointerEvents: "auto" },
                              children: [
                                /* @__PURE__ */ i(
                                  "span",
                                  {
                                    className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                                    style: { pointerEvents: "none" },
                                    children: /* @__PURE__ */ i(
                                      dt,
                                      {
                                        size: "md",
                                        className: g(
                                          "stroke-ink-primary",
                                          yt ? "opacity-100" : "opacity-0"
                                        )
                                      }
                                    )
                                  }
                                ),
                                /* @__PURE__ */ i("span", { className: "block text-left font-medium", children: o })
                              ]
                            }
                          )
                        }
                      ),
                      gt(e) ? (
                        // Render grouped data with CommandGroup headings
                        e.map((z) => /* @__PURE__ */ i(sr, { heading: z.groupLabel, className: "p-1", children: z.options.map(($) => /* @__PURE__ */ m(
                          or,
                          {
                            value: k ? `${$.value} ${$.label}` : $.value,
                            keywords: N ? [$.label.toUpperCase()] : void 0,
                            onSelect: (Ce) => {
                              const pe = k ? $.value : Ce;
                              Te(pe);
                            },
                            style: { pointerEvents: "auto" },
                            children: [
                              /* @__PURE__ */ i(
                                "span",
                                {
                                  className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                                  style: { pointerEvents: "none" },
                                  children: /* @__PURE__ */ i(
                                    dt,
                                    {
                                      size: "md",
                                      className: g(
                                        "stroke-ink-primary",
                                        rt($.value) ? "opacity-100" : "opacity-0"
                                      )
                                    }
                                  )
                                }
                              ),
                              /* @__PURE__ */ i(
                                "span",
                                {
                                  onClick: (Ce) => {
                                    Ce.preventDefault(), Ce.stopPropagation(), Te($.value);
                                  },
                                  style: { cursor: "pointer" },
                                  className: g(
                                    "block",
                                    V === "left" ? "text-left" : V === "center" ? "text-center" : "text-right"
                                  ),
                                  children: D ? D($) : $.label
                                }
                              )
                            ]
                          },
                          $.value
                        )) }, z.groupLabel))
                      ) : (
                        // Render flat data
                        /* @__PURE__ */ m(sr, { className: "p-1", children: [
                          e.map((z) => /* @__PURE__ */ m(
                            or,
                            {
                              value: k ? `${z.value} ${z.label}` : z.value,
                              keywords: N ? [z.label.toUpperCase()] : void 0,
                              onSelect: ($) => {
                                const Ce = k ? z.value : $;
                                Te(Ce);
                              },
                              style: { pointerEvents: "auto" },
                              children: [
                                /* @__PURE__ */ i(
                                  "span",
                                  {
                                    className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                                    style: { pointerEvents: "none" },
                                    children: /* @__PURE__ */ i(
                                      dt,
                                      {
                                        size: "md",
                                        className: g(
                                          "stroke-ink-primary",
                                          rt(z.value) ? "opacity-100" : "opacity-0"
                                        )
                                      }
                                    )
                                  }
                                ),
                                /* @__PURE__ */ i(
                                  "span",
                                  {
                                    onClick: ($) => {
                                      $.preventDefault(), $.stopPropagation(), Te(z.value);
                                    },
                                    style: { cursor: "pointer" },
                                    className: g(
                                      "block",
                                      V === "left" ? "text-left" : V === "center" ? "text-center" : "text-right"
                                    ),
                                    children: D ? D(z) : z.label
                                  }
                                )
                              ]
                            },
                            z.value
                          )),
                          G && /* @__PURE__ */ i("div", { className: "flex items-center justify-center py-2", children: /* @__PURE__ */ i(
                            "span",
                            {
                              className: g(
                                "text-sm text-ink-primary",
                                se && "opacity-75"
                              ),
                              children: "Loading more..."
                            }
                          ) })
                        ] })
                      )
                    ]
                  }
                )
              ]
            }
          )
        }
      )
    ] });
  };
  return x == null || x === "" ? j !== void 0 && j !== "" ? /* @__PURE__ */ m("div", { className: g("flex flex-col", S ? "" : "w-full"), children: [
    X(!1),
    /* @__PURE__ */ i(
      B,
      {
        className: g(
          "text-ink-error",
          w ? "text-[10px]" : "text-xs"
        ),
        children: j
      }
    )
  ] }) : X(!1) : /* @__PURE__ */ m("div", { className: g("flex flex-col justify-between", S ? "" : "w-full", y), children: [
    /* @__PURE__ */ i(
      "label",
      {
        className: g(
          "leading-snug self-start",
          w ? "text-xs" : "text-base",
          "text-ink-primary",
          se ? "font-tunecore" : "font-sentric-alt"
        ),
        htmlFor: nt,
        children: x
      }
    ),
    X(!0),
    j !== void 0 && j !== "" && /* @__PURE__ */ i(
      B,
      {
        className: g(
          "text-ink-error",
          w ? "text-[10px]" : "text-xs"
        ),
        children: j
      }
    )
  ] });
}
const Ou = ({
  children: e,
  className: t,
  elevation: n = "default"
}) => {
  const r = H((s) => s.isTunecore);
  return /* @__PURE__ */ i(
    "div",
    {
      className: g(
        "w-full p-4 bg-layer-default text-ink-primary",
        n === "default" && "shadow-md",
        n === "system" && "shadow-system",
        r ? "rounded-lg" : "rounded-sm",
        t
      ),
      children: e
    }
  );
};
function s1({
  className: e,
  buttonClassName: t,
  value: n,
  onChange: r,
  label: s,
  placeholder: a = "Pick a date",
  disabled: o = !1,
  disabledDays: l,
  smallFont: c = !1,
  semiSmallFont: d = !1
}) {
  const u = H((b) => b.isTunecore), [h, f] = Y.useState(n);
  Y.useEffect(() => {
    f(n);
  }, [n]);
  const y = (b) => {
    b && b.setHours(12, 0, 0, 0), f(b), r(b);
  }, p = () => {
    f(void 0), r(void 0);
  }, v = h ? Bt(h, "dd/MM/yyyy") : void 0;
  return /* @__PURE__ */ m("div", { className: g("flex flex-col w-full", e), children: [
    s != null && s !== "" ? /* @__PURE__ */ i(
      "label",
      {
        className: g(
          "self-start leading-snug",
          c ? "text-xs" : d ? "text-sm  mb-0.5 font-medium" : "text-base mb-1",
          "text-ink-primary",
          u ? "font-tunecore" : "font-sentric-alt"
        ),
        children: s
      }
    ) : null,
    /* @__PURE__ */ m(mi, { children: [
      /* @__PURE__ */ i(gi, { asChild: !0, children: /* @__PURE__ */ m(
        "button",
        {
          type: "button",
          disabled: o,
          className: g(
            "flex items-center font-medium px-2 py-1.5 focus-visible:outline-none transition ease-out duration-200 w-full text-left",
            // TuneCore predates this radius token system and has no spec of
            // its own — keep its original rounded-lg (8px) rather than
            // silently inheriting Sentric's new rounded-sm (6px).
            u ? "rounded-lg" : "rounded-sm",
            c ? "text-xs" : d ? "text-sm" : "text-base",
            u ? "font-tunecore bg-layer-raised text-white ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary placeholder:text-white/50" : "font-sentric-alt text-ink-primary bg-layer-default ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary placeholder:text-ink-primary/50",
            o && "opacity-50 cursor-not-allowed",
            t
          ),
          children: [
            /* @__PURE__ */ i(ta, { className: "w-4 h-4 mr-2" }),
            v ?? /* @__PURE__ */ i("span", { className: "text-ink-primary/50", children: a })
          ]
        }
      ) }),
      /* @__PURE__ */ m(Un, { className: "w-auto p-0", side: "bottom", align: "start", children: [
        /* @__PURE__ */ i(
          Ot,
          {
            mode: "single",
            selected: h,
            onSelect: y,
            disabled: l,
            initialFocus: !0,
            captionLayout: "dropdown",
            defaultMonth: h
          }
        ),
        h && /* @__PURE__ */ i("div", { className: "flex items-end justify-end w-full px-6 pb-4", children: /* @__PURE__ */ i(
          O,
          {
            label: "Clear",
            variant: "link",
            onClick: p,
            className: "w-auto mt-2"
          }
        ) })
      ] })
    ] })
  ] });
}
function o1({
  className: e,
  onSelect: t,
  label: n,
  smallFont: r,
  multiYear: s,
  fromYear: a,
  toYear: o,
  initialRange: l,
  maxDate: c,
  numberOfMonths: d = 2,
  defaultMonth: u
}) {
  const h = H((_) => _.isTunecore), [f, y] = Y.useState(l), [p, v] = Y.useState(l == null ? void 0 : l.from), [b, x] = Y.useState(l == null ? void 0 : l.to), w = s === !0, S = Y.useRef(t);
  Y.useLayoutEffect(() => {
    S.current = t;
  });
  const k = Y.useRef(!1);
  Y.useEffect(() => {
    w ? (v(l == null ? void 0 : l.from), x(l == null ? void 0 : l.to)) : y(l);
  }, [l, w]), Y.useEffect(() => {
    if (!k.current) {
      k.current = !0;
      return;
    }
    w ? y(void 0) : (v(void 0), x(void 0)), S.current(void 0);
  }, [w]);
  const N = (_) => {
    y(_), t(_);
  }, A = (_) => {
    if (_ === void 0)
      return;
    const G = new Date(_);
    return G.setHours(12, 0, 0, 0), G;
  }, C = (_) => {
    const G = A(_), me = A(b), K = G !== void 0 && me !== void 0 && me < G ? void 0 : me;
    K !== me && x(void 0), v(G), t(G !== void 0 || K !== void 0 ? { from: G, to: K } : void 0);
  }, M = (_) => {
    const G = A(_), me = A(p);
    x(G), t(me !== void 0 || G !== void 0 ? { from: me, to: G } : void 0);
  }, R = () => {
    w ? (v(void 0), x(void 0)) : y(void 0), t(void 0);
  }, D = w ? p !== void 0 || b !== void 0 ? { from: p, to: b } : void 0 : f, V = D != null && D.from ? D.to ? /* @__PURE__ */ m("span", { className: "text-sm capitalize font-sentric-alt", children: [
    Bt(D.from, "LLL dd, y"),
    " ",
    "-",
    " ",
    Bt(D.to, "LLL dd, y")
  ] }) : /* @__PURE__ */ i("span", { className: "text-sm capitalize font-sentric-alt", children: Bt(D.from, "LLL dd, y") }) : D != null && D.to ? /* @__PURE__ */ m("span", { className: "text-sm capitalize font-sentric-alt", children: [
    "To:",
    " ",
    Bt(D.to, "LLL dd, y")
  ] }) : "", L = a !== void 0 || o !== void 0, Q = {
    captionLayout: "dropdown-buttons",
    ...a !== void 0 && { fromYear: a },
    ...o !== void 0 && { toYear: o }
  }, le = {
    ...L && { captionLayout: "dropdown-buttons" },
    ...a !== void 0 && { fromYear: a },
    ...o !== void 0 && { toYear: o },
    ...c !== void 0 && { disabled: { after: c } },
    ...c !== void 0 && { toMonth: c },
    numberOfMonths: d
  };
  return /* @__PURE__ */ m("div", { className: g("flex flex-col w-full justify-between", e), children: [
    /* @__PURE__ */ i(
      "label",
      {
        className: g(
          "leading-snug self-start",
          r ? "text-xs" : "text-base",
          "text-ink-primary",
          h ? "font-tunecore" : "font-sentric-alt"
        ),
        htmlFor: "datePicker",
        children: n
      }
    ),
    /* @__PURE__ */ m(mi, { children: [
      /* @__PURE__ */ i(gi, { asChild: !0, children: /* @__PURE__ */ i(
        O,
        {
          id: "datePicker",
          label: /* @__PURE__ */ m(re, { children: [
            /* @__PURE__ */ i(ta, { className: "w-4 h-4 mr-2 shrink-0" }),
            /* @__PURE__ */ i("span", { className: "truncate", children: V })
          ] }),
          variant: "outline",
          className: g(
            "w-full flex items-center px-3 py-1.5 justify-start text-left font-normal normal-case overflow-hidden text-ink-primary",
            h ? "font-tunecore bg-layer-raised ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary" : "font-sentric-alt bg-layer-default ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary"
          )
        }
      ) }),
      /* @__PURE__ */ m(Un, { className: "w-auto p-0", side: "bottom", align: "center", children: [
        w ? /* @__PURE__ */ m("div", { className: "flex gap-4 p-3", children: [
          /* @__PURE__ */ i("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ i(
            Ot,
            {
              initialFocus: !0,
              mode: "single",
              selected: p,
              onSelect: C,
              defaultMonth: p ?? /* @__PURE__ */ new Date(),
              ...Q,
              ...c !== void 0 && { disabled: (_) => _ > c }
            }
          ) }),
          /* @__PURE__ */ i(
            "div",
            {
              className: g(
                "w-px self-stretch",
                h ? "bg-layer-inverse" : "bg-stroke-subtle"
              )
            }
          ),
          /* @__PURE__ */ i("div", { className: g("flex flex-col gap-1", !p && "pointer-events-none opacity-50"), children: /* @__PURE__ */ i(
            Ot,
            {
              mode: "single",
              selected: b,
              onSelect: M,
              defaultMonth: b ?? (p ? new Date(p.getFullYear(), p.getMonth() + 1, 1) : /* @__PURE__ */ new Date()),
              ...Q,
              disabled: (_) => p !== void 0 && _ < p || c !== void 0 && _ > c
            },
            (p == null ? void 0 : p.toISOString()) ?? "no-from"
          ) })
        ] }) : /* @__PURE__ */ i(
          Ot,
          {
            initialFocus: !0,
            mode: "range",
            defaultMonth: u ?? /* @__PURE__ */ new Date(),
            selected: f,
            onSelect: N,
            ...le
          }
        ),
        /* @__PURE__ */ i("div", { className: "flex items-end justify-end w-full px-6 pb-4", children: /* @__PURE__ */ i(
          O,
          {
            label: "Clear",
            variant: "link",
            onClick: R,
            className: "w-auto mt-2"
          }
        ) })
      ] })
    ] })
  ] });
}
const Hu = ee.Root, $u = ee.Trigger, a1 = ee.Group, l1 = ee.Portal, Uu = ee.Sub, c1 = ee.RadioGroup, Sa = T.forwardRef(({ className: e, inset: t, children: n, ...r }, s) => /* @__PURE__ */ m(
  ee.SubTrigger,
  {
    ref: s,
    className: g(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm text-ink-primary outline-none focus:bg-layer-raised data-[state=open]:bg-layer-raised",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ i(ea, { className: "w-4 h-4 ml-auto" })
    ]
  }
));
Sa.displayName = ee.SubTrigger.displayName;
const Na = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  ee.SubContent,
  {
    ref: n,
    className: g(
      "z-50 min-w-32 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
Na.displayName = ee.SubContent.displayName;
const Ta = T.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ i(ee.Portal, { children: /* @__PURE__ */ i(
  ee.Content,
  {
    ref: r,
    sideOffset: t,
    className: g(
      "font-sentric-alt relative z-50 max-h-96 min-w-32 overflow-hidden rounded-md border border-stroke-subtle bg-layer-default text-ink-primary shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 p-1",
      e
    ),
    ...n
  }
) }));
Ta.displayName = ee.Content.displayName;
const Wn = T.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ i(
  ee.Item,
  {
    ref: r,
    className: g(
      "relative flex w-full cursor-default select-none items-center rounded-sm p-2 text-sm text-ink-primary outline-none focus:bg-layer-raised focus:text-ink-primary data-disabled:pointer-events-none data-disabled:opacity-50 hover:cursor-pointer",
      e
    ),
    ...n
  }
));
Wn.displayName = ee.Item.displayName;
const Wu = T.forwardRef(({ className: e, children: t, checked: n, ...r }, s) => /* @__PURE__ */ m(
  ee.CheckboxItem,
  {
    ref: s,
    className: g(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-layer-raised focus:text-ink-primary data-disabled:pointer-events-none data-disabled:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ i("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ i(ee.ItemIndicator, { children: /* @__PURE__ */ i(na, { className: "w-4 h-4" }) }) }),
      t
    ]
  }
));
Wu.displayName = ee.CheckboxItem.displayName;
const Gu = T.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ m(
  ee.RadioItem,
  {
    ref: r,
    className: g(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-layer-raised focus:text-ink-primary data-disabled:pointer-events-none data-disabled:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ i("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ i(ee.ItemIndicator, { children: /* @__PURE__ */ i(id, { className: "w-2 h-2 fill-current" }) }) }),
      t
    ]
  }
));
Gu.displayName = ee.RadioItem.displayName;
const Ku = T.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ i(
  ee.Label,
  {
    ref: r,
    className: g(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
Ku.displayName = ee.Label.displayName;
const Xu = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  ee.Separator,
  {
    ref: n,
    className: g("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
Xu.displayName = ee.Separator.displayName;
function Yu({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    "span",
    {
      className: g("ml-auto text-xs tracking-widest opacity-60", e),
      ...t
    }
  );
}
Yu.displayName = "DropdownMenuShortcut";
function Ts(e) {
  return { id: e.id, name: e.name, size: e.size ?? 0, type: e.type ?? "" };
}
const Cs = 50 * 1024 * 1024;
class Ms extends md {
  constructor(n, r) {
    super(n, r);
    bs(this, "opts");
    this.id = r.id ?? "ChunkedUpload", this.type = "uploader", this.opts = {
      chunkSize: Cs,
      ...r
    }, this.handleUpload = this.handleUpload.bind(this);
  }
  install() {
    this.uppy.addUploader(this.handleUpload);
  }
  uninstall() {
    this.uppy.removeUploader(this.handleUpload);
  }
  // -- Upload orchestration
  /** Resolve headers — supports both static objects and factory functions. */
  resolveHeaders() {
    const n = this.opts.headers;
    return typeof n == "function" ? n() : n ?? {};
  }
  resolveMimeType(n) {
    var r, s;
    return ((s = (r = this.opts).uploadMimeType) == null ? void 0 : s.call(r, { name: n.name, type: n.type ?? "" })) ?? "application/octet-stream";
  }
  async handleUpload(n) {
    var r, s, a, o;
    for (const l of n) {
      const c = this.uppy.getFile(l);
      if (c != null && c.data)
        try {
          const d = c.data, u = this.opts.chunkSize ?? Cs, h = d.size <= u ? await this.uploadSingle(c, d) : await this.uploadChunked(c, d, u);
          this.uppy.emit("upload-success", c, {
            status: 200,
            body: typeof h == "object" && h !== null ? h : { result: h }
          }), (s = (r = this.opts).onUploadSuccess) == null || s.call(r, Ts(c), h);
        } catch (d) {
          const u = d instanceof Error ? d : new Error(String(d));
          this.uppy.emit("upload-error", c, u), (o = (a = this.opts).onUploadError) == null || o.call(a, Ts(c), u);
        }
    }
  }
  // -- Single-request upload (small files)
  async uploadSingle(n, r) {
    const s = new FormData(), a = new Blob([r], { type: this.resolveMimeType(n) });
    s.append("file", a, n.name);
    const o = await fetch(this.opts.endpoint, {
      method: "POST",
      headers: this.resolveHeaders(),
      body: s
    });
    if (!o.ok) {
      const c = await o.text().catch(() => "");
      throw new Error(`Upload failed (${o.status}): ${c}`);
    }
    this.uppy.emit("upload-progress", n, {
      uploadStarted: Date.now(),
      bytesUploaded: r.size,
      bytesTotal: r.size
    });
    const l = await o.text();
    try {
      return JSON.parse(l);
    } catch {
      return l;
    }
  }
  // -- Chunked upload (large files — S3 multipart via backend)
  async uploadChunked(n, r, s) {
    const a = Math.ceil(r.size / s);
    let o = "", l = [], c = {};
    const d = n.name.includes(".") ? n.name.slice(n.name.lastIndexOf(".")) : "", u = `${crypto.randomUUID()}${d}`, h = this.opts.endpoint;
    if (!/\/upload$/.test(h))
      throw new Error(
        `ChunkedUploadPlugin: "endpoint" must end with "/upload" (no trailing slash or query params). Received: ${h}`
      );
    const f = h.replace(/\/upload$/, "/upload-chunk");
    for (let y = 0; y < a; y++) {
      const p = y * s, v = Math.min(p + s, r.size), b = r.slice(p, v), x = new FormData();
      x.append("chunk", String(y)), x.append("chunks", String(a)), x.append("name", u), x.append("OriginalFilename", n.name), x.append("UploadID", o), x.append("ETagList", JSON.stringify(l));
      const w = new Blob([b], { type: this.resolveMimeType(n) });
      x.append("file", w, u);
      const S = await fetch(f, {
        method: "POST",
        headers: this.resolveHeaders(),
        body: x
      });
      if (!S.ok) {
        const N = await S.text().catch(() => "");
        throw new Error(`Chunk ${y + 1}/${a} failed (${S.status}): ${N}`);
      }
      const k = await S.json().catch(() => ({}));
      c = typeof k == "object" && k !== null ? k : {}, typeof c.uploadID == "string" && (o = c.uploadID), Array.isArray(c.eTagList) && (l = c.eTagList), this.uppy.emit("upload-progress", n, {
        uploadStarted: Date.now(),
        bytesUploaded: v,
        bytesTotal: r.size
      });
    }
    return c;
  }
}
function Zu(e) {
  return Math.min(100, Math.max(0, e));
}
const Ca = T.forwardRef(
  ({ className: e, value: t, ...n }, r) => {
    const s = Zu(t);
    return /* @__PURE__ */ i(
      xs.Root,
      {
        ref: r,
        "data-slot": "progress-bar",
        value: s,
        max: 100,
        className: g("relative h-2 w-full overflow-hidden rounded-full bg-layer-muted", e),
        ...n,
        children: /* @__PURE__ */ i(
          xs.Indicator,
          {
            "data-slot": "progress-bar-indicator",
            className: "h-full w-full bg-brand-primary transition-transform duration-300 ease-out motion-reduce:transition-none",
            style: { transform: `translateX(-${100 - s}%)` }
          }
        )
      }
    );
  }
);
Ca.displayName = "ProgressBar";
function Ma({
  label: e,
  completeLabel: t,
  value: n,
  showPercentage: r = !0,
  className: s
}) {
  const a = T.useId(), o = Math.round(Math.min(100, Math.max(0, n))), c = o === 100 && t !== void 0 ? t : e;
  return /* @__PURE__ */ m("div", { "data-slot": "labeled-progress-bar", className: g("flex w-full flex-col gap-2", s), children: [
    /* @__PURE__ */ i(Ca, { value: o, "aria-labelledby": a }),
    /* @__PURE__ */ m("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ i(B, { as: "caption", id: a, className: "text-ink-secondary", children: c }),
      r && /* @__PURE__ */ m(B, { as: "label", className: "tabular-nums", children: [
        o,
        "%"
      ] })
    ] })
  ] });
}
Ma.displayName = "LabeledProgressBar";
function yn({ children: e }) {
  return /* @__PURE__ */ i("div", { className: "flex size-10 shrink-0 items-center justify-center rounded-lg bg-layer-accent shadow-small-grey stroke-stroke-primary", children: e });
}
function ar({
  label: e,
  onClick: t,
  disabled: n
}) {
  return /* @__PURE__ */ i(
    O,
    {
      variant: "tertiary",
      size: "sm",
      className: "text-action-primary",
      label: e,
      disabled: n,
      onClick: (r) => {
        r.stopPropagation(), t();
      }
    }
  );
}
function Pa({
  state: e,
  prompt: t,
  selectLabel: n,
  messages: r,
  onSelectFile: s,
  icon: a,
  fileName: o,
  progress: l = 0,
  formatErrorAction: c,
  disabled: d,
  selectAnotherLabel: u = "Select another file",
  clearLabel: h = "Clear selected file",
  onClearFile: f
}) {
  if (e === "selected")
    return /* @__PURE__ */ m(re, { children: [
      /* @__PURE__ */ i(yn, { children: /* @__PURE__ */ i(Ns, { size: "lg" }) }),
      /* @__PURE__ */ m("div", { className: "flex w-full flex-col items-center gap-4 text-center", children: [
        o !== void 0 && /* @__PURE__ */ i(B, { as: "label", className: "block max-w-full truncate", title: o, children: o }),
        /* @__PURE__ */ m("div", { className: "flex items-center justify-center gap-2", children: [
          f !== void 0 && /* @__PURE__ */ i(
            O,
            {
              variant: "tertiary",
              size: "sm",
              label: h,
              disabled: d,
              onClick: (y) => {
                y.stopPropagation(), f();
              }
            }
          ),
          /* @__PURE__ */ i(
            O,
            {
              variant: "primary",
              size: "sm",
              label: u,
              disabled: d,
              onClick: (y) => {
                y.stopPropagation(), s();
              }
            }
          )
        ] })
      ] })
    ] });
  if (e === "uploading" || e === "success")
    return /* @__PURE__ */ m(re, { children: [
      o !== void 0 && /* @__PURE__ */ i(B, { as: "label", className: "block max-w-full truncate text-center", title: o, children: o }),
      /* @__PURE__ */ i(
        Ma,
        {
          className: "max-w-125",
          label: r.uploading,
          completeLabel: r.success,
          value: e === "success" ? 100 : l
        }
      )
    ] });
  if (e === "error-size") {
    const { title: y, description: p, actionLabel: v } = r.sizeError;
    return /* @__PURE__ */ m(re, { children: [
      /* @__PURE__ */ i(yn, { children: /* @__PURE__ */ i(nu, { size: "lg" }) }),
      /* @__PURE__ */ m("div", { className: "flex w-full flex-col items-center gap-2 text-center", children: [
        /* @__PURE__ */ i(B, { as: "label", className: "uppercase", children: y }),
        p !== void 0 && /* @__PURE__ */ i(B, { as: "label", children: p }),
        /* @__PURE__ */ i(ar, { label: v, onClick: s, disabled: d })
      ] })
    ] });
  }
  if (e === "error-format") {
    const { title: y, description: p, actionLabel: v } = r.formatError;
    return /* @__PURE__ */ m(re, { children: [
      /* @__PURE__ */ i(yn, { children: /* @__PURE__ */ i(Ns, { size: "lg" }) }),
      /* @__PURE__ */ m("div", { className: "flex w-full flex-col items-center gap-2 text-center", children: [
        /* @__PURE__ */ i(B, { as: "label", className: "uppercase", children: y }),
        p !== void 0 && /* @__PURE__ */ i(B, { as: "label", children: p }),
        /* @__PURE__ */ m("div", { className: "flex items-center justify-center gap-2", children: [
          c !== void 0 && /* @__PURE__ */ i(
            ar,
            {
              label: c.label,
              onClick: c.onClick,
              disabled: d
            }
          ),
          /* @__PURE__ */ i(
            O,
            {
              variant: "primary",
              size: "sm",
              label: v,
              disabled: d,
              onClick: (b) => {
                b.stopPropagation(), s();
              }
            }
          )
        ] })
      ] })
    ] });
  }
  return /* @__PURE__ */ m(re, { children: [
    /* @__PURE__ */ i(yn, { children: a ?? /* @__PURE__ */ i(su, { size: "lg" }) }),
    /* @__PURE__ */ m("div", { className: "flex w-full flex-col items-center gap-1 text-center", children: [
      /* @__PURE__ */ i(B, { as: "label", className: "uppercase", children: t }),
      /* @__PURE__ */ m("div", { className: "flex items-center justify-center gap-2", children: [
        /* @__PURE__ */ i(B, { as: "label", className: "uppercase", children: "or" }),
        /* @__PURE__ */ i(ar, { label: n, onClick: s, disabled: d })
      ] })
    ] })
  ] });
}
Pa.displayName = "DropzoneBody";
const qu = [];
function Da({
  formats: e = qu,
  formatsLabel: t = "Supported format",
  maxSizeLabel: n,
  maxSizeText: r = "Maximum size"
}) {
  const s = e.length > 0, a = n !== void 0;
  return !s && !a ? null : /* @__PURE__ */ m("div", { "data-slot": "dropzone-footer", className: "flex w-full items-center justify-between gap-4 pt-1", children: [
    s ? /* @__PURE__ */ m("div", { className: "flex flex-wrap items-center gap-2", children: [
      /* @__PURE__ */ m(B, { as: "sectionLabel", children: [
        t,
        " :"
      ] }),
      e.map((o) => /* @__PURE__ */ i(Ar, { variant: "sand", children: o }, o))
    ] }) : /* @__PURE__ */ i("span", {}),
    a && /* @__PURE__ */ m("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ i(B, { as: "sectionLabel", children: r }),
      /* @__PURE__ */ i(Ar, { variant: "sand", children: n })
    ] })
  ] });
}
Da.displayName = "DropzoneFooter";
const Ju = {
  "application/vnd.v21": [".v21"],
  "text/plain": [".txt"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.ms-excel.sheet.macroEnabled.12": [".xlsm"]
};
function Qu(e) {
  return e !== void 0 ? Object.keys(e).length > 0 ? e : void 0 : Ju;
}
function eh(e) {
  if (!e)
    return;
  const t = [];
  for (const [n, r] of Object.entries(e)) {
    t.push(n);
    for (const s of r)
      t.includes(s) || t.push(s);
  }
  return t.length > 0 ? t : void 0;
}
function Ia(e) {
  if (e <= 0)
    return "0 B";
  const t = 1024, n = ["B", "KB", "MB", "GB", "TB", "PB"], r = Math.min(n.length - 1, Math.floor(Math.log(e) / Math.log(t)));
  return `${Number.parseFloat((e / t ** r).toFixed(1))} ${n[r]}`;
}
function th(e) {
  const t = new Set(e.flatMap((n) => n.errors.map((r) => r.code)));
  return t.has("file-too-large") ? "size" : t.has("file-invalid-type") ? "format" : null;
}
function nh({ isDragActive: e, uploadStatus: t, rejectionError: n, hasSelectedFile: r = !1 }) {
  return t === "uploading" || t === "paused" ? "uploading" : e ? "dragging" : t === "complete" ? "success" : n === "size" ? "error-size" : n === "format" ? "error-format" : r ? "selected" : "idle";
}
function rh(e) {
  if (e.length !== 0)
    return e.length === 1 ? e[0] : `${e.length} files`;
}
function ih(e, t) {
  return e !== void 0 ? e : t !== void 0 ? Ia(t) : void 0;
}
function sh(e, { maxSizeLabel: t, acceptedFormats: n } = {}) {
  var a, o, l, c, d, u;
  const r = t !== void 0 ? `The limit is ${t}.` : void 0, s = n !== void 0 && n.length > 0 ? `Accepted formats: ${n.join(", ")}.` : void 0;
  return {
    uploading: (e == null ? void 0 : e.uploading) ?? "Uploading...",
    success: (e == null ? void 0 : e.success) ?? "Upload successful",
    sizeError: {
      title: ((a = e == null ? void 0 : e.sizeError) == null ? void 0 : a.title) ?? "File exceeds maximum size",
      description: ((o = e == null ? void 0 : e.sizeError) == null ? void 0 : o.description) ?? r,
      actionLabel: ((l = e == null ? void 0 : e.sizeError) == null ? void 0 : l.actionLabel) ?? "Upload another file"
    },
    formatError: {
      title: ((c = e == null ? void 0 : e.formatError) == null ? void 0 : c.title) ?? "File format not supported",
      description: ((d = e == null ? void 0 : e.formatError) == null ? void 0 : d.description) ?? s,
      actionLabel: ((u = e == null ? void 0 : e.formatError) == null ? void 0 : u.actionLabel) ?? "Select another file"
    }
  };
}
function oh({
  state: e,
  isTunecore: t = !1,
  disabled: n = !1
}) {
  return g(
    "flex min-h-52 w-full flex-col items-center justify-center gap-10 border-2 border-stroke-primary bg-layer-accent p-6 outline-none transition-all duration-200",
    t ? "rounded-lg" : "rounded-sm",
    e === "selected" || e === "dragging" || e === "uploading" || e === "success" ? "border-solid" : "border-dashed",
    e === "dragging" && "shadow-md-orange",
    n ? "cursor-not-allowed" : "cursor-pointer",
    // focus-visible, not react-dropzone's isFocused: that flag also flips when a button inside the box takes focus, which drew a second outline mid-upload.
    "focus-visible:ring-2 focus-visible:ring-stroke-primary focus-visible:ring-offset-2"
  );
}
function vn(e) {
  return { id: e.id, name: e.name, size: e.size ?? 0, type: e.type ?? "" };
}
const Aa = ({
  files: e,
  onRemoveFile: t,
  onClearAll: n,
  onUploadStart: r,
  disabled: s,
  autoUpload: a = !1,
  multiple: o
}) => {
  const { uppy: l, status: c } = aa(), d = Me(c);
  Ue(() => {
    d.current !== "uploading" && c === "uploading" && (r == null || r(e.length)), d.current = c;
  }, [c, r, e.length]);
  const [u, h] = ne({}), [f, y] = ne({});
  Ue(() => {
    if (c !== "uploading" && c !== "paused" && c !== "complete" && c !== "error")
      return;
    const N = () => {
      const C = l.getState(), M = {}, R = {};
      for (const [D, V] of Object.entries(C.files)) {
        const L = V;
        M[D] = L.progress, R[D] = L.error ?? null;
      }
      h(M), y(R);
    };
    if (N(), c === "complete" || c === "error")
      return;
    const A = window.setInterval(N, 250);
    return () => window.clearInterval(A);
  }, [l, c]);
  const p = c === "uploading" || c === "paused", v = c === "complete", b = c === "error", x = e.length > 0, w = p || s === !0, S = Re((N) => {
    N.stopPropagation(), l.upload();
  }, [l]), k = Re((N) => {
    N.stopPropagation(), n();
  }, [n]);
  return x ? /* @__PURE__ */ m("div", { className: "flex w-full flex-col gap-2", children: [
    /* @__PURE__ */ i("div", { className: "flex flex-col gap-1", children: e.map((N) => {
      const A = u[N.id] ?? N.progress, C = (A == null ? void 0 : A.percentage) ?? 0, M = (A == null ? void 0 : A.uploadComplete) === !0, R = f[N.id] ?? N.error ?? null;
      return /* @__PURE__ */ m("div", { className: "flex items-center gap-2 text-xs", children: [
        /* @__PURE__ */ m("span", { className: "flex-1 truncate", title: N.name, children: [
          N.name,
          /* @__PURE__ */ m("span", { className: "ml-1 text-ink-secondary", children: [
            "(",
            Ia(N.size ?? 0),
            ")"
          ] })
        ] }),
        M && /* @__PURE__ */ i("span", { className: "text-ink-success", children: "Done" }),
        R != null && /* @__PURE__ */ i("span", { className: "text-ink-error", title: R, children: "Failed" }),
        !M && R == null && p && /* @__PURE__ */ m("span", { className: "text-ink-secondary tabular-nums", children: [
          C,
          "%"
        ] }),
        /* @__PURE__ */ i(
          "button",
          {
            type: "button",
            className: "text-ink-secondary hover:text-ink-error transition-colors px-1",
            onClick: (D) => {
              D.stopPropagation(), t(N.id);
            },
            "aria-label": `Remove file ${N.name}`,
            title: "Remove file",
            disabled: w,
            children: "✕"
          }
        )
      ] }, N.id);
    }) }),
    /* @__PURE__ */ m("div", { className: "flex items-center gap-2 self-end", children: [
      v && /* @__PURE__ */ i("span", { className: "text-xs text-ink-success font-medium", children: o ? "All uploads complete" : "Upload complete" }),
      o && /* @__PURE__ */ i(
        O,
        {
          variant: "secondary",
          size: "sm",
          label: "Clear all",
          onClick: k,
          disabled: w
        }
      ),
      !a && !p && !v && /* @__PURE__ */ i(
        O,
        {
          variant: "primary",
          size: "sm",
          label: "Upload",
          disabled: e.length === 0 || w,
          onClick: S
        }
      ),
      b && !p && /* @__PURE__ */ i(
        O,
        {
          variant: "primary",
          size: "sm",
          label: "Retry",
          disabled: w,
          onClick: S
        }
      )
    ] })
  ] }) : null;
};
Aa.displayName = "UploadModeContent";
const yi = ({
  rootProps: e,
  inputProps: t,
  bodyProps: n,
  isDragActive: r,
  isTunecore: s,
  disabled: a,
  rejectionError: o,
  hasSelectedFile: l,
  uploadStatus: c,
  progress: d,
  children: u
}) => {
  const h = nh({ isDragActive: r, uploadStatus: c, rejectionError: o, hasSelectedFile: l });
  return /* @__PURE__ */ m(
    "div",
    {
      ...e,
      className: oh({ state: h, isTunecore: s, disabled: a }),
      children: [
        /* @__PURE__ */ i(
          "input",
          {
            ...t,
            "aria-label": "Upload file - drag and drop a file here, or click to select a file",
            title: "Upload file - supports drag and drop or click to browse"
          }
        ),
        /* @__PURE__ */ i(Pa, { ...n, state: h, progress: d }),
        u
      ]
    }
  );
};
yi.displayName = "DropzoneSurface";
const Ea = (e) => {
  const { status: t, progress: n } = aa();
  return /* @__PURE__ */ i(yi, { ...e, uploadStatus: t, progress: n });
};
Ea.displayName = "UploadAwareSurface";
const ah = ({
  endpoint: e,
  headers: t,
  onUploadSuccess: n,
  onUploadError: r,
  onUploadStart: s,
  autoUpload: a = !1,
  onFilesAdded: o,
  onFileRemoved: l,
  multiple: c = !1,
  chunkSize: d,
  accept: u,
  disabled: h,
  label: f,
  useFsAccessApi: y = !0,
  uploadMimeType: p,
  prompt: v,
  selectLabel: b = "Select file",
  selectAnotherLabel: x,
  clearLabel: w,
  acceptedFormats: S,
  formatsLabel: k,
  maxSizeBytes: N,
  maxSizeLabel: A,
  maxSizeText: C,
  icon: M,
  formatErrorAction: R,
  messages: D,
  // Legacy props
  onFileAccepted: V,
  file: L,
  onClick: Q
}) => {
  const le = H((X) => X.isTunecore), _ = e !== void 0 && e !== "", G = Qu(u), me = en(
    () => eh(G),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- stable reference from resolveAccept
    [JSON.stringify(G)]
  ), [K] = ne(a), [j] = ne(() => {
    if (!_)
      return null;
    const X = new pd({
      autoProceed: K,
      restrictions: {
        maxNumberOfFiles: c ? null : 1,
        maxFileSize: N ?? null,
        allowedFileTypes: me ?? null
      }
    });
    return X.use(Ms, {
      id: "ChunkedUpload",
      endpoint: e,
      headers: t,
      chunkSize: d,
      onUploadSuccess: n,
      onUploadError: r,
      uploadMimeType: p
    }), X;
  });
  Ue(() => () => {
    j == null || j.cancelAll();
  }, [j]), Ue(() => {
    if (!j)
      return;
    const X = j.getPlugin("ChunkedUpload");
    X && X instanceof Ms && (X.opts.headers = t, X.opts.onUploadSuccess = n, X.opts.onUploadError = r, X.opts.uploadMimeType = p);
  }, [j, t, n, r, p]);
  const [ie, ue] = ne([]), [je, ke] = ne(null), Ie = Re((X) => {
    j && j.removeFile(X);
    const U = ie.find((de) => de.id === X);
    ue((de) => de.filter((z) => z.id !== X)), U !== void 0 && (l == null || l(vn(U)));
  }, [j, ie, l]), mt = Re(() => {
    j && j.cancelAll();
    const X = ie;
    ue([]), X.forEach((U) => l == null ? void 0 : l(vn(U))), ke(null);
  }, [j, ie, l]), se = Re((X, U = []) => {
    if (ke(th(U)), _ && j) {
      if (!c) {
        const z = Object.keys(j.getState().files);
        for (const $ of z)
          j.removeFile($);
        ie.forEach(($) => l == null ? void 0 : l(vn($))), ue([]);
      }
      const de = [];
      for (const z of X)
        try {
          const $ = j.addFile({
            name: z.name,
            type: z.type || "application/octet-stream",
            data: z,
            source: "local"
          });
          $ && de.push({
            id: typeof $ == "string" ? $ : z.name,
            name: z.name,
            size: z.size,
            type: z.type
          });
        } catch {
        }
      de.length > 0 && (ue((z) => [...z, ...de]), o == null || o(de.map(vn)));
    } else V != null && X[0] != null && V(X[0]);
  }, [_, j, c, V, o, l, ie]), { getRootProps: tt, getInputProps: an, open: nt, isDragActive: gt } = yd({
    onDrop: se,
    accept: G,
    maxSize: N,
    disabled: h,
    multiple: _ ? c : !1,
    useFsAccessApi: y
  }), Ae = !_ && L != null, Se = ih(A, N), ge = sh(D, { maxSizeLabel: Se, acceptedFormats: S }), rt = {
    prompt: v ?? (_ && c ? "Drag and drop files here" : "Drag and drop a file here"),
    selectLabel: b,
    selectAnotherLabel: x,
    clearLabel: w,
    onClearFile: Q,
    icon: M,
    messages: ge,
    formatErrorAction: R,
    disabled: h,
    onSelectFile: nt,
    fileName: Ae ? L.name : rh(ie.map((X) => X.name))
  }, Ne = {
    rootProps: tt(),
    inputProps: an(),
    bodyProps: rt,
    isDragActive: gt,
    isTunecore: le,
    disabled: h,
    rejectionError: je,
    hasSelectedFile: Ae
  }, Te = /* @__PURE__ */ m("div", { className: "flex w-full flex-col gap-1.5", children: [
    f != null && f !== "" && /* @__PURE__ */ i(B, { as: "bodySm", className: "font-medium", children: f }),
    /* @__PURE__ */ m("div", { children: [
      _ && j ? /* @__PURE__ */ i(Ea, { ...Ne, children: /* @__PURE__ */ i(
        Aa,
        {
          files: ie,
          onRemoveFile: Ie,
          onClearAll: mt,
          onUploadStart: s,
          disabled: h,
          autoUpload: K,
          multiple: c
        }
      ) }) : /* @__PURE__ */ i(yi, { ...Ne }),
      /* @__PURE__ */ i(
        Da,
        {
          formats: S,
          formatsLabel: k,
          maxSizeLabel: Se,
          maxSizeText: C
        }
      )
    ] })
  ] });
  return _ && j ? /* @__PURE__ */ i(
    gd,
    {
      uppy: j,
      children: Te
    }
  ) : Te;
};
ah.displayName = "FileDropzone";
const lh = Be(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), Va = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  la.Root,
  {
    ref: n,
    className: g(lh(), e),
    ...t
  }
));
Va.displayName = la.Root.displayName;
const d1 = bd, La = T.createContext(
  {}
), Ra = T.createContext(
  {}
);
function Gn() {
  const e = T.useContext(La), t = T.useContext(Ra), { id: n } = t;
  if (!e.name)
    return {
      id: n,
      name: "",
      formItemId: `${n}-form-item`,
      formDescriptionId: `${n}-form-item-description`,
      formMessageId: `${n}-form-item-message`,
      invalid: !1,
      isDirty: !1,
      isTouched: !1,
      isValidating: !1
    };
  const { getFieldState: r, formState: s } = vd(), a = r(e.name, s);
  return {
    id: n,
    name: e.name,
    formItemId: `${n}-form-item`,
    formDescriptionId: `${n}-form-item-description`,
    formMessageId: `${n}-form-item-message`,
    ...a
  };
}
function u1({
  ...e
}) {
  const t = T.useMemo(
    () => ({ name: e.name }),
    [e.name]
  );
  return /* @__PURE__ */ i(La.Provider, { value: t, children: /* @__PURE__ */ i(xd, { ...e }) });
}
const ch = T.forwardRef(({ className: e, ...t }, n) => {
  const r = T.useId(), s = T.useMemo(() => ({ id: r }), [r]);
  return /* @__PURE__ */ i(Ra.Provider, { value: s, children: /* @__PURE__ */ i("div", { ref: n, className: g("", e), ...t }) });
});
ch.displayName = "FormItem";
const dh = T.forwardRef(({ className: e, smallFont: t, required: n, children: r, ...s }, a) => {
  const { error: o, formItemId: l } = Gn(), c = H((d) => d.isTunecore);
  return /* @__PURE__ */ m(
    Va,
    {
      ref: a,
      className: g(
        o && "",
        "text-ink-primary",
        c ? "font-tunecore" : "font-sentric-alt",
        t ? "text-xs" : "text-sm font-medium",
        "leading-snug inline-flex",
        e
      ),
      htmlFor: l,
      ...s,
      children: [
        r,
        n && /* @__PURE__ */ i(B, { className: "ml-1", "aria-label": "required", children: "*" })
      ]
    }
  );
});
dh.displayName = "FormLabel";
const uh = T.forwardRef(({ ...e }, t) => {
  const { error: n, formItemId: r, formDescriptionId: s, formMessageId: a } = Gn();
  return /* @__PURE__ */ i(
    tn,
    {
      ref: t,
      id: r,
      "aria-describedby": n ? `${s} ${a}` : `${s}`,
      "aria-invalid": !!n,
      ...e
    }
  );
});
uh.displayName = "FormControl";
const hh = T.forwardRef(({ className: e, ...t }, n) => {
  const { formDescriptionId: r } = Gn();
  return /* @__PURE__ */ i(
    "p",
    {
      ref: n,
      id: r,
      className: g("text-sm text-muted-foreground", e),
      ...t
    }
  );
});
hh.displayName = "FormDescription";
const fh = T.forwardRef(({ className: e, children: t, ...n }, r) => {
  const { error: s, formMessageId: a } = Gn(), o = s == null ? void 0 : s.message;
  let l;
  return typeof o == "string" && o !== "undefined" && o !== "" ? l = o : l = t, l == null || l === "" ? null : /* @__PURE__ */ i(
    B,
    {
      as: "bodySm",
      ref: r,
      id: a,
      className: g(
        "text-ink-error font-medium",
        e
      ),
      ...n,
      children: l
    }
  );
});
fh.displayName = "FormMessage";
const ph = [], mh = [];
function gh() {
  return /* @__PURE__ */ m(re, { children: [
    /* @__PURE__ */ m(
      "svg",
      {
        "aria-hidden": "true",
        className: "absolute -left-px -top-px h-[calc(100%+2px)] w-auto overflow-visible opacity-0 transition-opacity duration-150 ease-out motion-reduce:transition-none group-data-[state=checked]/mark:opacity-100",
        fill: "none",
        viewBox: "0 0 18 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ i("path", { d: "M13.5 0.5H2A1.5 1.5 0 0 0 0.5 2V14A1.5 1.5 0 0 0 2 15.5H14A1.5 1.5 0 0 0 15.5 14V7.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1", vectorEffect: "non-scaling-stroke" }),
          /* @__PURE__ */ i("path", { d: "M3.25 7.08L7.55 11.39L16.5 2.44", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.16667", vectorEffect: "non-scaling-stroke" })
        ]
      }
    ),
    /* @__PURE__ */ i("span", { className: "relative flex size-4 items-center justify-center", children: /* @__PURE__ */ i(
      "svg",
      {
        "aria-hidden": "true",
        className: "absolute opacity-0 transition-opacity duration-150 ease-out motion-reduce:transition-none group-data-[state=indeterminate]/mark:opacity-100",
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ i("path", { d: "M4 8L12 8", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5" })
      }
    ) })
  ] });
}
const Vr = T.forwardRef(({
  className: e,
  smallFont: t = !1,
  column: n = !1,
  label: r = "",
  secondaryLabel: s,
  id: a,
  checked: o,
  onCheckedChange: l,
  onChange: c,
  defaultChecked: d,
  disabled: u = !1,
  isList: h = !1,
  options: f = ph,
  showSelectAll: y = !0,
  onSelectionChange: p,
  selectedValues: v = mh,
  tableHeader: b = !1,
  ...x
}, w) => {
  const S = T.useId(), k = a ?? `form-checkbox-${S}`, N = `${k}-label`, A = `${k}-secondary-label`, C = r !== "" || s !== void 0, M = T.useMemo(
    () => v.length === f.length && f.length > 0,
    [v, f.length]
  ), R = (L) => {
    p && p(
      v.includes(L) ? v.filter((Q) => Q !== L) : [...v, L]
    );
  }, D = (L) => {
    const Q = L === !0;
    l == null || l(Q), c && c({
      target: { checked: Q },
      currentTarget: { checked: Q }
    });
  }, V = /* @__PURE__ */ i(
    ws.Root,
    {
      id: k,
      ref: w,
      "aria-describedby": s !== void 0 ? A : void 0,
      "aria-labelledby": r !== "" ? N : void 0,
      checked: o,
      defaultChecked: d,
      disabled: u,
      onCheckedChange: D,
      className: g(
        "relative flex shrink-0 cursor-pointer items-center justify-center rounded-[2px] border bg-transparent outline-none transition-colors duration-150 ease-out motion-reduce:transition-none focus-visible:ring-2 focus-visible:ring-action-primary focus-visible:ring-offset-2 disabled:pointer-events-none",
        !C && "disabled:opacity-25",
        C || b ? "size-6" : "size-4",
        "border-ink-primary text-ink-primary data-[state=checked]:border-transparent data-[state=checked]:text-ink-accent",
        e
      ),
      ...x,
      children: /* @__PURE__ */ i(ws.Indicator, { forceMount: !0, className: "group/mark", children: /* @__PURE__ */ i(gh, {}) })
    }
  );
  return h ? /* @__PURE__ */ m("div", { className: "flex flex-col items-start gap-4", children: [
    y && f.length > 0 && /* @__PURE__ */ i(
      Vr,
      {
        checked: M,
        label: "Select all",
        onCheckedChange: (L) => p == null ? void 0 : p(L ? f.map((Q) => Q.value) : [])
      }
    ),
    f.map((L) => /* @__PURE__ */ i(
      Vr,
      {
        checked: v.includes(L.value),
        label: L.label,
        onCheckedChange: () => R(L.value)
      },
      L.value
    ))
  ] }) : C ? /* @__PURE__ */ m(
    "div",
    {
      className: g(
        n ? "flex flex-col-reverse items-start gap-4" : "flex items-center gap-4",
        u && "pointer-events-none opacity-25"
      ),
      children: [
        V,
        /* @__PURE__ */ m("label", { className: "flex min-w-0 cursor-pointer flex-col gap-2 whitespace-nowrap overflow-clip [text-box-edge:cap_alphabetic] [text-box-trim:trim-both]", htmlFor: k, children: [
          r !== "" && /* @__PURE__ */ i(B, { as: t ? "label" : "bodySm", id: N, children: r }),
          s !== void 0 && /* @__PURE__ */ i(B, { as: "label", className: "text-ink-secondary", id: A, children: s })
        ] })
      ]
    }
  ) : V;
});
Vr.displayName = "FormCheckbox";
const yh = T.forwardRef(
  ({ className: e, smallFont: t, type: n, hasError: r, errorMessage: s, customWidth: a, label: o, ...l }, c) => {
    const d = H((p) => p.isTunecore), u = l["aria-invalid"] === !0 || r || s !== void 0 && s !== "", f = `formTextInput-${T.useId()}`, y = (p) => {
      const v = p ? { id: f, name: f } : {};
      return p ? /* @__PURE__ */ i(
        "input",
        {
          type: n,
          className: g(
            "flex font-medium px-2 py-1.5  focus-visible:outline-none transition ease-out duration-200",
            // TuneCore predates this radius token system and has no spec
            // of its own — keep its original rounded-lg (8px) rather than
            // silently inheriting Sentric's new rounded-sm (6px).
            d ? "rounded-lg" : "rounded-sm",
            a ? "" : "w-full",
            t ? "text-xs" : "text-sm",
            d ? "font-tunecore text-white placeholder:text-white/50 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary bg-layer-raised" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
            u && (d ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary bg-layer-error"),
            e
          ),
          ref: c,
          ...v,
          ...l
        }
      ) : /* @__PURE__ */ i(
        "input",
        {
          type: n,
          className: g(
            "flex font-medium px-2 py-1.5 focus-visible:outline-none transition ease-out duration-200",
            // TuneCore predates this radius token system and has no spec
            // of its own — keep its original rounded-lg (8px) rather than
            // silently inheriting Sentric's new rounded-sm (6px).
            d ? "rounded-lg" : "rounded-sm",
            a ? "" : "w-full",
            t ? "text-xs" : "text-sm",
            d ? "font-tunecore text-white bg-layer-raised placeholder:text-white/35 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-stroke-primary" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
            u && (d ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary bg-layer-error"),
            e
          ),
          ref: c,
          ...v,
          ...l
        }
      );
    };
    return o == null || o === "" ? s !== void 0 && s !== "" ? /* @__PURE__ */ m("div", { className: g("flex flex-col", a ? "" : "w-full"), children: [
      y(!1),
      /* @__PURE__ */ i(
        B,
        {
          className: g(
            "text-ink-error",
            t ? "text-[10px]" : "text-xs"
          ),
          children: s
        }
      )
    ] }) : y(!1) : /* @__PURE__ */ m("div", { className: g("flex flex-col justify-between", a ? "" : "w-full"), children: [
      /* @__PURE__ */ i(
        "label",
        {
          className: g(
            "leading-snug self-start",
            t ? "text-xs" : "text-base",
            "text-ink-primary",
            d ? "font-tunecore" : "font-sentric-alt"
          ),
          htmlFor: f,
          children: o
        }
      ),
      y(!0),
      s !== void 0 && s !== "" && /* @__PURE__ */ i(
        B,
        {
          className: g(
            "text-ink-error",
            t ? "text-[10px]" : "text-xs"
          ),
          children: s
        }
      )
    ] });
  }
);
yh.displayName = "FormInput";
const vh = [], bh = T.forwardRef(
  ({
    className: e,
    smallFont: t,
    type: n = "text",
    hasError: r,
    customWidth: s,
    label: a,
    values: o = vh,
    onChange: l,
    placeholder: c,
    addButtonText: d = "Add another",
    minItems: u = 1,
    ...h
  }, f) => {
    const y = H((k) => k.isTunecore), p = h["aria-invalid"] === !0 || r;
    T.useEffect(() => {
      if (u > 0 && o.length < u) {
        const k = [...o];
        for (; k.length < u; )
          k.push("");
        l(k);
      }
    }, [o, u, l]);
    const v = (k, N) => {
      const A = [...o];
      A[k] = N, l(A);
    }, b = () => {
      l([...o, ""]);
    }, x = (k) => {
      if (o.length > u) {
        const N = o.filter((A, C) => C !== k);
        l(N);
      }
    }, w = g(
      "flex font-medium px-2 py-1.5 focus-visible:outline-none transition ease-out duration-200",
      // TuneCore predates this radius token system and has no spec of its
      // own — keep its original rounded-lg (8px) rather than silently
      // inheriting Sentric's new rounded-sm (6px).
      y ? "rounded-lg" : "rounded-sm",
      s ? "" : "w-full",
      t ? "text-xs" : "text-sm",
      y ? "font-tunecore bg-layer-raised placeholder:text-white/35 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-stroke-primary" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
      p && (y ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary bg-layer-error"),
      e
    ), S = () => {
      const k = o.length === 0 ? [""] : o, N = o.length === 0;
      return /* @__PURE__ */ m("div", { className: "space-y-2", children: [
        k.map((A, C) => /* @__PURE__ */ m("div", { className: "flex items-center gap-1", children: [
          /* @__PURE__ */ i(
            "input",
            {
              type: n,
              className: w,
              value: A,
              onChange: (M) => {
                N ? l([M.target.value]) : v(C, M.target.value);
              },
              placeholder: c,
              ref: C === 0 ? f : void 0,
              ...h
            }
          ),
          o.length > u && /* @__PURE__ */ i(
            O,
            {
              type: "button",
              variant: "link",
              onClick: () => x(C),
              className: "min-w-0 p-1",
              icon: /* @__PURE__ */ i(pa, { className: "h-5 w-5 stroke-ink-primary group-hover:stroke-ink-accent" })
            }
          )
        ] }, `input-${C}`)),
        /* @__PURE__ */ i(
          O,
          {
            type: "button",
            variant: "link",
            onClick: b,
            className: "flex items-center text-ink-accent",
            icon: /* @__PURE__ */ i(Jd, { className: "w-5 h-5" }),
            label: d
          }
        )
      ] });
    };
    return a == null || a === "" ? S() : /* @__PURE__ */ m("div", { className: g("flex flex-col justify-between", s ? "" : "w-full"), children: [
      /* @__PURE__ */ i(
        "label",
        {
          className: g(
            "leading-snug self-start mb-2",
            t ? "text-xs" : "text-base",
            y ? "font-tunecore" : "font-sentric-alt"
          ),
          children: a
        }
      ),
      S()
    ] });
  }
);
bh.displayName = "FormMultipleInput";
const xh = T.forwardRef(
  ({ hasError: e, errorMessage: t, smallFont: n, min: r, max: s, className: a, showPercentage: o = !1, ...l }, c) => {
    const d = H((h) => h.isTunecore), u = l["aria-invalid"] === !0 || e || t !== void 0 && t !== "";
    return /* @__PURE__ */ m("div", { className: "flex flex-col justify-between", children: [
      /* @__PURE__ */ i(
        "label",
        {
          className: g(
            "leading-snug self-start text-ink-primary",
            n ? "text-xs" : "text-base",
            d ? "font-tunecore" : "font-sentric-alt"
          ),
          htmlFor: "formNumberInput",
          children: l.label
        }
      ),
      /* @__PURE__ */ m("div", { className: "relative", children: [
        /* @__PURE__ */ i(
          "input",
          {
            min: r,
            max: s,
            id: "formNumberInput",
            name: "formNumberInput",
            type: "number",
            className: g(
              "flex font-medium px-2 py-1.5 min-w-24 focus-visible:outline-none transition ease-out duration-200",
              // TuneCore predates this radius token system and has no spec
              // of its own — keep its original rounded-lg (8px) rather than
              // silently inheriting Sentric's new rounded-sm (6px).
              d ? "rounded-lg" : "rounded-sm",
              o ? "pr-6" : "",
              // Add right padding when percentage is shown
              n ? "text-xs" : "text-sm",
              d ? "font-tunecore bg-layer-raised placeholder:text-white/35 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-stroke-primary" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
              u && (d ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-error bg-layer-error"),
              a
            ),
            ref: c,
            ...l
          }
        ),
        o && /* @__PURE__ */ i(
          "span",
          {
            className: g(
              "absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none",
              n ? "text-xs" : "text-sm",
              "text-ink-primary",
              d ? "font-tunecore" : "font-sentric-alt"
            ),
            children: "%"
          }
        )
      ] }),
      t !== void 0 && t !== "" && /* @__PURE__ */ i(
        "span",
        {
          className: g(
            "text-ink-error mt-0.5",
            n ? "text-[10px]" : "text-xs"
          ),
          children: t
        }
      )
    ] });
  }
);
xh.displayName = "NumberInput";
const wh = T.forwardRef(
  ({ className: e, smallFont: t, hasError: n, errorMessage: r, customWidth: s, label: a, rows: o, ...l }, c) => {
    const d = H((p) => p.isTunecore), u = l["aria-invalid"] === !0 || n || r !== void 0 && r !== "", f = `formTextarea-${T.useId()}`, y = (p) => {
      const v = p ? { id: f, name: f } : {};
      return p ? /* @__PURE__ */ i(
        "textarea",
        {
          rows: o ?? 4,
          className: g(
            "flex font-medium px-2 py-1.5 focus-visible:outline-none transition ease-out duration-200 resize-y",
            d ? "rounded-lg" : "rounded-sm",
            s ? "" : "w-full",
            t ? "text-xs" : "text-sm",
            d ? "font-tunecore text-ink-primary placeholder:text-white/50 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary bg-layer-raised" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
            u && (d ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary bg-layer-error"),
            e
          ),
          ref: c,
          ...v,
          ...l
        }
      ) : /* @__PURE__ */ i(
        "textarea",
        {
          rows: o ?? 4,
          className: g(
            "flex font-medium px-2 py-1.5 focus-visible:outline-none transition ease-out duration-200 resize-y",
            d ? "rounded-lg" : "rounded-sm",
            s ? "" : "w-full",
            t ? "text-xs" : "text-sm",
            d ? "font-tunecore text-ink-primary bg-layer-raised placeholder:text-white/35 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-stroke-primary" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
            u && (d ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary bg-layer-error"),
            e
          ),
          ref: c,
          ...v,
          ...l
        }
      );
    };
    return a == null || a === "" ? r !== void 0 && r !== "" ? /* @__PURE__ */ m("div", { className: g("flex flex-col", s ? "" : "w-full"), children: [
      y(!1),
      /* @__PURE__ */ i(
        B,
        {
          className: g(
            "text-ink-error",
            t ? "text-[10px]" : "text-xs"
          ),
          children: r
        }
      )
    ] }) : y(!1) : /* @__PURE__ */ m("div", { className: g("flex flex-col justify-between", s ? "" : "w-full"), children: [
      /* @__PURE__ */ i(
        "label",
        {
          className: g(
            "leading-snug self-start",
            t ? "text-xs" : "text-base",
            "text-ink-primary",
            d ? "font-tunecore" : "font-sentric-alt"
          ),
          htmlFor: f,
          children: a
        }
      ),
      y(!0),
      r !== void 0 && r !== "" && /* @__PURE__ */ i(
        B,
        {
          className: g(
            "text-ink-error",
            t ? "text-[10px]" : "text-xs"
          ),
          children: r
        }
      )
    ] });
  }
);
wh.displayName = "FormTextarea";
const za = "0 0 2342 278.32", Ps = { x: 117.08, y: 142.73 }, Ba = [
  {
    id: "s-dot",
    d: "M234.152 142.729C234.152 207.75 181.683 260.877 117.467 260.877C53.2513 260.877 -0.000976562 207.75 -0.000976562 142.729C-0.000976562 77.7079 52.4682 24.5811 116.684 24.5811C180.9 24.5811 234.152 76.915 234.152 142.729Z",
    offsetX: 1053.92
  },
  {
    id: "s-swoosh",
    d: "M371.2 103.082C309.333 97.5314 299.936 93.5668 299.936 81.6727C299.936 72.1574 309.333 65.8139 353.188 65.8139C399.392 65.8139 420.536 72.1574 420.536 89.6021H514.511C511.378 31.7175 455.777 0 353.188 0C312.466 0 278.008 5.55057 252.948 17.4447C282.707 50.7481 300.719 94.3597 300.719 142.729C300.719 149.865 299.936 157.002 299.152 164.138C315.598 167.31 335.176 169.689 356.32 171.275C422.886 176.032 431.5 179.204 431.5 193.477C431.5 204.578 422.886 212.508 367.284 212.508C346.923 212.508 317.164 210.922 288.972 207.75C281.924 227.573 270.96 245.811 258.43 261.67C286.622 273.564 324.212 278.321 371.2 278.321C467.524 278.321 525.475 256.912 525.475 189.512C525.475 118.941 463.608 111.011 371.2 103.082Z",
    offsetX: 781.79
  },
  {
    id: "E",
    d: "M554.267 7.13623V271.185H821.311V201.406H644.326V173.653H814.263V104.668H644.326V76.9148H821.311V7.13623H554.267Z",
    offsetX: 483.21
  },
  {
    id: "N",
    d: "M1107.75 7.13623V181.583L984.017 7.13623H850.104V271.185H940.946V96.7383L1063.9 271.185H1197.81V7.13623H1107.75Z",
    offsetX: 147.04
  },
  {
    id: "T",
    d: "M1226.6 7.13623V84.0513H1336.24V271.185H1427.08V84.0513H1537.5V7.13623H1226.6Z",
    offsetX: -211.05
  },
  {
    id: "R",
    d: "M1655.57 81.276V131.231H1745.63C1765.99 131.231 1780.87 131.231 1780.87 106.65C1780.87 82.0689 1765.99 82.0689 1745.63 82.0689H1655.57V81.276ZM1875.63 218.454V270.788H1785.57V233.52C1785.57 209.732 1780.09 203.389 1756.59 203.389H1656.35V270.788H1566.29V7.53271H1769.12C1841.17 7.53271 1877.19 37.6644 1877.19 93.1701C1877.19 133.61 1859.96 156.605 1828.64 167.706C1856.83 169.292 1875.63 186.737 1875.63 218.454Z",
    offsetX: -550.74
  },
  {
    id: "I",
    d: "M1996.04 7.53271H1905.98V270.788H1996.04V7.53271Z",
    offsetX: -780.01
  },
  {
    id: "C",
    d: "M2183.81 0C2277.78 0 2334.17 39.6469 2342 113.39H2245.68C2241.76 96.7385 2223.75 76.915 2183.81 76.915C2136.82 76.915 2118.81 104.668 2118.81 138.764C2118.81 173.654 2137.6 201.406 2183.81 201.406C2223.75 201.406 2241.76 181.583 2245.68 164.138H2342C2334.17 237.882 2278.57 278.321 2183.81 278.321C2083.57 278.321 2024.83 231.538 2024.83 138.764C2024.83 45.9904 2083.57 0 2183.81 0Z",
    offsetX: -1012.41
  }
], kh = {
  wave: { durationMs: 1600, staggerShare: 0.07 },
  reveal: { durationMs: 2400, staggerShare: 0 },
  draw: { durationMs: 2400, staggerShare: 0.045 }
};
function ja({
  variant: e = "reveal",
  durationMs: t,
  label: n = "Loading",
  className: r
}) {
  const s = kh[e], a = t ?? s.durationMs, { staggerShare: o } = s;
  return /* @__PURE__ */ i(
    "svg",
    {
      viewBox: za,
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className: g("sentric-logo-loader w-full", `sentric-logo-loader--${e}`, r),
      style: { "--sentric-logo-duration": `${a}ms` },
      role: n == null ? void 0 : "status",
      "aria-label": n ?? void 0,
      "aria-hidden": n == null ? !0 : void 0,
      children: /* @__PURE__ */ i("g", { className: "sentric-logo-loader__group", children: Ba.map((l, c) => {
        const d = l.id === "s-dot";
        return /* @__PURE__ */ i(
          "g",
          {
            className: g(
              "sentric-logo-loader__glyph",
              d && "sentric-logo-loader__glyph--dot"
            ),
            style: {
              "--sentric-logo-tx": `${l.offsetX}px`,
              ...o > 0 ? {
                "--sentric-logo-delay": `${Math.round(c * o * a)}ms`
              } : {}
            },
            children: d ? (
              // Nested group so the dot's pop-in scale composes with the
              // spread translate above it — two animations cannot share
              // one `transform`.
              /* @__PURE__ */ i(
                "g",
                {
                  className: "sentric-logo-loader__dot",
                  style: { transformOrigin: `${Ps.x}px ${Ps.y}px` },
                  children: /* @__PURE__ */ i("path", { className: "sentric-logo-loader__path", d: l.d, pathLength: 1 })
                }
              )
            ) : /* @__PURE__ */ i("path", { className: "sentric-logo-loader__path", d: l.d, pathLength: 1 })
          },
          l.id
        );
      }) })
    }
  );
}
const h1 = ({ loadingText: e = "Loading..." }) => wd.createPortal(
  /* @__PURE__ */ m(
    "div",
    {
      role: "status",
      "aria-live": "polite",
      className: "fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/10 backdrop-blur-xl",
      children: [
        /* @__PURE__ */ i(ja, { label: null, className: "w-1/4 mb-2 md:w-1/8 text-ink-primary" }),
        /* @__PURE__ */ i(B, { as: "subtitle", className: "text-ink-primary", children: e })
      ]
    }
  ),
  document.getElementById("loading-root")
), f1 = ({
  loadingText: e = "Loading..."
}) => /* @__PURE__ */ m(
  "div",
  {
    role: "status",
    "aria-live": "polite",
    className: "absolute inset-0 z-50 flex flex-col items-center justify-center overflow-hidden bg-black/10 rounded-md backdrop-blur-3xl",
    children: [
      /* @__PURE__ */ i(ja, { label: null, className: "w-48 max-w-[50%] text-ink-primary" }),
      /* @__PURE__ */ i(B, { as: "subtitle", className: "mt-4 text-center text-ink-primary", children: e })
    ]
  }
);
function p1({ title: e, className: t }) {
  return /* @__PURE__ */ i(
    "svg",
    {
      viewBox: za,
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className: g("w-full", t),
      role: e == null ? void 0 : "img",
      "aria-label": e,
      "aria-hidden": e == null ? !0 : void 0,
      children: Ba.map((n) => /* @__PURE__ */ i("path", { d: n.d }, n.id))
    }
  );
}
const Ds = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_API: "https://prd-sa-api.publishingdashboard.com/api/v1", VITE_CLARITY_PROJECT_ID: "sg99g0t7y3", VITE_CLONE_LIST_URL: "https://vws7dkrb5qhuu6ayzkjprt7h2a0ckuev.lambda-url.eu-west-1.on.aws/", VITE_LAUNCH_DARKLY_ID: "624d54bdea0454154cd0d09b", VITE_LOCIZE_API_KEY: "lz_api_NajclbNcjsYTfrCWn4MI4UKuQiSSjnEr", VITE_LOCIZE_PROJECT_ID: "5ee2f31f-72cc-4506-bfa8-8a10e34c5935", VITE_LOCIZE_VERSION: "production", VITE_OTEL_ENABLED: "true", VITE_OTEL_EXPORTER_URL: "/api/traces", VITE_RIGHTS_APP_URL: "https://admin.rightsapp.co.uk/", VITE_STAGE: "prd" }, Yt = /* @__PURE__ */ new Map(), bn = (e) => {
  const t = Yt.get(e);
  return t ? Object.fromEntries(
    Object.entries(t.stores).map(([n, r]) => [n, r.getState()])
  ) : {};
}, Sh = (e, t, n) => {
  if (e === void 0)
    return {
      type: "untracked",
      connection: t.connect(n)
    };
  const r = Yt.get(n.name);
  if (r)
    return { type: "tracked", store: e, ...r };
  const s = {
    connection: t.connect(n),
    stores: {}
  };
  return Yt.set(n.name, s), { type: "tracked", store: e, ...s };
}, Nh = (e, t) => {
  if (t === void 0) return;
  const n = Yt.get(e);
  n && (delete n.stores[t], Object.keys(n.stores).length === 0 && Yt.delete(e));
}, Th = (e) => {
  var t, n;
  if (!e) return;
  const r = e.split(`
`), s = r.findIndex(
    (o) => o.includes("api.setState")
  );
  if (s < 0) return;
  const a = ((t = r[s + 1]) == null ? void 0 : t.trim()) || "";
  return (n = /.+ (.+) .+/.exec(a)) == null ? void 0 : n[1];
}, Ch = (e, t = {}) => (n, r, s) => {
  const { enabled: a, anonymousActionType: o, store: l, ...c } = t;
  let d;
  try {
    d = (a ?? (Ds ? "production" : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!d)
    return e(n, r, s);
  const { connection: u, ...h } = Sh(l, d, c);
  let f = !0;
  s.setState = ((v, b, x) => {
    const w = n(v, b);
    if (!f) return w;
    const S = x === void 0 ? {
      type: o || Th(new Error().stack) || "anonymous"
    } : typeof x == "string" ? { type: x } : x;
    return l === void 0 ? (u == null || u.send(S, r()), w) : (u == null || u.send(
      {
        ...S,
        type: `${l}/${S.type}`
      },
      {
        ...bn(c.name),
        [l]: s.getState()
      }
    ), w);
  }), s.devtools = {
    cleanup: () => {
      u && typeof u.unsubscribe == "function" && u.unsubscribe(), Nh(c.name, l);
    }
  };
  const y = (...v) => {
    const b = f;
    f = !1, n(...v), f = b;
  }, p = e(s.setState, r, s);
  if (h.type === "untracked" ? u == null || u.init(p) : (h.stores[h.store] = s, u == null || u.init(
    Object.fromEntries(
      Object.entries(h.stores).map(([v, b]) => [
        v,
        v === h.store ? p : b.getState()
      ])
    )
  )), s.dispatchFromDevtools && typeof s.dispatch == "function") {
    let v = !1;
    const b = s.dispatch;
    s.dispatch = (...x) => {
      (Ds ? "production" : void 0) !== "production" && x[0].type === "__setState" && !v && (console.warn(
        '[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.'
      ), v = !0), b(...x);
    };
  }
  return u.subscribe((v) => {
    var b;
    switch (v.type) {
      case "ACTION":
        if (typeof v.payload != "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return lr(
          v.payload,
          (x) => {
            if (x.type === "__setState") {
              if (l === void 0) {
                y(x.state);
                return;
              }
              Object.keys(x.state).length !== 1 && console.error(
                `
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `
              );
              const w = x.state[l];
              if (w == null)
                return;
              JSON.stringify(s.getState()) !== JSON.stringify(w) && y(w);
              return;
            }
            s.dispatchFromDevtools && typeof s.dispatch == "function" && s.dispatch(x);
          }
        );
      case "DISPATCH":
        switch (v.payload.type) {
          case "RESET":
            return y(p), l === void 0 ? u == null ? void 0 : u.init(s.getState()) : u == null ? void 0 : u.init(bn(c.name));
          case "COMMIT":
            if (l === void 0) {
              u == null || u.init(s.getState());
              return;
            }
            return u == null ? void 0 : u.init(bn(c.name));
          case "ROLLBACK":
            return lr(v.state, (x) => {
              if (l === void 0) {
                y(x), u == null || u.init(s.getState());
                return;
              }
              y(x[l]), u == null || u.init(bn(c.name));
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return lr(v.state, (x) => {
              if (l === void 0) {
                y(x);
                return;
              }
              JSON.stringify(s.getState()) !== JSON.stringify(x[l]) && y(x[l]);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState: x } = v.payload, w = (b = x.computedStates.slice(-1)[0]) == null ? void 0 : b.state;
            if (!w) return;
            y(l === void 0 ? w : w[l]), u == null || u.send(
              null,
              // FIXME no-any
              x
            );
            return;
          }
          case "PAUSE_RECORDING":
            return f = !f;
        }
        return;
    }
  }), p;
}, Mh = Ch, lr = (e, t) => {
  let n;
  try {
    n = JSON.parse(e);
  } catch (r) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      r
    );
  }
  n !== void 0 && t(n);
};
function m1({ steps: e, initialStep: t, storeName: n = "wizard" }) {
  if (e.length === 0)
    throw new Error("Wizard must have at least one step");
  const r = t ?? e[0], s = e.indexOf(r);
  if (s === -1)
    throw new Error(`Initial step "${r}" not found in steps array`);
  return sa()(
    Mh(
      (a, o) => ({
        currentStep: r,
        currentStepIndex: s,
        completedSteps: [],
        isStepComplete: (l) => o().completedSteps.includes(l),
        markStepComplete: (l) => {
          o().completedSteps.includes(l) || a((c) => ({ completedSteps: [...c.completedSteps, l] }));
        },
        nextStep: () => {
          const l = o().currentStepIndex + 1;
          l >= e.length || a({ currentStep: e[l], currentStepIndex: l });
        },
        previousStep: () => {
          const l = o().currentStepIndex - 1;
          l < 0 || a({ currentStep: e[l], currentStepIndex: l });
        },
        goToStep: (l) => {
          const c = e.indexOf(l);
          c !== -1 && a({ currentStep: l, currentStepIndex: c });
        },
        reset: () => {
          a({
            currentStep: r,
            currentStepIndex: s,
            completedSteps: []
          });
        }
      }),
      {
        name: n
      }
    )
  );
}
const Ph = ({
  onNext: e,
  onPrevious: t,
  canGoNext: n = !0,
  canGoPrevious: r = !0,
  isNextLoading: s = !1,
  isPreviousLoading: a = !1,
  nextDisabledTooltip: o,
  hideNext: l,
  hidePrevious: c,
  nextLabel: d = "Next",
  previousLabel: u = "Previous",
  isLastStep: h = !1,
  isTunecore: f = !1
}) => {
  const y = async () => {
    if (n && !s && e != null)
      try {
        await e();
      } catch (v) {
        console.error("Error in next step:", v);
      }
  }, p = async () => {
    if (r && !a && t != null)
      try {
        await t();
      } catch (v) {
        console.error("Error in previous step:", v);
      }
  };
  return /* @__PURE__ */ m("div", { className: "flex justify-between mt-6", children: [
    /* @__PURE__ */ i("div", { className: "flex", children: !c && r && t != null ? /* @__PURE__ */ i(
      O,
      {
        type: "button",
        variant: "outline",
        onClick: () => {
          p();
        },
        disabled: !r || a,
        label: a ? "Loading..." : u
      }
    ) : !c && /* @__PURE__ */ i("div", {}) }),
    /* @__PURE__ */ m("div", { className: "flex items-center gap-2", children: [
      !l && (!n || s) && o != null && o !== "" && /* @__PURE__ */ m("div", { className: "flex items-center gap-2 px-3 py-2 rounded-lg bg-layer-disabled", children: [
        /* @__PURE__ */ i(ru, { className: "w-5 h-5 shrink-0 stroke-ink-accent" }),
        /* @__PURE__ */ i("span", { className: "text-sm text-ink-secondary", children: o })
      ] }),
      !l && e != null && /* @__PURE__ */ i(
        O,
        {
          type: "button",
          variant: f ? "secondary" : "primary",
          onClick: () => {
            y();
          },
          disabled: !n || s,
          label: s ? "Loading..." : h ? "Finish" : d
        }
      )
    ] })
  ] });
}, cr = ({
  index: e,
  title: t,
  isActive: n,
  isCompleted: r,
  showStepNumbers: s,
  isTunecore: a,
  onStepClick: o,
  canNavigate: l = !0
}) => {
  const d = `w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-200 ${r ? a ? "bg-action-primary text-white" : "bg-action-secondary text-black" : n ? a ? "bg-brand-primary text-white" : "bg-action-primary/70 text-white" : a && l ? "bg-layer-inverse text-white" : a ? "bg-layer-inverse text-gray-500" : "bg-layer-raised text-ink-secondary border-2 border-stroke-subtle"}`, u = [n && "current step", r && "completed"].filter(Boolean).join(", "), h = u ? `${t}, ${u}` : t, f = s ? r && !n ? /* @__PURE__ */ i(dt, { className: "w-5 h-5 stroke-black", "aria-hidden": "true" }) : /* @__PURE__ */ i("span", { className: "leading-none", children: e + 1 }) : r ? /* @__PURE__ */ i(dt, { className: "w-5 h-5 stroke-black", "aria-hidden": "true" }) : null;
  return o != null ? /* @__PURE__ */ i(
    "button",
    {
      type: "button",
      onClick: () => {
        l && o(e);
      },
      className: g(d, l ? "cursor-pointer" : "cursor-not-allowed"),
      "aria-label": h,
      "aria-current": n ? "step" : void 0,
      "aria-disabled": !l,
      children: f
    }
  ) : /* @__PURE__ */ i("div", { className: d, children: f });
}, Dh = ({ index: e, currentStepIndex: t, isTunecore: n }) => {
  const r = e < t ? n ? "bg-action-primary" : "bg-action-secondary" : e === t ? n ? "bg-layer-inverse" : "bg-action-primary" : n ? "bg-layer-inverse" : "bg-layer-raised";
  return /* @__PURE__ */ i("div", { className: g("flex-1 h-0.5 mx-2", r) });
}, Is = ({ index: e, currentStepIndex: t, isTunecore: n }) => {
  const r = e < t ? n ? "bg-action-primary" : "bg-action-secondary" : e === t ? n ? "bg-layer-inverse" : "bg-action-primary" : n ? "bg-layer-inverse" : "bg-layer-raised";
  return /* @__PURE__ */ i("div", { className: g("flex-1 mx-2 w-0.5", r) });
}, Ih = ({ step: e, animated: t, children: n }) => {
  const r = e.visible !== !1;
  return t ? /* @__PURE__ */ i(
    "div",
    {
      className: g("overflow-hidden transition-all duration-500 ease-in-out", {
        "max-h-0 opacity-0": !r,
        "max-h-40 opacity-100": r
      }),
      children: n
    }
  ) : r ? /* @__PURE__ */ i(re, { children: n }) : null;
}, Ah = ({
  steps: e,
  currentStepIndex: t,
  direction: n = "horizontal",
  isTunecore: r = !1,
  onStepClick: s,
  animated: a = !1,
  showStepNumbers: o = !0,
  showDescriptions: l = !1,
  showLabels: c = !0,
  stretch: d = !1,
  canNavigateToStep: u
}) => {
  if (e.length === 0)
    return null;
  const h = Math.min(Math.max(t, 0), e.length - 1);
  return /* @__PURE__ */ m(
    "div",
    {
      className: g({
        "w-full mb-4": n === "horizontal",
        "h-full": n === "vertical" && d
      }),
      children: [
        /* @__PURE__ */ m("div", { className: "block md:hidden", children: [
          /* @__PURE__ */ m("div", { className: "flex items-center justify-between mb-2", children: [
            /* @__PURE__ */ m("span", { className: `text-sm font-medium ${r ? "text-white" : "text-ink-primary"}`, children: [
              h + 1,
              " ",
              "of",
              " ",
              e.length
            ] }),
            /* @__PURE__ */ i("div", { className: "flex justify-center mt-3 space-x-2", children: e.map((f, y) => {
              const p = y === h, v = f.isComplete === !0 || y < h;
              return /* @__PURE__ */ i(
                "div",
                {
                  className: g("w-3 h-3 rounded-full transition-all duration-200", {
                    [r ? "bg-action-primary" : "bg-action-secondary"]: v,
                    [r ? "bg-brand-primary" : "bg-action-primary"]: !v && p,
                    [r ? "bg-layer-inverse" : "bg-layer-raised"]: !v && !p
                  })
                },
                f.id
              );
            }) })
          ] }),
          /* @__PURE__ */ i(
            "div",
            {
              className: g("w-full h-2 rounded-full", {
                "bg-layer-inverse": r,
                "bg-layer-raised": !r
              }),
              children: /* @__PURE__ */ i(
                "div",
                {
                  className: "h-2 rounded-full transition-all duration-300 bg-action-primary",
                  style: { width: `${(h + 1) / e.length * 100}%` }
                }
              )
            }
          )
        ] }),
        n === "horizontal" && /* @__PURE__ */ i("div", { className: "items-center justify-between hidden md:flex", children: e.map((f, y) => {
          const p = y === h, v = f.isComplete === !0 || y < h, b = y === e.length - 1;
          return /* @__PURE__ */ m("div", { className: `flex items-center ${b ? "" : "flex-1"}`, children: [
            /* @__PURE__ */ m("div", { className: "flex flex-col items-center", children: [
              /* @__PURE__ */ i(
                cr,
                {
                  index: y,
                  title: f.title,
                  isActive: p,
                  isCompleted: v,
                  showStepNumbers: o,
                  isTunecore: r,
                  onStepClick: s,
                  canNavigate: u == null || u(y)
                }
              ),
              l && /* @__PURE__ */ m("div", { className: "mt-2 text-center", children: [
                /* @__PURE__ */ i(
                  "div",
                  {
                    className: g("text-sm font-medium", {
                      "text-ink-accent": p && !r || v && !p,
                      "text-brand-primary": p && r,
                      "text-white/70": r && !p && !v,
                      "text-ink-secondary": !r && !p && !v
                    }),
                    children: f.title
                  }
                ),
                f.description != null && f.description !== "" && /* @__PURE__ */ i("div", { className: "text-xs mt-1 text-ink-secondary", children: f.description })
              ] })
            ] }),
            !b && /* @__PURE__ */ i(
              Dh,
              {
                index: y,
                currentStepIndex: h,
                isTunecore: r
              }
            )
          ] }, f.id);
        }) }),
        n === "vertical" && /* @__PURE__ */ i("div", { className: g("hidden md:flex flex-col", { "h-full": d }), children: e.map((f, y) => {
          const p = y === h, v = f.isComplete === !0 || y < h, b = y === e.length - 1, x = /* @__PURE__ */ m("div", { className: "ml-3 min-w-0", children: [
            /* @__PURE__ */ i(
              "div",
              {
                className: g("text-sm font-medium pt-1", {
                  "text-ink-accent": p && !r || v && !p,
                  "text-brand-primary": p && r,
                  "text-white/70": r && !p && !v,
                  "text-ink-secondary": !r && !p && !v
                }),
                children: f.title
              }
            ),
            l && f.description != null && f.description !== "" && /* @__PURE__ */ i("div", { className: "text-xs mt-0.5 text-ink-secondary", children: f.description })
          ] });
          return d ? /* @__PURE__ */ m(Y.Fragment, { children: [
            /* @__PURE__ */ m("div", { className: "flex flex-row items-center self-center", children: [
              /* @__PURE__ */ i(
                cr,
                {
                  index: y,
                  title: f.title,
                  isActive: p,
                  isCompleted: v,
                  showStepNumbers: o,
                  isTunecore: r,
                  onStepClick: s,
                  canNavigate: u == null || u(y)
                }
              ),
              c && x
            ] }),
            !b && /* @__PURE__ */ i("div", { className: "flex flex-row flex-1", children: /* @__PURE__ */ i("div", { className: "flex flex-col items-center w-8", children: /* @__PURE__ */ i(
              Is,
              {
                index: y,
                currentStepIndex: h,
                isTunecore: r
              }
            ) }) })
          ] }, f.id) : /* @__PURE__ */ i(Ih, { step: f, animated: a, children: /* @__PURE__ */ m("div", { className: "flex flex-row", children: [
            /* @__PURE__ */ m("div", { className: "flex flex-col items-center w-8", children: [
              /* @__PURE__ */ i(
                cr,
                {
                  index: y,
                  title: f.title,
                  isActive: p,
                  isCompleted: v,
                  showStepNumbers: o,
                  isTunecore: r,
                  onStepClick: s,
                  canNavigate: u == null || u(y)
                }
              ),
              !b && /* @__PURE__ */ i("div", { className: g("flex flex-col flex-1", { "pb-5": !c }), children: /* @__PURE__ */ i(
                Is,
                {
                  index: y,
                  currentStepIndex: h,
                  isTunecore: r
                }
              ) })
            ] }),
            c && /* @__PURE__ */ m("div", { className: g("ml-3 min-w-0", { "pb-5": !b }), children: [
              /* @__PURE__ */ i(
                "div",
                {
                  className: g("text-sm font-medium pt-1", {
                    "text-ink-accent": p && !r || v && !p,
                    "text-brand-primary": p && r,
                    "text-white/70": r && !p && !v,
                    "text-ink-secondary": !r && !p && !v
                  }),
                  children: f.title
                }
              ),
              l && f.description != null && f.description !== "" && /* @__PURE__ */ i("div", { className: "text-xs mt-0.5 text-ink-secondary", children: f.description })
            ] })
          ] }) }, f.id);
        }) })
      ]
    }
  );
}, g1 = ({
  steps: e,
  wizardStore: t,
  showProgress: n = !0,
  showNavigation: r = !0,
  showStepNumbers: s = !0,
  showDescriptions: a = !1,
  direction: o,
  isTunecore: l,
  onStepClick: c,
  onComplete: d,
  onCancel: u,
  // Currently unused but reserved for future implementation
  onError: h,
  className: f,
  containerClassName: y
}) => {
  const [p, v] = ne({}), [b, x] = ne(!1), [w, S] = ne(null), k = e[t.currentStepIndex], N = k == null ? void 0 : k.component;
  Ue(() => {
    S(null);
  }, [t.currentStepIndex]);
  const A = e.map((V) => ({
    ...V,
    isComplete: t.completedSteps.includes(V.id)
  })), C = async () => {
    if (k != null) {
      if (S(null), v((V) => ({
        ...V,
        [k.id]: !0
      })), (k == null ? void 0 : k.validation) != null) {
        x(!0);
        try {
          const V = await k.validation();
          if (!V.isValid) {
            v((L) => ({
              ...L,
              [k.id]: !1
            })), S(V.errorMessage ?? "Validation failed. Please check your input and try again.");
            return;
          }
        } catch (V) {
          S("An unexpected error occurred. Please try again."), h != null ? h(V) : console.error("Validation error:", V);
          return;
        } finally {
          x(!1);
        }
      }
      t.markStepComplete(k.id), t.currentStepIndex === e.length - 1 ? d == null || d() : t.nextStep();
    }
  }, M = () => {
    t.previousStep();
  }, R = (V) => {
    t.markStepComplete(V);
  };
  if (k == null || N == null)
    return /* @__PURE__ */ m("div", { className: "p-4 text-ink-error", children: [
      'Error: No component found for step "',
      t.currentStep,
      '"'
    ] });
  const D = {
    stepId: k.id,
    isActive: !0,
    onNext: C,
    onPrevious: M,
    onComplete: R,
    onWizardComplete: d,
    // Pass the wizard's onComplete to allow steps to complete the wizard
    isNextDisabled: p[k.id] === !1 || b,
    isPreviousDisabled: t.currentStepIndex === 0 || b,
    isLoading: b
  };
  return /* @__PURE__ */ m(
    Ou,
    {
      className: y ?? f,
      children: [
        n && /* @__PURE__ */ i(
          Ah,
          {
            steps: A,
            currentStepIndex: t.currentStepIndex,
            showStepNumbers: s,
            showDescriptions: a,
            direction: o,
            isTunecore: l,
            onStepClick: c
          }
        ),
        /* @__PURE__ */ i(N, { ...D }),
        /* @__PURE__ */ i(zd, { message: w ?? void 0 }),
        r && /* @__PURE__ */ i(
          Ph,
          {
            onNext: C,
            onPrevious: t.currentStepIndex > 0 ? M : void 0,
            canGoNext: !(p[k.id] === !1 || b),
            canGoPrevious: t.currentStepIndex > 0 && !b,
            isNextLoading: b,
            isPreviousLoading: !1,
            isLastStep: t.currentStepIndex === e.length - 1,
            nextLabel: t.currentStepIndex === e.length - 1 ? "Complete" : "Next",
            isTunecore: l
          }
        )
      ]
    }
  );
};
function y1({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    Mr.Root,
    {
      "data-slot": "radio-group",
      className: g("grid gap-3", e),
      ...t
    }
  );
}
function v1({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    Mr.Item,
    {
      "data-slot": "radio-group-item",
      className: g(
        "aspect-square size-4 shrink-0 cursor-pointer rounded-full border shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        "border-ink-primary focus-visible:ring-action-primary/50 data-[state=checked]:bg-action-primary data-[state=checked]:border-ink-accent",
        e
      ),
      ...t,
      children: /* @__PURE__ */ i(
        Mr.Indicator,
        {
          "data-slot": "radio-group-indicator",
          className: "flex size-full items-center justify-center text-ink-inverse",
          children: /* @__PURE__ */ i(
            "svg",
            {
              className: "size-3",
              viewBox: "0 0 12 12",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              "aria-hidden": "true",
              children: /* @__PURE__ */ i(
                "path",
                {
                  d: "M10 3L4.5 8.5L2 6",
                  stroke: "currentColor",
                  strokeWidth: "1.16667",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }
              )
            }
          )
        }
      )
    }
  );
}
function b1({ className: e, ...t }) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: g(
        "flex flex-col overflow-y-auto rounded-sm border border-stroke-subtle bg-layer-default",
        e
      ),
      ...t
    }
  );
}
const Fa = ae.Root, x1 = ae.Group, _a = ae.Value, vi = T.forwardRef(({ className: e, smallFont: t, label: n, customWidth: r, ...s }, a) => {
  const o = H((u) => u.isTunecore), c = `formSelect-${T.useId()}`, d = (u) => {
    const h = u ? { id: c, name: c } : {};
    return /* @__PURE__ */ m(
      ae.Trigger,
      {
        ref: a,
        "aria-label": "Select an option",
        className: g(
          "group flex cursor-pointer font-medium pr-2 py-1.5 focus-visible:outline-none transition ease-out duration-200 justify-between items-center",
          o ? "rounded-lg" : "rounded-sm",
          "data-disabled:cursor-not-allowed data-disabled:pointer-events-none",
          r ? "" : "w-full",
          t ? "text-xs" : "text-sm",
          o ? "font-tunecore bg-layer-raised text-white placeholder:text-white/35 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary data-disabled:hover:ring-layer-raised data-disabled:text-white/35" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary data-disabled:ring-stroke-disabled data-disabled:hover:ring-stroke-disabled data-disabled:text-ink-disabled",
          e
        ),
        ...h,
        ...s,
        children: [
          /* @__PURE__ */ i("span", { className: "flex-1 pl-3 text-left", children: s.children }),
          /* @__PURE__ */ i(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              strokeWidth: "1.75",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              className: "w-4 h-4 ml-2 shrink-0 stroke-ink-primary group-data-disabled:stroke-ink-disabled",
              children: /* @__PURE__ */ i("path", { d: "m6 9 6 6 6-6" })
            }
          )
        ]
      }
    );
  };
  return n == null || n === "" ? d(!1) : /* @__PURE__ */ m("div", { className: g("flex flex-col justify-between", r ? "" : "w-full"), children: [
    /* @__PURE__ */ i(
      "label",
      {
        className: g(
          "leading-snug self-start text-ink-primary",
          t ? "text-xs" : "text-base",
          o ? "font-tunecore" : "font-sentric-alt"
        ),
        htmlFor: c,
        children: n
      }
    ),
    d(!0)
  ] });
});
vi.displayName = "SelectTrigger";
const Oa = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  ae.ScrollUpButton,
  {
    ref: n,
    className: g(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ i(sd, { className: "w-4 h-4" })
  }
));
Oa.displayName = ae.ScrollUpButton.displayName;
const Ha = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  ae.ScrollDownButton,
  {
    ref: n,
    className: g(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ i(Qo, { className: "w-4 h-4" })
  }
));
Ha.displayName = ae.ScrollDownButton.displayName;
const bi = T.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, s) => {
  const a = H((o) => o.isTunecore);
  return /* @__PURE__ */ i(ae.Portal, { children: /* @__PURE__ */ m(
    ae.Content,
    {
      ref: s,
      className: g(
        "relative z-50 max-h-96 min-w-32 overflow-hidden rounded-md border shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        a ? "font-tunecore border-stroke-subtle bg-layer-inverse text-white" : "font-sentric-alt border-stroke-subtle bg-layer-default text-ink-primary",
        n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: n,
      ...r,
      children: [
        /* @__PURE__ */ i(Oa, {}),
        /* @__PURE__ */ i(
          ae.Viewport,
          {
            className: g(
              "p-1",
              n === "popper" && "h-(--radix-select-trigger-height) w-full min-w-(--radix-select-trigger-width)"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ i(Ha, {})
      ]
    }
  ) });
});
bi.displayName = ae.Content.displayName;
const Eh = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  ae.Label,
  {
    ref: n,
    className: g("py-1.5 pl-8 pr-2 text-sm font-semibold", e),
    ...t
  }
));
Eh.displayName = ae.Label.displayName;
const xi = T.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ m(
  ae.Item,
  {
    ref: r,
    className: g(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none data-disabled:pointer-events-none data-disabled:opacity-50 hover:cursor-pointer",
      "focus:bg-layer-raised focus:text-ink-primary hover:bg-layer-raised hover:text-ink-primary",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ i("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ i(ae.ItemIndicator, { children: /* @__PURE__ */ i(na, { className: "w-4 h-4" }) }) }),
      /* @__PURE__ */ i(ae.ItemText, { children: t })
    ]
  }
));
xi.displayName = ae.Item.displayName;
const Vh = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  ae.Separator,
  {
    ref: n,
    className: g("-mx-1 my-1 h-px bg-[var(--color-stroke-divider)]", e),
    ...t
  }
));
Vh.displayName = ae.Separator.displayName;
const w1 = J.Root, k1 = J.Trigger, S1 = J.Close, Lh = J.Portal, $a = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  J.Overlay,
  {
    className: g(
      "fixed inset-0 z-50 bg-black/10  backdrop-blur-xl  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
$a.displayName = J.Overlay.displayName;
const Rh = Be(
  "fixed z-50 gap-4 bg-layer-default text-ink-primary p-6 shadow-lg transition ease-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-200 data-[state=open]:duration-200",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), zh = T.forwardRef(({ side: e = "right", className: t, children: n, ...r }, s) => /* @__PURE__ */ m(Lh, { children: [
  /* @__PURE__ */ i($a, {}),
  /* @__PURE__ */ m(
    J.Content,
    {
      ref: s,
      className: g(Rh({ side: e }), t),
      ...r,
      children: [
        n,
        /* @__PURE__ */ m(J.Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
          /* @__PURE__ */ i(fa, { size: "lg", className: "stroke-ink-primary" }),
          /* @__PURE__ */ i("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
zh.displayName = J.Content.displayName;
function Bh({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: g(
        "flex flex-col space-y-2 text-center sm:text-left",
        e
      ),
      ...t
    }
  );
}
Bh.displayName = "SheetHeader";
function jh({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: g(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        e
      ),
      ...t
    }
  );
}
jh.displayName = "SheetFooter";
const Fh = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  J.Title,
  {
    ref: n,
    className: g("text-lg font-semibold text-left font-sentric", e),
    ...t
  }
));
Fh.displayName = J.Title.displayName;
const _h = T.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  J.Description,
  {
    ref: n,
    className: g("text-sm text-muted-foreground", e),
    ...t
  }
));
_h.displayName = J.Description.displayName;
const Ua = T.createContext(null), Wa = T.createContext(null);
function Ga() {
  const e = T.useContext(Ua);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider");
  return e;
}
const Oh = 295, Hh = 200, $h = 420;
function xn(e, t, n) {
  return Math.min(n, Math.max(t, e));
}
function N1({
  open: e,
  onOpenChange: t,
  defaultWidth: n = Oh,
  minWidth: r = Hh,
  maxWidth: s = $h,
  widthStorageKey: a,
  children: o
}) {
  const l = T.useCallback((v) => t(v), [t]), c = T.useCallback(() => t(!e), [t, e]), [d, u] = T.useState(() => {
    if (a == null)
      return xn(n, r, s);
    try {
      const v = localStorage.getItem(a), b = v != null ? Number.parseInt(v, 10) : Number.NaN;
      return xn(Number.isNaN(b) ? n : b, r, s);
    } catch {
      return xn(n, r, s);
    }
  }), [h, f] = T.useState(!1), y = T.useCallback((v) => {
    u((b) => {
      const x = xn(v, r, s);
      if (a != null && x !== b)
        try {
          localStorage.setItem(a, String(x));
        } catch {
        }
      return x;
    });
  }, [r, s, a]), p = T.useMemo(() => ({
    state: e ? "expanded" : "collapsed",
    open: e,
    setOpen: l,
    toggleSidebar: c,
    width: d,
    setWidth: y,
    minWidth: r,
    maxWidth: s,
    resizing: h
  }), [e, l, c, d, y, r, s, h]);
  return /* @__PURE__ */ i(Ua.Provider, { value: p, children: /* @__PURE__ */ i(Wa.Provider, { value: f, children: o }) });
}
const Uh = 4, Wh = T.forwardRef(
  ({ className: e, onPointerDown: t, ...n }, r) => {
    const { toggleSidebar: s, state: a, width: o, setWidth: l } = Ga(), c = T.useContext(Wa), d = T.useRef(null), u = (p) => {
      d.current = { startX: p.clientX, startWidth: o, dragged: !1 }, p.currentTarget.setPointerCapture(p.pointerId), t == null || t(p);
    }, h = (p) => {
      const v = d.current;
      if (!v)
        return;
      const b = p.clientX - v.startX;
      !v.dragged && Math.abs(b) >= Uh && (v.dragged = !0, c == null || c(!0)), v.dragged && l(v.startWidth + b);
    }, f = (p) => {
      var v;
      (v = d.current) != null && v.dragged && (c == null || c(!1)), p.currentTarget.hasPointerCapture(p.pointerId) && p.currentTarget.releasePointerCapture(p.pointerId);
    }, y = (p) => {
      var b;
      const v = ((b = d.current) == null ? void 0 : b.dragged) ?? !1;
      if (d.current = null, v) {
        p.preventDefault();
        return;
      }
      s();
    };
    return a !== "expanded" ? null : /* @__PURE__ */ i(
      "button",
      {
        ref: r,
        type: "button",
        "data-slot": "sidebar-rail",
        "data-state": a,
        "aria-label": "Toggle Sidebar",
        title: "Toggle Sidebar",
        onPointerDown: u,
        onPointerMove: h,
        onPointerUp: f,
        onPointerCancel: f,
        onClick: y,
        className: g(
          "absolute inset-y-0 -right-4 z-20 hidden w-4 -translate-x-1/2 cursor-col-resize touch-none opacity-0 transition-opacity duration-150 ease-out after:absolute after:inset-y-0 after:left-1/2 after:w-px after:-translate-x-1/2 after:transition-colors hover:after:bg-stroke-primary group-hover:opacity-100 focus-visible:opacity-100 lg:flex",
          e
        ),
        ...n
      }
    );
  }
);
Wh.displayName = "SidebarRail";
const Gh = T.forwardRef(
  ({ className: e, onClick: t, ...n }, r) => {
    const { state: s, toggleSidebar: a } = Ga(), o = s === "collapsed";
    return /* @__PURE__ */ i(
      "button",
      {
        ref: r,
        type: "button",
        "data-slot": "sidebar-toggle-button",
        "data-state": s,
        "aria-label": o ? "Expand Sidebar" : "Collapse Sidebar",
        title: o ? "Expand Sidebar" : "Collapse Sidebar",
        onClick: (l) => {
          a(), t == null || t(l);
        },
        className: g(
          "absolute -right-3 top-1/2 z-30 hidden h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full border border-stroke-subtle bg-layer-default text-ink-primary shadow-small-grey opacity-0 transition-all duration-150 ease-out hover:scale-110 group-hover:opacity-100 focus-visible:opacity-100 lg:flex",
          e
        ),
        ...n,
        children: o ? /* @__PURE__ */ i(ci, { className: "w-3.5 h-3.5 stroke-ink-primary" }) : /* @__PURE__ */ i(li, { className: "w-3.5 h-3.5 stroke-ink-primary" })
      }
    );
  }
);
Gh.displayName = "SidebarToggleButton";
const Kh = T.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ i(
    "div",
    {
      ref: n,
      "data-slot": "sidebar-footer",
      className: g("mt-auto flex flex-col gap-2", e),
      ...t
    }
  )
);
Kh.displayName = "SidebarFooter";
function it({ className: e, ...t }) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: g("animate-pulse rounded-md bg-black/10 backdrop-blur-xl", e),
      ...t
    }
  );
}
function T1({ trackCount: e = 4 }) {
  return /* @__PURE__ */ m(it, { className: "w-full min-h-[400px] rounded-lg flex flex-col", children: [
    /* @__PURE__ */ m("div", { className: "flex items-center gap-4 p-6", children: [
      /* @__PURE__ */ i(it, { className: "w-20 h-20 rounded-md shrink-0" }),
      /* @__PURE__ */ m("div", { className: "flex-1", children: [
        /* @__PURE__ */ i(it, { className: "w-3/4 h-4 mb-2" }),
        /* @__PURE__ */ i(it, { className: "w-1/2 h-3" })
      ] })
    ] }),
    /* @__PURE__ */ i("div", { className: "flex-1 p-6 pt-0", children: /* @__PURE__ */ i("div", { className: "space-y-6", children: Array.from({ length: e }, (t, n) => /* @__PURE__ */ m("div", { className: "flex items-center gap-4", children: [
      /* @__PURE__ */ i(it, { className: "w-6 h-4 shrink-0" }),
      /* @__PURE__ */ i(it, { className: "flex-1 h-4" }),
      /* @__PURE__ */ i(it, { className: "w-12 h-4 shrink-0" })
    ] }, `track-skeleton-${n}`)) }) })
  ] });
}
function Xh({ className: e, ...t }) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: g("animate-pulse rounded-md bg-layer-raised", e),
      ...t
    }
  );
}
const Yh = {
  sm: { container: "w-3 h-3", border: "1.5px" },
  md: { container: "w-4 h-4", border: "2px" },
  lg: { container: "w-6 h-6", border: "2.5px" }
};
function C1({
  status: e = "pending",
  size: t = "md",
  label: n,
  className: r
}) {
  if (e === "idle")
    return null;
  const { container: s, border: a } = Yh[t];
  return /* @__PURE__ */ m("span", { className: g("inline-flex items-center", n != null && n !== "" && "gap-2", r), children: [
    /* @__PURE__ */ m(
      "span",
      {
        className: g("relative shrink-0 inline-flex items-center justify-center", s),
        style: { "--spinner-border": a },
        children: [
          e === "pending" && /* @__PURE__ */ i(
            "span",
            {
              "aria-label": "Loading",
              role: "status",
              className: "absolute inset-0 rounded-full border-current border-t-transparent animate-spin",
              style: { borderWidth: "var(--spinner-border)" }
            }
          ),
          e === "success" && /* @__PURE__ */ i(
            "svg",
            {
              "aria-label": "Success",
              role: "img",
              className: g(
                "absolute inset-0 animate-in zoom-in-50 fade-in duration-200",
                s
              ),
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: 2.5,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: /* @__PURE__ */ i("path", { d: "M20 6 9 17l-5-5" })
            }
          ),
          e === "error" && /* @__PURE__ */ m(
            "svg",
            {
              "aria-label": "Error",
              role: "img",
              className: g(
                "absolute inset-0 animate-in zoom-in-50 fade-in duration-200",
                s
              ),
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: 2.5,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [
                /* @__PURE__ */ i("path", { d: "M18 6 6 18" }),
                /* @__PURE__ */ i("path", { d: "m6 6 12 12" })
              ]
            }
          )
        ]
      }
    ),
    n != null && n !== "" && /* @__PURE__ */ i("span", { className: "text-sm leading-none", children: n })
  ] });
}
const Zh = (e) => `Step ${e + 1}`;
function qh(e, t) {
  switch (e) {
    case "completed":
      return t.saved;
    case "error":
      return t.error;
    case "upcoming":
      return t.upcoming;
    case "disabled":
      return t.disabled;
    case "active":
      return "";
  }
}
function M1({
  steps: e,
  ariaLabel: t = "Progress",
  disabled: n = !1,
  className: r,
  onStepClick: s,
  savedLabel: a = "Saved",
  errorLabel: o = "Error",
  upcomingLabel: l = "Upcoming",
  disabledLabel: c = "Disabled",
  formatStepLabel: d = Zh
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      role: "group",
      "aria-label": t,
      "aria-disabled": n || void 0,
      tabIndex: 0,
      className: g("w-full overflow-x-auto rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stroke-focus", r),
      children: /* @__PURE__ */ i("ol", { className: "flex w-max min-w-full items-start py-2", children: e.map((u, h) => {
        const f = n ? "disabled" : u.status, y = f === "active", p = f === "upcoming" || f === "disabled", v = !n && f !== "disabled" && u.canNavigate === !0, b = qh(f, {
          saved: a,
          error: o,
          upcoming: l,
          disabled: c
        }), x = d(h), w = [x, u.label, b, f === "error" ? u.errorMessage : void 0].filter(Boolean).join(", "), S = /* @__PURE__ */ m(re, { children: [
          /* @__PURE__ */ i(
            "div",
            {
              "aria-hidden": "true",
              "data-slot": "stepper-icon",
              className: g(
                "flex size-8 shrink-0 items-center justify-center rounded-sm shadow-small-grey [&>svg]:stroke-current",
                p ? "bg-layer-disabled text-ink-disabled" : "bg-layer-accent text-ink-accent",
                f === "error" && "bg-layer-error text-ink-error"
              ),
              children: f === "error" ? /* @__PURE__ */ i(iu, { size: "lg" }) : u.icon
            }
          ),
          /* @__PURE__ */ m("div", { className: "flex flex-col items-start", children: [
            /* @__PURE__ */ m(
              "div",
              {
                className: g(
                  "flex items-center gap-1 [&>span]:text-ink-secondary",
                  p && "[&>span]:text-ink-disabled"
                ),
                children: [
                  /* @__PURE__ */ i(B, { as: "sectionLabel", children: x }),
                  (f === "completed" || f === "error") && /* @__PURE__ */ i(
                    jd,
                    {
                      variant: f === "completed" ? "success" : "danger",
                      className: g(
                        "rounded-sm px-1 py-0",
                        f === "completed" ? "[&>span]:text-ink-success" : "[&>span]:text-ink-error"
                      ),
                      children: /* @__PURE__ */ i(B, { as: "label", children: b })
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ i(
              "div",
              {
                className: g(
                  "[&>span]:whitespace-nowrap",
                  y && "[&>span]:font-semibold",
                  p && "[&>span]:text-ink-disabled",
                  f === "error" && "[&>span]:text-ink-error"
                ),
                children: /* @__PURE__ */ i(B, { as: "bodySm", children: u.label })
              }
            ),
            f === "error" && u.errorMessage != null && u.errorMessage !== "" && /* @__PURE__ */ i("div", { className: "max-w-56 whitespace-normal text-left [&>span]:text-ink-error", children: /* @__PURE__ */ i(B, { as: "caption", children: u.errorMessage }) })
          ] })
        ] });
        return /* @__PURE__ */ m(
          "li",
          {
            "data-status": f,
            "aria-label": s ? void 0 : w,
            "aria-current": !s && y ? "step" : void 0,
            className: g("flex items-start", h < e.length - 1 && "grow"),
            children: [
              s ? /* @__PURE__ */ i(
                O,
                {
                  variant: "ghost",
                  label: S,
                  disabled: !v,
                  "aria-label": w,
                  "aria-current": y ? "step" : void 0,
                  onClick: () => s(u.id),
                  className: "items-center gap-2 rounded-sm p-0 text-left normal-case disabled:opacity-100"
                }
              ) : /* @__PURE__ */ i("div", { className: "flex items-center gap-2", children: S }),
              h < e.length - 1 && /* @__PURE__ */ i(
                "div",
                {
                  "aria-hidden": "true",
                  "data-slot": "stepper-connector",
                  className: g(
                    "mx-2 mt-4 min-w-8 grow border-t",
                    f === "completed" ? "border-stroke-strong" : "border-dashed border-stroke-disabled"
                  )
                }
              )
            ]
          },
          u.id
        );
      }) })
    }
  );
}
function Jh(e) {
  return /* @__PURE__ */ m("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
    /* @__PURE__ */ i("path", { d: "M12 4L4 12", stroke: "currentColor", strokeWidth: "1.16667", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ i("path", { d: "M4 4L12 12", stroke: "currentColor", strokeWidth: "1.16667", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
}
function Qh(e) {
  return /* @__PURE__ */ i("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ i("path", { d: "M13.3333 4L6 11.3333L2.66667 8", stroke: "currentColor", strokeWidth: "1.16667", strokeLinecap: "round", strokeLinejoin: "round" }) });
}
const ef = Be(
  "peer inline-flex shrink-0 items-center rounded-full border shadow-xs transition-colors outline-none focus-visible:ring-[3px] focus-visible:ring-action-primary/50 disabled:cursor-not-allowed data-[state=unchecked]:bg-layer-raised data-[state=unchecked]:border-stroke-default data-[state=checked]:bg-action-primary data-[state=checked]:border-stroke-primary disabled:bg-layer-disabled disabled:border-stroke-disabled",
  {
    variants: {
      size: {
        sm: "h-6 w-10 p-0.5",
        xl: "h-8 w-13 p-1"
      }
    },
    defaultVariants: {
      size: "sm"
    }
  }
), tf = Be(
  "group/thumb pointer-events-none flex items-center justify-center rounded-full transition-transform data-[state=unchecked]:bg-layer-strong data-[state=checked]:bg-layer-accent data-[disabled]:bg-layer-raised",
  {
    variants: {
      size: {
        sm: "size-5 data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0",
        xl: "size-6 data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
      }
    },
    defaultVariants: {
      size: "sm"
    }
  }
);
function P1({
  className: e,
  size: t = "sm",
  disabled: n,
  ...r
}) {
  return /* @__PURE__ */ i(
    ks.Root,
    {
      "data-slot": "switch",
      disabled: n,
      className: g(ef({ size: t }), e),
      ...r,
      children: /* @__PURE__ */ m(ks.Thumb, { "data-slot": "switch-thumb", className: tf({ size: t }), children: [
        /* @__PURE__ */ i(
          Jh,
          {
            "aria-hidden": !0,
            className: "block text-ink-inverse group-data-[state=checked]/thumb:hidden"
          }
        ),
        /* @__PURE__ */ i(
          Qh,
          {
            "aria-hidden": !0,
            className: g(
              "hidden group-data-[state=checked]/thumb:block",
              n === !0 ? "text-ink-inverse" : "text-action-primary"
            )
          }
        )
      ] })
    }
  );
}
const Ka = It({});
function nf(e) {
  const t = Me(null);
  return t.current === null && (t.current = e()), t.current;
}
const rf = typeof window < "u", sf = rf ? ad : Ue, wi = /* @__PURE__ */ It(null);
function ki(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Vn(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
const Ge = (e, t, n) => n > t ? t : n < e ? e : n;
function Lr(e, t) {
  return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
let At = () => {
}, Ke = () => {
};
var Jo;
typeof process < "u" && ((Jo = process.env) == null ? void 0 : Jo.NODE_ENV) !== "production" && (At = (e, t, n) => {
  !e && typeof console < "u" && console.warn(Lr(t, n));
}, Ke = (e, t, n) => {
  if (!e)
    throw new Error(Lr(t, n));
});
const Je = {}, Xa = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), Ya = (e) => typeof e == "object" && e !== null, Za = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function qa(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const De = /* @__NO_SIDE_EFFECTS__ */ (e) => e, nn = (...e) => e.reduce((t, n) => (r) => n(t(r))), Zt = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r ? (n - e) / r : 1;
};
class Si {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return ki(this.subscriptions, t), () => Vn(this.subscriptions, t);
  }
  notify(t, n, r) {
    const s = this.subscriptions.length;
    if (s)
      if (s === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let a = 0; a < s; a++) {
          const o = this.subscriptions[a];
          o && o(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const we = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, Pe = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, Ja = /* @__NO_SIDE_EFFECTS__ */ (e, t) => t ? e * (1e3 / t) : 0, As = /* @__PURE__ */ new Set();
function Kn(e, t, n) {
  e || As.has(t) || (console.warn(Lr(t, n)), As.add(t));
}
const Qa = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, of = 1e-7, af = 12;
function lf(e, t, n, r, s) {
  let a, o, l = 0;
  do
    o = t + (n - t) / 2, a = Qa(o, r, s) - e, a > 0 ? n = o : t = o;
  while (Math.abs(a) > of && ++l < af);
  return o;
}
// @__NO_SIDE_EFFECTS__
function rn(e, t, n, r) {
  if (e === t && n === r)
    return De;
  const s = (a) => lf(a, 0, 1, e, n);
  return (a) => a === 0 || a === 1 ? a : Qa(s(a), t, r);
}
const el = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, tl = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => 1 - e(1 - t), nl = /* @__PURE__ */ rn(0.33, 1.53, 0.69, 0.99), Ni = /* @__PURE__ */ tl(nl), rl = /* @__PURE__ */ el(Ni), il = (e) => e >= 1 ? 1 : (e *= 2) < 1 ? 0.5 * Ni(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Ti = (e) => 1 - Math.sin(Math.acos(e)), sl = /* @__PURE__ */ tl(Ti), ol = /* @__PURE__ */ el(Ti), cf = /* @__PURE__ */ rn(0.42, 0, 1, 1), df = /* @__PURE__ */ rn(0, 0, 0.58, 1), al = /* @__PURE__ */ rn(0.42, 0, 0.58, 1), uf = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] != "number", ll = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] == "number", Es = {
  linear: De,
  easeIn: cf,
  easeInOut: al,
  easeOut: df,
  circIn: Ti,
  circInOut: ol,
  circOut: sl,
  backIn: Ni,
  backInOut: rl,
  backOut: nl,
  anticipate: il
}, hf = (e) => typeof e == "string", Vs = (e) => {
  if (/* @__PURE__ */ ll(e)) {
    Ke(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [t, n, r, s] = e;
    return /* @__PURE__ */ rn(t, n, r, s);
  } else if (hf(e))
    return Ke(Es[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), Es[e];
  return e;
}, wn = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function ff(e) {
  let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, s = !1;
  const a = /* @__PURE__ */ new WeakSet();
  let o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function l(d) {
    a.has(d) && (c.schedule(d), e()), d(o);
  }
  const c = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (d, u = !1, h = !1) => {
      const y = h && r ? t : n;
      return u && a.add(d), y.add(d), d;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (d) => {
      n.delete(d), a.delete(d);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (d) => {
      if (o = d, r) {
        s = !0;
        return;
      }
      r = !0;
      const u = t;
      t = n, n = u, t.forEach(l), t.clear(), r = !1, s && (s = !1, c.process(d));
    }
  };
  return c;
}
const pf = 40;
function cl(e, t) {
  let n = !1, r = !0;
  const s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, a = () => n = !0, o = wn.reduce((S, k) => (S[k] = ff(a), S), {}), { setup: l, read: c, resolveKeyframes: d, preUpdate: u, update: h, preRender: f, render: y, postRender: p } = o, v = () => {
    const S = Je.useManualTiming, k = S ? s.timestamp : performance.now();
    n = !1, S || (s.delta = r ? 1e3 / 60 : Math.max(Math.min(k - s.timestamp, pf), 1)), s.timestamp = k, s.isProcessing = !0, l.process(s), c.process(s), d.process(s), u.process(s), h.process(s), f.process(s), y.process(s), p.process(s), s.isProcessing = !1, n && t && (r = !1, e(v));
  }, b = () => {
    n = !0, r = !0, s.isProcessing || e(v);
  };
  return { schedule: wn.reduce((S, k) => {
    const N = o[k];
    return S[k] = (A, C = !1, M = !1) => (n || b(), N.schedule(A, C, M)), S;
  }, {}), cancel: (S) => {
    for (let k = 0; k < wn.length; k++)
      o[wn[k]].cancel(S);
  }, state: s, steps: o };
}
const { schedule: q, cancel: Qe, state: he, steps: dr } = /* @__PURE__ */ cl(typeof requestAnimationFrame < "u" ? requestAnimationFrame : De, !0);
let Tn;
function mf() {
  Tn = void 0;
}
const ye = {
  now: () => (Tn === void 0 && ye.set(he.isProcessing || Je.useManualTiming ? he.timestamp : performance.now()), Tn),
  set: (e) => {
    Tn = e, queueMicrotask(mf);
  }
}, dl = (e) => (t) => typeof t == "string" && t.startsWith(e), ul = /* @__PURE__ */ dl("--"), gf = /* @__PURE__ */ dl("var(--"), Ci = (e) => gf(e) ? yf.test(e.split("/*")[0].trim()) : !1, yf = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function Ls(e) {
  return typeof e != "string" ? !1 : e.split("/*")[0].includes("var(--");
}
const Et = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, qt = {
  ...Et,
  transform: (e) => Ge(0, 1, e)
}, kn = {
  ...Et,
  default: 1
}, Ht = (e) => Math.round(e * 1e5) / 1e5, Mi = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function vf(e) {
  return e == null;
}
const bf = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Pi = (e, t) => (n) => !!(typeof n == "string" && bf.test(n) && n.startsWith(e) || t && !vf(n) && Object.prototype.hasOwnProperty.call(n, t)), hl = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [s, a, o, l] = r.match(Mi);
  return {
    [e]: parseFloat(s),
    [t]: parseFloat(a),
    [n]: parseFloat(o),
    alpha: l !== void 0 ? parseFloat(l) : 1
  };
}, xf = (e) => Ge(0, 255, e), ur = {
  ...Et,
  transform: (e) => Math.round(xf(e))
}, at = {
  test: /* @__PURE__ */ Pi("rgb", "red"),
  parse: /* @__PURE__ */ hl("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + ur.transform(e) + ", " + ur.transform(t) + ", " + ur.transform(n) + ", " + Ht(qt.transform(r)) + ")"
};
function wf(e) {
  let t = "", n = "", r = "", s = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), s = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), s = e.substring(4, 5), t += t, n += n, r += r, s += s), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: s ? parseInt(s, 16) / 255 : 1
  };
}
const Rr = {
  test: /* @__PURE__ */ Pi("#"),
  parse: wf,
  transform: at.transform
}, sn = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), Xe = /* @__PURE__ */ sn("deg"), $e = /* @__PURE__ */ sn("%"), E = /* @__PURE__ */ sn("px"), kf = /* @__PURE__ */ sn("vh"), Sf = /* @__PURE__ */ sn("vw"), Rs = {
  ...$e,
  parse: (e) => $e.parse(e) / 100,
  transform: (e) => $e.transform(e * 100)
}, kt = {
  test: /* @__PURE__ */ Pi("hsl", "hue"),
  parse: /* @__PURE__ */ hl("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + $e.transform(Ht(t)) + ", " + $e.transform(Ht(n)) + ", " + Ht(qt.transform(r)) + ")"
}, oe = {
  test: (e) => at.test(e) || Rr.test(e) || kt.test(e),
  parse: (e) => at.test(e) ? at.parse(e) : kt.test(e) ? kt.parse(e) : Rr.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? at.transform(e) : kt.transform(e),
  getAnimatableNone: (e) => {
    const t = oe.parse(e);
    return t.alpha = 0, oe.transform(t);
  }
}, Nf = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Tf(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(Mi)) == null ? void 0 : t.length) || 0) + (((n = e.match(Nf)) == null ? void 0 : n.length) || 0) > 0;
}
const fl = "number", pl = "color", Cf = "var", Mf = "var(", zs = "${}", Pf = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Pt(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, s = [];
  let a = 0;
  const l = t.replace(Pf, (c) => (oe.test(c) ? (r.color.push(a), s.push(pl), n.push(oe.parse(c))) : c.startsWith(Mf) ? (r.var.push(a), s.push(Cf), n.push(c)) : (r.number.push(a), s.push(fl), n.push(parseFloat(c))), ++a, zs)).split(zs);
  return { values: n, split: l, indexes: r, types: s };
}
function Df(e) {
  return Pt(e).values;
}
function ml({ split: e, types: t }) {
  const n = e.length;
  return (r) => {
    let s = "";
    for (let a = 0; a < n; a++)
      if (s += e[a], r[a] !== void 0) {
        const o = t[a];
        o === fl ? s += Ht(r[a]) : o === pl ? s += oe.transform(r[a]) : s += r[a];
      }
    return s;
  };
}
function If(e) {
  return ml(Pt(e));
}
const Af = (e) => typeof e == "number" ? 0 : oe.test(e) ? oe.getAnimatableNone(e) : e, Ef = (e, t) => typeof e == "number" ? t != null && t.trim().endsWith("/") ? e : 0 : Af(e);
function Vf(e) {
  const t = Pt(e);
  return ml(t)(t.values.map((r, s) => Ef(r, t.split[s])));
}
const ze = {
  test: Tf,
  parse: Df,
  createTransformer: If,
  getAnimatableNone: Vf
};
function hr(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Lf({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let s = 0, a = 0, o = 0;
  if (!t)
    s = a = o = n;
  else {
    const l = n < 0.5 ? n * (1 + t) : n + t - n * t, c = 2 * n - l;
    s = hr(c, l, e + 1 / 3), a = hr(c, l, e), o = hr(c, l, e - 1 / 3);
  }
  return {
    red: Math.round(s * 255),
    green: Math.round(a * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
function Ln(e, t) {
  return (n) => n > 0 ? t : e;
}
const Z = (e, t, n) => e + (t - e) * n, fr = (e, t, n) => {
  const r = e * e, s = n * (t * t - r) + r;
  return s < 0 ? 0 : Math.sqrt(s);
}, Rf = [Rr, at, kt], zf = (e) => Rf.find((t) => t.test(e));
function Bs(e) {
  const t = zf(e);
  if (At(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t)
    return !1;
  let n = t.parse(e);
  return t === kt && (n = Lf(n)), n;
}
const js = (e, t) => {
  const n = Bs(e), r = Bs(t);
  if (!n || !r)
    return Ln(e, t);
  const s = { ...n };
  return (a) => (s.red = fr(n.red, r.red, a), s.green = fr(n.green, r.green, a), s.blue = fr(n.blue, r.blue, a), s.alpha = Z(n.alpha, r.alpha, a), at.transform(s));
}, zr = /* @__PURE__ */ new Set(["none", "hidden"]);
function Bf(e, t) {
  return zr.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function jf(e, t) {
  return (n) => Z(e, t, n);
}
function Di(e) {
  return typeof e == "number" ? jf : typeof e == "string" ? Ci(e) ? Ln : oe.test(e) ? js : Of : Array.isArray(e) ? gl : typeof e == "object" ? oe.test(e) ? js : Ff : Ln;
}
function gl(e, t) {
  const n = [...e], r = n.length, s = e.map((a, o) => Di(a)(a, t[o]));
  return (a) => {
    for (let o = 0; o < r; o++)
      n[o] = s[o](a);
    return n;
  };
}
function Ff(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const s in n)
    e[s] !== void 0 && t[s] !== void 0 && (r[s] = Di(e[s])(e[s], t[s]));
  return (s) => {
    for (const a in r)
      n[a] = r[a](s);
    return n;
  };
}
function _f(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let s = 0; s < t.values.length; s++) {
    const a = t.types[s], o = e.indexes[a][r[a]], l = e.values[o] ?? 0;
    n[s] = l, r[a]++;
  }
  return n;
}
const Of = (e, t) => {
  const n = ze.createTransformer(t), r = Pt(e), s = Pt(t);
  return r.indexes.var.length === s.indexes.var.length && r.indexes.color.length === s.indexes.color.length && r.indexes.number.length >= s.indexes.number.length ? zr.has(e) && !s.values.length || zr.has(t) && !r.values.length ? Bf(e, t) : nn(gl(_f(r, s), s.values), n) : (At(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Ln(e, t));
};
function yl(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? Z(e, t, n) : Di(e)(e, t);
}
const Hf = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => q.update(t, n),
    stop: () => Qe(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => he.isProcessing ? he.timestamp : ye.now()
  };
}, vl = (e, t, n = 10) => {
  let r = "";
  const s = Math.max(Math.round(t / n), 2);
  for (let a = 0; a < s; a++)
    r += Math.round(e(a / (s - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, Rn = 2e4;
function Ii(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < Rn; )
    t += n, r = e.next(t);
  return t >= Rn ? 1 / 0 : t;
}
function $f(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), s = Math.min(Ii(r), Rn);
  return {
    type: "keyframes",
    ease: (a) => r.next(s * a).value / t,
    duration: /* @__PURE__ */ Pe(s)
  };
}
const te = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
};
function Br(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const Uf = 12;
function Wf(e, t, n) {
  let r = n;
  for (let s = 1; s < Uf; s++)
    r = r - e(r) / t(r);
  return r;
}
const pr = 1e-3;
function Gf({ duration: e = te.duration, bounce: t = te.bounce, velocity: n = te.velocity, mass: r = te.mass }) {
  let s, a;
  At(e <= /* @__PURE__ */ we(te.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let o = 1 - t;
  o = Ge(te.minDamping, te.maxDamping, o), e = Ge(te.minDuration, te.maxDuration, /* @__PURE__ */ Pe(e)), o < 1 ? (s = (d) => {
    const u = d * o, h = u * e, f = u - n, y = Br(d, o), p = Math.exp(-h);
    return pr - f / y * p;
  }, a = (d) => {
    const h = d * o * e, f = h * n + n, y = Math.pow(o, 2) * Math.pow(d, 2) * e, p = Math.exp(-h), v = Br(Math.pow(d, 2), o);
    return (-s(d) + pr > 0 ? -1 : 1) * ((f - y) * p) / v;
  }) : (s = (d) => {
    const u = Math.exp(-d * e), h = (d - n) * e + 1;
    return -pr + u * h;
  }, a = (d) => {
    const u = Math.exp(-d * e), h = (n - d) * (e * e);
    return u * h;
  });
  const l = 5 / e, c = Wf(s, a, l);
  if (e = /* @__PURE__ */ we(e), isNaN(c))
    return {
      stiffness: te.stiffness,
      damping: te.damping,
      duration: e
    };
  {
    const d = Math.pow(c, 2) * r;
    return {
      stiffness: d,
      damping: o * 2 * Math.sqrt(r * d),
      duration: e
    };
  }
}
const Kf = ["duration", "bounce"], Xf = ["stiffness", "damping", "mass"];
function Fs(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function Yf(e) {
  let t = {
    velocity: te.velocity,
    stiffness: te.stiffness,
    damping: te.damping,
    mass: te.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!Fs(e, Xf) && Fs(e, Kf))
    if (t.velocity = 0, e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), s = r * r, a = 2 * Ge(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(s);
      t = {
        ...t,
        mass: te.mass,
        stiffness: s,
        damping: a
      };
    } else {
      const n = Gf({ ...e, velocity: 0 });
      t = {
        ...t,
        ...n,
        mass: te.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function zn(e = te.visualDuration, t = te.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: s } = n;
  const a = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], l = { done: !1, value: a }, { stiffness: c, damping: d, mass: u, duration: h, velocity: f, isResolvedFromDuration: y } = Yf({
    ...n,
    velocity: -/* @__PURE__ */ Pe(n.velocity || 0)
  }), p = f || 0, v = d / (2 * Math.sqrt(c * u)), b = o - a, x = /* @__PURE__ */ Pe(Math.sqrt(c / u)), w = Math.abs(b) < 5;
  r || (r = w ? te.restSpeed.granular : te.restSpeed.default), s || (s = w ? te.restDelta.granular : te.restDelta.default);
  let S, k, N, A, C, M;
  if (v < 1)
    N = Br(x, v), A = (p + v * x * b) / N, S = (D) => {
      const V = Math.exp(-v * x * D);
      return o - V * (A * Math.sin(N * D) + b * Math.cos(N * D));
    }, C = v * x * A + b * N, M = v * x * b - A * N, k = (D) => Math.exp(-v * x * D) * (C * Math.sin(N * D) + M * Math.cos(N * D));
  else if (v === 1) {
    S = (V) => o - Math.exp(-x * V) * (b + (p + x * b) * V);
    const D = p + x * b;
    k = (V) => Math.exp(-x * V) * (x * D * V - p);
  } else {
    const D = x * Math.sqrt(v * v - 1);
    S = (le) => {
      const _ = Math.exp(-v * x * le), G = Math.min(D * le, 300);
      return o - _ * ((p + v * x * b) * Math.sinh(G) + D * b * Math.cosh(G)) / D;
    };
    const V = (p + v * x * b) / D, L = v * x * V - b * D, Q = v * x * b - V * D;
    k = (le) => {
      const _ = Math.exp(-v * x * le), G = Math.min(D * le, 300);
      return _ * (L * Math.sinh(G) + Q * Math.cosh(G));
    };
  }
  const R = {
    calculatedDuration: y && h || null,
    velocity: (D) => /* @__PURE__ */ we(k(D)),
    next: (D) => {
      if (!y && v < 1) {
        const L = Math.exp(-v * x * D), Q = Math.sin(N * D), le = Math.cos(N * D), _ = o - L * (A * Q + b * le), G = /* @__PURE__ */ we(L * (C * Q + M * le));
        return l.done = Math.abs(G) <= r && Math.abs(o - _) <= s, l.value = l.done ? o : _, l;
      }
      const V = S(D);
      if (y)
        l.done = D >= h;
      else {
        const L = /* @__PURE__ */ we(k(D));
        l.done = Math.abs(L) <= r && Math.abs(o - V) <= s;
      }
      return l.value = l.done ? o : V, l;
    },
    toString: () => {
      const D = Math.min(Ii(R), Rn), V = vl((L) => R.next(D * L).value, D, 30);
      return D + "ms " + V;
    },
    toTransition: () => {
    }
  };
  return R;
}
zn.applyToOptions = (e) => {
  const t = $f(e, 100, zn);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ we(t.duration), e.type = "keyframes", e;
};
const Zf = 5;
function bl(e, t, n) {
  const r = Math.max(t - Zf, 0);
  return /* @__PURE__ */ Ja(n - e(r), t - r);
}
function jr({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: s = 10, bounceStiffness: a = 500, modifyTarget: o, min: l, max: c, restDelta: d = 0.5, restSpeed: u }) {
  const h = e[0], f = {
    done: !1,
    value: h
  }, y = (M) => l !== void 0 && M < l || c !== void 0 && M > c, p = (M) => l === void 0 ? c : c === void 0 || Math.abs(l - M) < Math.abs(c - M) ? l : c;
  let v = n * t;
  const b = h + v, x = o === void 0 ? b : o(b);
  x !== b && (v = x - h);
  const w = (M) => -v * Math.exp(-M / r), S = (M) => x + w(M), k = (M) => {
    const R = w(M), D = S(M);
    f.done = Math.abs(R) <= d, f.value = f.done ? x : D;
  };
  let N, A;
  const C = (M) => {
    y(f.value) && (N = M, A = zn({
      keyframes: [f.value, p(f.value)],
      velocity: bl(S, M, f.value),
      // TODO: This should be passing * 1000
      damping: s,
      stiffness: a,
      restDelta: d,
      restSpeed: u
    }));
  };
  return C(0), {
    calculatedDuration: null,
    next: (M) => {
      let R = !1;
      return !A && N === void 0 && (R = !0, k(M), C(M)), N !== void 0 && M >= N ? A.next(M - N) : (!R && k(M), f);
    }
  };
}
function qf(e, t, n) {
  const r = [], s = n || Je.mix || yl, a = e.length - 1;
  for (let o = 0; o < a; o++) {
    let l = s(e[o], e[o + 1]);
    if (t) {
      const c = Array.isArray(t) ? t[o] || De : t;
      l = nn(c, l);
    }
    r.push(l);
  }
  return r;
}
function Jf(e, t, { clamp: n = !0, ease: r, mixer: s } = {}) {
  const a = e.length;
  if (Ke(a === t.length, "Both input and output ranges must be the same length", "range-length"), a === 1)
    return () => t[0];
  if (a === 2 && t[0] === t[1])
    return () => t[1];
  const o = e[0] === e[1];
  e[0] > e[a - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const l = qf(t, r, s), c = l.length, d = (u) => {
    if (o && u < e[0])
      return t[0];
    let h = 0;
    if (c > 1)
      for (; h < e.length - 2 && !(u < e[h + 1]); h++)
        ;
    const f = /* @__PURE__ */ Zt(e[h], e[h + 1], u);
    return l[h](f);
  };
  return n ? (u) => d(Ge(e[0], e[a - 1], u)) : d;
}
function Qf(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const s = /* @__PURE__ */ Zt(0, t, r);
    e.push(Z(n, 1, s));
  }
}
function ep(e) {
  const t = [0];
  return Qf(t, e.length - 1), t;
}
function tp(e, t) {
  return e.map((n) => n * t);
}
function np(e, t) {
  return e.map(() => t || al).splice(0, e.length - 1);
}
function St({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const s = /* @__PURE__ */ uf(r) ? r.map(Vs) : Vs(r), a = {
    done: !1,
    value: t[0]
  }, o = tp(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : ep(t),
    e
  ), l = Jf(o, t, {
    ease: Array.isArray(s) ? s : np(t, s)
  });
  return {
    calculatedDuration: e,
    next: (c) => (a.value = l(c), a.done = c >= e, a)
  };
}
const rp = (e) => e !== null;
function Xn(e, { repeat: t, repeatType: n = "loop" }, r, s = 1) {
  const a = e.filter(rp), l = s < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : a.length - 1;
  return !l || r === void 0 ? a[l] : r;
}
const ip = {
  decay: jr,
  inertia: jr,
  tween: St,
  keyframes: St,
  spring: zn
};
function xl(e) {
  typeof e.type == "string" && (e.type = ip[e.type]);
}
class Ai {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const sp = (e) => e / 100;
class Bn extends Ai {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
      done: !1,
      value: void 0
    }, this.stop = () => {
      var r, s;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== ye.now() && this.tick(ye.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (s = (r = this.options).onStop) == null || s.call(r));
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    xl(t);
    const { type: n = St, repeat: r = 0, repeatDelay: s = 0, repeatType: a, velocity: o = 0 } = t;
    let { keyframes: l } = t;
    const c = n || St;
    process.env.NODE_ENV !== "production" && c !== St && Ke(l.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${l}`, "spring-two-frames"), c !== St && typeof l[0] != "number" && (this.mixKeyframes = nn(sp, yl(l[0], l[1])), l = [0, 100]);
    const d = c({ ...t, keyframes: l });
    a === "mirror" && (this.mirroredGenerator = c({
      ...t,
      keyframes: [...l].reverse(),
      velocity: -o
    })), d.calculatedDuration === null && (d.calculatedDuration = Ii(d));
    const { calculatedDuration: u } = d;
    this.calculatedDuration = u, this.resolvedDuration = u + s, this.totalDuration = this.resolvedDuration * (r + 1) - s, this.generator = d;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: s, mixKeyframes: a, mirroredGenerator: o, resolvedDuration: l, calculatedDuration: c } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: d = 0, keyframes: u, repeat: h, repeatType: f, repeatDelay: y, type: p, onUpdate: v, finalKeyframe: b } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - s / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const x = this.currentTime - d * (this.playbackSpeed >= 0 ? 1 : -1), w = this.playbackSpeed >= 0 ? x < 0 : x > s;
    this.currentTime = Math.max(x, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = s);
    let S = this.currentTime, k = r;
    if (h) {
      const M = Math.min(this.currentTime, s) / l;
      let R = Math.floor(M), D = M % 1;
      !D && M >= 1 && (D = 1), D === 1 && R--, R = Math.min(R, h + 1), !!(R % 2) && (f === "reverse" ? (D = 1 - D, y && (D -= y / l)) : f === "mirror" && (k = o)), S = Ge(0, 1, D) * l;
    }
    let N;
    w ? (this.delayState.value = u[0], N = this.delayState) : N = k.next(S), a && !w && (N.value = a(N.value));
    let { done: A } = N;
    !w && c !== null && (A = this.playbackSpeed >= 0 ? this.currentTime >= s : this.currentTime <= 0);
    const C = this.holdTime === null && (this.state === "finished" || this.state === "running" && A);
    return C && p !== jr && (N.value = Xn(u, this.options, b, this.speed)), v && v(N.value), C && this.finish(), N;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ Pe(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ Pe(t);
  }
  get time() {
    return /* @__PURE__ */ Pe(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ we(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = t, this.tick(t));
  }
  /**
   * Returns the generator's velocity at the current time in units/second.
   * Uses the analytical derivative when available (springs), avoiding
   * the MotionValue's frame-dependent velocity estimation.
   */
  getGeneratorVelocity() {
    const t = this.currentTime;
    if (t <= 0)
      return this.options.velocity || 0;
    if (this.generator.velocity)
      return this.generator.velocity(t);
    const n = this.generator.next(t).value;
    return bl((r) => this.generator.next(r).value, t, n);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    n && this.driver && this.updateTime(ye.now()), this.playbackSpeed = t, n && this.driver && (this.time = /* @__PURE__ */ Pe(this.currentTime));
  }
  play() {
    var s, a;
    if (this.isStopped)
      return;
    const { driver: t = Hf, startTime: n } = this.options;
    this.driver || (this.driver = t((o) => this.tick(o))), (a = (s = this.options).onPlay) == null || a.call(s);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(ye.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var t, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (t = this.options).onComplete) == null || n.call(t);
  }
  cancel() {
    var t, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (t = this.options).onCancel) == null || n.call(t);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), t.observe(this);
  }
}
function op(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const lt = (e) => e * 180 / Math.PI, Fr = (e) => {
  const t = lt(Math.atan2(e[1], e[0]));
  return _r(t);
}, ap = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: Fr,
  rotateZ: Fr,
  skewX: (e) => lt(Math.atan(e[1])),
  skewY: (e) => lt(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, _r = (e) => (e = e % 360, e < 0 && (e += 360), e), _s = Fr, Os = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), Hs = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), lp = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Os,
  scaleY: Hs,
  scale: (e) => (Os(e) + Hs(e)) / 2,
  rotateX: (e) => _r(lt(Math.atan2(e[6], e[5]))),
  rotateY: (e) => _r(lt(Math.atan2(-e[2], e[0]))),
  rotateZ: _s,
  rotate: _s,
  skewX: (e) => lt(Math.atan(e[4])),
  skewY: (e) => lt(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function Or(e) {
  return e.includes("scale") ? 1 : 0;
}
function Hr(e, t) {
  if (!e || e === "none")
    return Or(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, s;
  if (n)
    r = lp, s = n;
  else {
    const l = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = ap, s = l;
  }
  if (!s)
    return Or(t);
  const a = r[t], o = s[1].split(",").map(dp);
  return typeof a == "function" ? a(o) : o[a];
}
const cp = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return Hr(n, t);
};
function dp(e) {
  return parseFloat(e.trim());
}
const Vt = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Lt = /* @__PURE__ */ new Set([...Vt, "pathRotation"]), $s = (e) => e === Et || e === E, up = /* @__PURE__ */ new Set(["x", "y", "z"]), hp = Vt.filter((e) => !up.has(e));
function fp(e) {
  const t = [];
  return hp.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const qe = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0", boxSizing: r }) => {
    const s = e.max - e.min;
    return r === "border-box" ? s : s - parseFloat(t) - parseFloat(n);
  },
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0", boxSizing: r }) => {
    const s = e.max - e.min;
    return r === "border-box" ? s : s - parseFloat(t) - parseFloat(n);
  },
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => Hr(t, "x"),
  y: (e, { transform: t }) => Hr(t, "y")
};
qe.translateX = qe.x;
qe.translateY = qe.y;
const ut = /* @__PURE__ */ new Set();
let $r = !1, Ur = !1, Wr = !1;
function wl() {
  if (Ur) {
    const e = Array.from(ut).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const s = fp(r);
      s.length && (n.set(r, s), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const s = n.get(r);
      s && s.forEach(([a, o]) => {
        var l;
        (l = r.getValue(a)) == null || l.set(o);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  Ur = !1, $r = !1, ut.forEach((e) => e.complete(Wr)), ut.clear();
}
function kl() {
  ut.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (Ur = !0);
  });
}
function pp() {
  Wr = !0, kl(), wl(), Wr = !1;
}
class Ei {
  constructor(t, n, r, s, a, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = s, this.element = a, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (ut.add(this), $r || ($r = !0, q.read(kl), q.resolveKeyframes(wl))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: s } = this;
    if (t[0] === null) {
      const a = s == null ? void 0 : s.get(), o = t[t.length - 1];
      if (a !== void 0)
        t[0] = a;
      else if (r && n) {
        const l = r.readValue(n, o);
        l != null && (t[0] = l);
      }
      t[0] === void 0 && (t[0] = o), s && a === void 0 && s.set(t[0]);
    }
    op(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), ut.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (ut.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const mp = (e) => e.startsWith("--");
function Sl(e, t, n) {
  mp(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const gp = {};
function Nl(e, t) {
  const n = /* @__PURE__ */ qa(e);
  return () => gp[t] ?? n();
}
const yp = /* @__PURE__ */ Nl(() => window.ScrollTimeline !== void 0, "scrollTimeline"), Tl = /* @__PURE__ */ Nl(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), jt = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, Us = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ jt([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ jt([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ jt([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ jt([0.33, 1.53, 0.69, 0.99])
};
function Cl(e, t) {
  if (e)
    return typeof e == "function" ? Tl() ? vl(e, t) : "ease-out" : /* @__PURE__ */ ll(e) ? jt(e) : Array.isArray(e) ? e.map((n) => Cl(n, t) || Us.easeOut) : Us[e];
}
function vp(e, t, n, { delay: r = 0, duration: s = 300, repeat: a = 0, repeatType: o = "loop", ease: l = "easeOut", times: c } = {}, d = void 0) {
  const u = {
    [t]: n
  };
  c && (u.offset = c);
  const h = Cl(l, s);
  Array.isArray(h) && (u.easing = h);
  const f = {
    delay: r,
    duration: s,
    easing: Array.isArray(h) ? "linear" : h,
    fill: "both",
    iterations: a + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return d && (f.pseudoElement = d), e.animate(u, f);
}
function Ml(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function bp({ type: e, ...t }) {
  return Ml(e) && Tl() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class Pl extends Ai {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !t)
      return;
    const { element: n, name: r, keyframes: s, pseudoElement: a, allowFlatten: o = !1, finalKeyframe: l, onComplete: c } = t;
    this.isPseudoElement = !!a, this.allowFlatten = o, this.options = t, Ke(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const d = bp(t);
    this.animation = vp(n, r, s, d, a), d.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !a) {
        const u = Xn(s, this.options, l, this.speed);
        this.updateMotionValue && this.updateMotionValue(u), Sl(n, r, u), this.animation.cancel();
      }
      c == null || c(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var t, n;
    (n = (t = this.animation).finish) == null || n.call(t);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var n, r, s;
    const t = (n = this.options) == null ? void 0 : n.element;
    !this.isPseudoElement && (t != null && t.isConnected) && ((s = (r = this.animation).commitStyles) == null || s.call(r));
  }
  get duration() {
    var n, r;
    const t = ((r = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : r.call(n).duration) || 0;
    return /* @__PURE__ */ Pe(Number(t));
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ Pe(t);
  }
  get time() {
    return /* @__PURE__ */ Pe(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    const n = this.finishedTime !== null;
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ we(t), n && this.animation.pause();
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(t) {
    this.manualStartTime = this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, rangeStart: n, rangeEnd: r, observe: s }) {
    var a;
    return this.allowFlatten && ((a = this.animation.effect) == null || a.updateTiming({ easing: "linear" })), this.animation.onfinish = null, t && yp() ? (this.animation.timeline = t, n && (this.animation.rangeStart = n), r && (this.animation.rangeEnd = r), De) : s(this);
  }
}
const Dl = {
  anticipate: il,
  backInOut: rl,
  circInOut: ol
};
function xp(e) {
  return e in Dl;
}
function wp(e) {
  typeof e.ease == "string" && xp(e.ease) && (e.ease = Dl[e.ease]);
}
const mr = 10;
class kp extends Pl {
  constructor(t) {
    wp(t), xl(t), super(t), t.startTime !== void 0 && t.autoplay !== !1 && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: s, element: a, ...o } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const l = new Bn({
      ...o,
      autoplay: !1
    }), c = Math.max(mr, ye.now() - this.startTime), d = Ge(0, mr, c - mr), u = l.sample(c).value, { name: h } = this.options;
    a && h && Sl(a, h, u), n.setWithVelocity(l.sample(Math.max(0, c - d)).value, u, d), l.stop();
  }
}
const Ws = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(ze.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function Sp(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function Np(e, t, n, r) {
  const s = e[0];
  if (s === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const a = e[e.length - 1], o = Ws(s, t), l = Ws(a, t);
  return At(o === l, `You are trying to animate ${t} from "${s}" to "${a}". "${o ? a : s}" is not an animatable value.`, "value-not-animatable"), !o || !l ? !1 : Sp(e) || (n === "spring" || Ml(n)) && r;
}
function Gr(e) {
  e.duration = 0, e.type = "keyframes";
}
const Il = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), Tp = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function Cp(e) {
  for (let t = 0; t < e.length; t++)
    if (typeof e[t] == "string" && Tp.test(e[t]))
      return !0;
  return !1;
}
const Mp = /* @__PURE__ */ new Set([
  "color",
  "backgroundColor",
  "outlineColor",
  "fill",
  "stroke",
  "borderColor",
  "borderTopColor",
  "borderRightColor",
  "borderBottomColor",
  "borderLeftColor"
]), Pp = /* @__PURE__ */ qa(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function Dp(e) {
  var h;
  const { motionValue: t, name: n, repeatDelay: r, repeatType: s, damping: a, type: o, keyframes: l } = e, c = (h = t == null ? void 0 : t.owner) == null ? void 0 : h.current;
  if (!(c instanceof HTMLElement) && !(c instanceof SVGElement))
    return !1;
  const { onUpdate: d, transformTemplate: u } = t.owner.getProps();
  return Pp() && n && /**
   * Force WAAPI for color properties with browser-only color formats
   * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
   */
  (Il.has(n) || Mp.has(n) && Cp(l)) && (n !== "transform" || !u) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !d && !r && s !== "mirror" && a !== 0 && o !== "inertia";
}
const Ip = 40;
class Ap extends Ai {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: s = 0, repeatDelay: a = 0, repeatType: o = "loop", keyframes: l, name: c, motionValue: d, element: u, ...h }) {
    var p;
    super(), this.stop = () => {
      var v, b;
      this._animation && (this._animation.stop(), (v = this.stopTimeline) == null || v.call(this)), (b = this.keyframeResolver) == null || b.cancel();
    }, this.createdAt = ye.now();
    const f = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: s,
      repeatDelay: a,
      repeatType: o,
      name: c,
      motionValue: d,
      element: u,
      ...h
    }, y = (u == null ? void 0 : u.KeyframeResolver) || Ei;
    this.keyframeResolver = new y(l, (v, b, x) => this.onKeyframesResolved(v, b, f, !x), c, d, u), (p = this.keyframeResolver) == null || p.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, s) {
    var x, w;
    this.keyframeResolver = void 0;
    const { name: a, type: o, velocity: l, delay: c, isHandoff: d, onUpdate: u } = r;
    this.resolvedAt = ye.now();
    let h = !0;
    Np(t, a, o, l) || (h = !1, (Je.instantAnimations || !c) && (u == null || u(Xn(t, r, n))), t[0] = t[t.length - 1], Gr(r), r.repeat = 0);
    const y = {
      startTime: s ? this.resolvedAt ? this.resolvedAt - this.createdAt > Ip ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, p = h && !d && Dp(y), v = (w = (x = y.motionValue) == null ? void 0 : x.owner) == null ? void 0 : w.current;
    let b;
    if (p)
      try {
        b = new kp({
          ...y,
          element: v
        });
      } catch {
        b = new Bn(y);
      }
    else
      b = new Bn(y);
    b.finished.then(() => {
      this.notifyFinished();
    }).catch(De), this.pendingTimeline && (this.stopTimeline = b.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = b;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    var t;
    return this._animation || ((t = this.keyframeResolver) == null || t.resume(), pp()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var t;
    this._animation && this.animation.cancel(), (t = this.keyframeResolver) == null || t.cancel();
  }
}
function Al(e, t, n, r = 0, s = 1) {
  const a = Array.from(e).sort((d, u) => d.sortNodePosition(u)).indexOf(t), o = e.size, l = (o - 1) * r;
  return typeof n == "function" ? n(a, o) : s === 1 ? a * r : l - a * r;
}
const Gs = 30, Ep = (e) => !isNaN(parseFloat(e));
class Vp {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      var a;
      const s = ye.now();
      if (this.updatedAt !== s && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((a = this.events.change) == null || a.notify(this.current), this.dependents))
        for (const o of this.dependents)
          o.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = ye.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = Ep(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && Kn(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Si());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), q.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var t;
    (t = this.events.change) == null || t.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = ye.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > Gs)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Gs);
    return /* @__PURE__ */ Ja(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var t, n;
    (t = this.dependents) == null || t.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Dt(e, t) {
  return new Vp(e, t);
}
function El(e, t) {
  if (e != null && e.inherit && t) {
    const { inherit: n, ...r } = e;
    return { ...t, ...r };
  }
  return e;
}
function Vi(e, t) {
  const n = (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
  return n !== e ? El(n, e) : n;
}
const Lp = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Rp = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), zp = {
  type: "keyframes",
  duration: 0.8
}, Bp = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, jp = (e, { keyframes: t }) => t.length > 2 ? zp : Lt.has(e) ? e.startsWith("scale") ? Rp(t[1]) : Lp : Bp, Fp = /* @__PURE__ */ new Set([
  "when",
  "delay",
  "delayChildren",
  "staggerChildren",
  "staggerDirection",
  "repeat",
  "repeatType",
  "repeatDelay",
  "from",
  "elapsed"
]);
function _p(e) {
  for (const t in e)
    if (!Fp.has(t))
      return !0;
  return !1;
}
const Li = (e, t, n, r = {}, s, a) => (o) => {
  const l = Vi(r, e) || {}, c = l.delay || r.delay || 0;
  let { elapsed: d = 0 } = r;
  d = d - /* @__PURE__ */ we(c);
  const u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...l,
    delay: -d,
    onUpdate: (f) => {
      t.set(f), l.onUpdate && l.onUpdate(f);
    },
    onComplete: () => {
      o(), l.onComplete && l.onComplete();
    },
    name: e,
    motionValue: t,
    element: a ? void 0 : s
  };
  _p(l) || Object.assign(u, jp(e, u)), u.duration && (u.duration = /* @__PURE__ */ we(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ we(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let h = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (Gr(u), u.delay === 0 && (h = !0)), (Je.instantAnimations || Je.skipAnimations || s != null && s.shouldSkipAnimations || l.skipAnimations) && (h = !0, Gr(u), u.delay = 0), u.allowFlatten = !l.type && !l.ease, h && !a && t.get() !== void 0) {
    const f = Xn(u.keyframes, l);
    if (f !== void 0) {
      q.update(() => {
        u.onUpdate(f), u.onComplete();
      });
      return;
    }
  }
  return l.isSync ? new Bn(u) : new Ap(u);
}, Op = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function Hp(e) {
  const t = Op.exec(e);
  if (!t)
    return [,];
  const [, n, r, s] = t;
  return [`--${n ?? r}`, s];
}
const $p = 4;
function Vl(e, t, n = 1) {
  Ke(n <= $p, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, s] = Hp(e);
  if (!r)
    return;
  const a = window.getComputedStyle(t).getPropertyValue(r);
  if (a) {
    const o = a.trim();
    return Xa(o) ? parseFloat(o) : o;
  }
  return Ci(s) ? Vl(s, t, n + 1) : s;
}
function Ks(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function Ri(e, t, n, r) {
  if (typeof t == "function") {
    const [s, a] = Ks(r);
    t = t(n !== void 0 ? n : e.custom, s, a);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [s, a] = Ks(r);
    t = t(n !== void 0 ? n : e.custom, s, a);
  }
  return t;
}
function ht(e, t, n) {
  const r = e.getProps();
  return Ri(r, t, n !== void 0 ? n : r.custom, e);
}
const Ll = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Vt
]), Kr = (e) => Array.isArray(e);
function Up(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Dt(n));
}
function Wp(e) {
  return Kr(e) ? e[e.length - 1] || 0 : e;
}
function Gp(e, t) {
  const n = ht(e, t);
  let { transitionEnd: r = {}, transition: s = {}, ...a } = n || {};
  a = { ...a, ...r };
  for (const o in a) {
    const l = Wp(a[o]);
    Up(e, o, l);
  }
}
const fe = (e) => !!(e && e.getVelocity);
function Kp(e) {
  return !!(fe(e) && e.add);
}
function Xr(e, t) {
  const n = e.getValue("willChange");
  if (Kp(n))
    return n.add(t);
  if (!n && Je.WillChange) {
    const r = new Je.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function zi(e) {
  return e.replace(/([A-Z])/g, (t) => `-${t.toLowerCase()}`);
}
const Xp = "framerAppearId", Rl = "data-" + zi(Xp);
function zl(e) {
  return e.props[Rl];
}
function Yp({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function Bl(e, t, { delay: n = 0, transitionOverride: r, type: s } = {}) {
  let { transition: a, transitionEnd: o, ...l } = t;
  const c = e.getDefaultTransition();
  a = a ? El(a, c) : c;
  const d = a == null ? void 0 : a.reduceMotion, u = a == null ? void 0 : a.skipAnimations;
  r && (a = r);
  const h = [], f = s && e.animationState && e.animationState.getState()[s], y = a == null ? void 0 : a.path;
  y && y.animateVisualElement(e, l, a, n, h);
  for (const p in l) {
    const v = e.getValue(p, e.latestValues[p] ?? null), b = l[p];
    if (b === void 0 || f && Yp(f, p))
      continue;
    const x = {
      delay: n,
      ...Vi(a || {}, p)
    };
    u && (x.skipAnimations = !0);
    const w = v.get();
    if (w !== void 0 && !v.isAnimating() && !Array.isArray(b) && b === w && !x.velocity) {
      q.update(() => v.set(b));
      continue;
    }
    let S = !1;
    if (window.MotionHandoffAnimation) {
      const A = zl(e);
      if (A) {
        const C = window.MotionHandoffAnimation(A, p, q);
        C !== null && (x.startTime = C, S = !0);
      }
    }
    Xr(e, p);
    const k = d ?? e.shouldReduceMotion;
    v.start(Li(p, v, b, k && Ll.has(p) ? { type: !1 } : x, e, S));
    const N = v.animation;
    N && h.push(N);
  }
  if (o) {
    const p = () => q.update(() => {
      o && Gp(e, o);
    });
    h.length ? Promise.all(h).then(p) : p();
  }
  return h;
}
function Yr(e, t, n = {}) {
  var c;
  const r = ht(e, t, n.type === "exit" ? (c = e.presenceContext) == null ? void 0 : c.custom : void 0);
  let { transition: s = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (s = n.transitionOverride);
  const a = r ? () => Promise.all(Bl(e, r, n)) : () => Promise.resolve(), o = e.variantChildren && e.variantChildren.size ? (d = 0) => {
    const { delayChildren: u = 0, staggerChildren: h, staggerDirection: f } = s;
    return Zp(e, t, d, u, h, f, n);
  } : () => Promise.resolve(), { when: l } = s;
  if (l) {
    const [d, u] = l === "beforeChildren" ? [a, o] : [o, a];
    return d().then(() => u());
  } else
    return Promise.all([a(), o(n.delay)]);
}
function Zp(e, t, n = 0, r = 0, s = 0, a = 1, o) {
  const l = [];
  for (const c of e.variantChildren)
    c.notify("AnimationStart", t), l.push(Yr(c, t, {
      ...o,
      delay: n + (typeof r == "function" ? 0 : r) + Al(e.variantChildren, c, r, s, a)
    }).then(() => c.notify("AnimationComplete", t)));
  return Promise.all(l);
}
function qp(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const s = t.map((a) => Yr(e, a, n));
    r = Promise.all(s);
  } else if (typeof t == "string")
    r = Yr(e, t, n);
  else {
    const s = typeof t == "function" ? ht(e, t, n.custom) : t;
    r = Promise.all(Bl(e, s, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const Jp = {
  test: (e) => e === "auto",
  parse: (e) => e
}, jl = (e) => (t) => t.test(e), Fl = [Et, E, $e, Xe, Sf, kf, Jp], Xs = (e) => Fl.find(jl(e));
function Qp(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || Za(e) : !0;
}
const em = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function tm(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(Mi) || [];
  if (!r)
    return e;
  const s = n.replace(r, "");
  let a = em.has(t) ? 1 : 0;
  return r !== n && (a *= 100), t + "(" + a + s + ")";
}
const nm = /\b([a-z-]*)\(.*?\)/gu, Zr = {
  ...ze,
  getAnimatableNone: (e) => {
    const t = e.match(nm);
    return t ? t.map(tm).join(" ") : e;
  }
}, qr = {
  ...ze,
  getAnimatableNone: (e) => {
    const t = ze.parse(e);
    return ze.createTransformer(e)(t.map((r) => typeof r == "number" ? 0 : typeof r == "object" ? { ...r, alpha: 1 } : r));
  }
}, Ys = {
  ...Et,
  transform: Math.round
}, rm = {
  rotate: Xe,
  /**
   * Internal channel for `transition.path` orientToPath. Composed onto
   * `rotate` at the transform-build sites so the user's `rotate` is
   * never read or overwritten. Not part of `transformPropOrder`.
   */
  pathRotation: Xe,
  rotateX: Xe,
  rotateY: Xe,
  rotateZ: Xe,
  scale: kn,
  scaleX: kn,
  scaleY: kn,
  scaleZ: kn,
  skew: Xe,
  skewX: Xe,
  skewY: Xe,
  distance: E,
  translateX: E,
  translateY: E,
  translateZ: E,
  x: E,
  y: E,
  z: E,
  perspective: E,
  transformPerspective: E,
  opacity: qt,
  originX: Rs,
  originY: Rs,
  originZ: E
}, jn = {
  // Border props
  borderWidth: E,
  borderTopWidth: E,
  borderRightWidth: E,
  borderBottomWidth: E,
  borderLeftWidth: E,
  borderRadius: E,
  borderTopLeftRadius: E,
  borderTopRightRadius: E,
  borderBottomRightRadius: E,
  borderBottomLeftRadius: E,
  // Positioning props
  width: E,
  maxWidth: E,
  height: E,
  maxHeight: E,
  top: E,
  right: E,
  bottom: E,
  left: E,
  inset: E,
  insetBlock: E,
  insetBlockStart: E,
  insetBlockEnd: E,
  insetInline: E,
  insetInlineStart: E,
  insetInlineEnd: E,
  // Spacing props
  padding: E,
  paddingTop: E,
  paddingRight: E,
  paddingBottom: E,
  paddingLeft: E,
  paddingBlock: E,
  paddingBlockStart: E,
  paddingBlockEnd: E,
  paddingInline: E,
  paddingInlineStart: E,
  paddingInlineEnd: E,
  margin: E,
  marginTop: E,
  marginRight: E,
  marginBottom: E,
  marginLeft: E,
  marginBlock: E,
  marginBlockStart: E,
  marginBlockEnd: E,
  marginInline: E,
  marginInlineStart: E,
  marginInlineEnd: E,
  // Typography
  fontSize: E,
  // Misc
  backgroundPositionX: E,
  backgroundPositionY: E,
  ...rm,
  zIndex: Ys,
  // SVG
  fillOpacity: qt,
  strokeOpacity: qt,
  numOctaves: Ys
}, im = {
  ...jn,
  // Color props
  color: oe,
  backgroundColor: oe,
  outlineColor: oe,
  fill: oe,
  stroke: oe,
  // Border props
  borderColor: oe,
  borderTopColor: oe,
  borderRightColor: oe,
  borderBottomColor: oe,
  borderLeftColor: oe,
  filter: Zr,
  WebkitFilter: Zr,
  mask: qr,
  WebkitMask: qr
}, _l = (e) => im[e], sm = /* @__PURE__ */ new Set([Zr, qr]);
function Ol(e, t) {
  let n = _l(e);
  return sm.has(n) || (n = ze), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const om = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function am(e, t, n) {
  let r = 0, s;
  for (; r < e.length && !s; ) {
    const a = e[r];
    typeof a == "string" && !om.has(a) && Pt(a).values.length && (s = e[r]), r++;
  }
  if (s && n)
    for (const a of t)
      e[a] = Ol(n, s);
}
class lm extends Ei {
  constructor(t, n, r, s, a) {
    super(t, n, r, s, a, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let u = 0; u < t.length; u++) {
      let h = t[u];
      if (typeof h == "string" && (h = h.trim(), Ci(h))) {
        const f = Vl(h, n.current);
        f !== void 0 && (t[u] = f), u === t.length - 1 && (this.finalKeyframe = h);
      }
    }
    if (this.resolveNoneKeyframes(), !Ll.has(r) || t.length !== 2)
      return;
    const [s, a] = t, o = Xs(s), l = Xs(a), c = Ls(s), d = Ls(a);
    if (c !== d && qe[r]) {
      this.needsMeasurement = !0;
      return;
    }
    if (o !== l)
      if ($s(o) && $s(l))
        for (let u = 0; u < t.length; u++) {
          const h = t[u];
          typeof h == "string" && (t[u] = parseFloat(h));
        }
      else qe[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let s = 0; s < t.length; s++)
      (t[s] === null || Qp(t[s])) && r.push(s);
    r.length && am(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = qe[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const s = n[n.length - 1];
    s !== void 0 && t.getValue(r, s).jump(s, !1);
  }
  measureEndState() {
    var l;
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const s = t.getValue(n);
    s && s.jump(this.measuredOrigin, !1);
    const a = r.length - 1, o = r[a];
    r[a] = qe[n](t.measureViewportBox(), window.getComputedStyle(t.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), (l = this.removedTransforms) != null && l.length && this.removedTransforms.forEach(([c, d]) => {
      t.getValue(c).set(d);
    }), this.resolveNoneKeyframes();
  }
}
const Bi = [
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomRightRadius",
  "borderBottomLeftRadius"
];
function Hl(e, t, n) {
  if (e == null)
    return [];
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const s = (n == null ? void 0 : n[e]) ?? r.querySelectorAll(e);
    return s ? Array.from(s) : [];
  }
  return Array.from(e).filter((r) => r != null);
}
const Jr = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function cm(e) {
  return Ya(e) && "offsetHeight" in e && !("ownerSVGElement" in e);
}
const { schedule: ji } = /* @__PURE__ */ cl(queueMicrotask, !1), Le = {
  x: !1,
  y: !1
};
function $l() {
  return Le.x || Le.y;
}
function dm(e) {
  return e === "x" || e === "y" ? Le[e] ? null : (Le[e] = !0, () => {
    Le[e] = !1;
  }) : Le.x || Le.y ? null : (Le.x = Le.y = !0, () => {
    Le.x = Le.y = !1;
  });
}
function Ul(e, t) {
  const n = Hl(e), r = new AbortController(), s = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, s, () => r.abort()];
}
function um(e) {
  return !(e.pointerType === "touch" || $l());
}
function hm(e, t, n = {}) {
  const [r, s, a] = Ul(e, n);
  return r.forEach((o) => {
    let l = !1, c = !1, d;
    const u = () => {
      o.removeEventListener("pointerleave", p);
    }, h = (b) => {
      d && (d(b), d = void 0), u();
    }, f = (b) => {
      l = !1, window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", f), c && (c = !1, h(b));
    }, y = () => {
      l = !0, window.addEventListener("pointerup", f, s), window.addEventListener("pointercancel", f, s);
    }, p = (b) => {
      if (b.pointerType !== "touch") {
        if (l) {
          c = !0;
          return;
        }
        h(b);
      }
    }, v = (b) => {
      if (!um(b))
        return;
      c = !1;
      const x = t(o, b);
      typeof x == "function" && (d = x, o.addEventListener("pointerleave", p, s));
    };
    o.addEventListener("pointerenter", v, s), o.addEventListener("pointerdown", y, s);
  }), a;
}
const Wl = (e, t) => t ? e === t ? !0 : Wl(e, t.parentElement) : !1, Fi = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, fm = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function pm(e) {
  return fm.has(e.tagName) || e.isContentEditable === !0;
}
const mm = /* @__PURE__ */ new Set(["INPUT", "SELECT", "TEXTAREA"]);
function gm(e) {
  return mm.has(e.tagName) || e.isContentEditable === !0;
}
const Cn = /* @__PURE__ */ new WeakSet();
function Zs(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function gr(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const ym = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = Zs(() => {
    if (Cn.has(n))
      return;
    gr(n, "down");
    const s = Zs(() => {
      gr(n, "up");
    }), a = () => gr(n, "cancel");
    n.addEventListener("keyup", s, t), n.addEventListener("blur", a, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function qs(e) {
  return Fi(e) && !$l();
}
const Js = /* @__PURE__ */ new WeakSet();
function vm(e, t, n = {}) {
  const [r, s, a] = Ul(e, n), o = (l) => {
    const c = l.currentTarget;
    if (!qs(l) || Js.has(l))
      return;
    Cn.add(c), n.stopPropagation && Js.add(l);
    const d = t(c, l), u = { ...s, capture: !0 }, h = (p, v) => {
      window.removeEventListener("pointerup", f, u), window.removeEventListener("pointercancel", y, u), Cn.has(c) && Cn.delete(c), qs(p) && typeof d == "function" && d(p, { success: v });
    }, f = (p) => {
      h(p, c === window || c === document || n.useGlobalTarget || Wl(c, p.target));
    }, y = (p) => {
      h(p, !1);
    };
    window.addEventListener("pointerup", f, u), window.addEventListener("pointercancel", y, u);
  };
  return r.forEach((l) => {
    (n.useGlobalTarget ? window : l).addEventListener("pointerdown", o, s), cm(l) && (l.addEventListener("focus", (d) => ym(d, s)), !pm(l) && !l.hasAttribute("tabindex") && (l.tabIndex = 0));
  }), a;
}
function _i(e) {
  return Ya(e) && "ownerSVGElement" in e;
}
const Mn = /* @__PURE__ */ new WeakMap();
let Ze;
const Gl = (e, t, n) => (r, s) => s && s[0] ? s[0][e + "Size"] : _i(r) && "getBBox" in r ? r.getBBox()[t] : r[n], bm = /* @__PURE__ */ Gl("inline", "width", "offsetWidth"), xm = /* @__PURE__ */ Gl("block", "height", "offsetHeight");
function wm({ target: e, borderBoxSize: t }) {
  var n;
  (n = Mn.get(e)) == null || n.forEach((r) => {
    r(e, {
      get width() {
        return bm(e, t);
      },
      get height() {
        return xm(e, t);
      }
    });
  });
}
function km(e) {
  e.forEach(wm);
}
function Sm() {
  typeof ResizeObserver > "u" || (Ze = new ResizeObserver(km));
}
function Nm(e, t) {
  Ze || Sm();
  const n = Hl(e);
  return n.forEach((r) => {
    let s = Mn.get(r);
    s || (s = /* @__PURE__ */ new Set(), Mn.set(r, s)), s.add(t), Ze == null || Ze.observe(r);
  }), () => {
    n.forEach((r) => {
      const s = Mn.get(r);
      s == null || s.delete(t), s != null && s.size || Ze == null || Ze.unobserve(r);
    });
  };
}
const Pn = /* @__PURE__ */ new Set();
let Nt;
function Tm() {
  Nt = () => {
    const e = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    Pn.forEach((t) => t(e));
  }, window.addEventListener("resize", Nt);
}
function Cm(e) {
  return Pn.add(e), Nt || Tm(), () => {
    Pn.delete(e), !Pn.size && typeof Nt == "function" && (window.removeEventListener("resize", Nt), Nt = void 0);
  };
}
function Qs(e, t) {
  return typeof e == "function" ? Cm(e) : Nm(e, t);
}
function Mm(e) {
  return _i(e) && e.tagName === "svg";
}
const Pm = [...Fl, oe, ze], Dm = (e) => Pm.find(jl(e)), eo = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Tt = () => ({
  x: eo(),
  y: eo()
}), to = () => ({ min: 0, max: 0 }), ce = () => ({
  x: to(),
  y: to()
}), Im = /* @__PURE__ */ new WeakMap();
function Yn(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function Jt(e) {
  return typeof e == "string" || Array.isArray(e);
}
const Oi = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Hi = ["initial", ...Oi];
function Zn(e) {
  return Yn(e.animate) || Hi.some((t) => Jt(e[t]));
}
function Kl(e) {
  return !!(Zn(e) || e.variants);
}
function Am(e, t, n) {
  for (const r in t) {
    const s = t[r], a = n[r];
    if (fe(s))
      e.addValue(r, s);
    else if (fe(a))
      e.addValue(r, Dt(s, { owner: e }));
    else if (a !== s)
      if (e.hasValue(r)) {
        const o = e.getValue(r);
        o.liveStyle === !0 ? o.jump(s) : o.hasAnimated || o.set(s);
      } else {
        const o = e.getStaticValue(r);
        e.addValue(r, Dt(o !== void 0 ? o : s, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const Fn = { current: null }, $i = { current: !1 }, Em = typeof window < "u";
function Xl() {
  if ($i.current = !0, !!Em)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Fn.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      Fn.current = !1;
}
const no = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let _n = {};
function Yl(e) {
  _n = e;
}
function Vm() {
  return _n;
}
class Lm {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: s, skipAnimations: a, blockInitialAnimation: o, visualState: l }, c = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Ei, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const y = ye.now();
      this.renderScheduledAt < y && (this.renderScheduledAt = y, q.render(this.render, !1, !0));
    };
    const { latestValues: d, renderState: u } = l;
    this.latestValues = d, this.baseTarget = { ...d }, this.initialValues = n.initial ? { ...d } : {}, this.renderState = u, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = s, this.skipAnimationsConfig = a, this.options = c, this.blockInitialAnimation = !!o, this.isControllingVariants = Zn(n), this.isVariantNode = Kl(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: h, ...f } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const y in f) {
      const p = f[y];
      d[y] !== void 0 && fe(p) && p.set(d[y]);
    }
  }
  mount(t) {
    var n, r;
    if (this.hasBeenMounted)
      for (const s in this.initialValues)
        (n = this.values.get(s)) == null || n.jump(this.initialValues[s]), this.latestValues[s] = this.initialValues[s];
    this.current = t, Im.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((s, a) => this.bindToMotionValue(a, s)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : ($i.current || Xl(), this.shouldReduceMotion = Fn.current), process.env.NODE_ENV !== "production" && Kn(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, (r = this.parent) == null || r.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
  }
  unmount() {
    var t;
    this.projection && this.projection.unmount(), Qe(this.notifyUpdate), Qe(this.render), this.valueSubscriptions.forEach((n) => n()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (t = this.parent) == null || t.removeChild(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features) {
      const r = this.features[n];
      r && (r.unmount(), r.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, n) {
    if (this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)(), n.accelerate && Il.has(t) && this.current instanceof HTMLElement) {
      const { factory: o, keyframes: l, times: c, ease: d, duration: u } = n.accelerate, h = new Pl({
        element: this.current,
        name: t,
        keyframes: l,
        times: c,
        ease: d,
        duration: /* @__PURE__ */ we(u)
      }), f = o(h);
      this.valueSubscriptions.set(t, () => {
        f(), h.cancel();
      });
      return;
    }
    const r = Lt.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const s = n.on("change", (o) => {
      this.latestValues[t] = o, this.props.onUpdate && q.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let a;
    typeof window < "u" && window.MotionCheckAppearSync && (a = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      s(), a && a();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in _n) {
      const n = _n[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: s } = n;
      if (!this.features[t] && s && r(this.props) && (this.features[t] = new s(this)), this.features[t]) {
        const a = this.features[t];
        a.isMounted ? a.update() : (a.mount(), a.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ce();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < no.length; r++) {
      const s = no[r];
      this.propEventSubscriptions[s] && (this.propEventSubscriptions[s](), delete this.propEventSubscriptions[s]);
      const a = "on" + s, o = t[a];
      o && (this.propEventSubscriptions[s] = this.on(s, o));
    }
    this.prevMotionValues = Am(this, this.scrapeMotionValuesFromProps(t, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Dt(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (Xa(r) || Za(r)) ? r = parseFloat(r) : !Dm(r) && ze.test(n) && (r = Ol(t, n)), this.setBaseTarget(t, fe(r) ? r.get() : r)), fe(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var a;
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const o = Ri(this.props, n, (a = this.presenceContext) == null ? void 0 : a.custom);
      o && (r = o[t]);
    }
    if (n && r !== void 0)
      return r;
    const s = this.getBaseTargetFromProps(this.props, t);
    return s !== void 0 && !fe(s) ? s : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Si()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    ji.render(this.render);
  }
}
class Zl extends Lm {
  constructor() {
    super(...arguments), this.KeyframeResolver = lm;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    const r = t.style;
    return r ? r[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    fe(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class et {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function ql({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function Rm({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function zm(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function yr(e) {
  return e === void 0 || e === 1;
}
function Qr({ scale: e, scaleX: t, scaleY: n }) {
  return !yr(e) || !yr(t) || !yr(n);
}
function ot(e) {
  return Qr(e) || Jl(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function Jl(e) {
  return ro(e.x) || ro(e.y);
}
function ro(e) {
  return e && e !== "0%";
}
function On(e, t, n) {
  const r = e - n, s = t * r;
  return n + s;
}
function io(e, t, n, r, s) {
  return s !== void 0 && (e = On(e, s, r)), On(e, n, r) + t;
}
function ei(e, t = 0, n = 1, r, s) {
  e.min = io(e.min, t, n, r, s), e.max = io(e.max, t, n, r, s);
}
function Ql(e, { x: t, y: n }) {
  ei(e.x, t.translate, t.scale, t.originPoint), ei(e.y, n.translate, n.scale, n.originPoint);
}
const so = 0.999999999999, oo = 1.0000000000001;
function Bm(e, t, n, r = !1) {
  var l;
  const s = n.length;
  if (!s)
    return;
  t.x = t.y = 1;
  let a, o;
  for (let c = 0; c < s; c++) {
    a = n[c], o = a.projectionDelta;
    const { visualElement: d } = a.options;
    d && d.props.style && d.props.style.display === "contents" || (r && a.options.layoutScroll && a.scroll && a !== a.root && (Oe(e.x, -a.scroll.offset.x), Oe(e.y, -a.scroll.offset.y)), o && (t.x *= o.x.scale, t.y *= o.y.scale, Ql(e, o)), r && ot(a.latestValues) && Dn(e, a.latestValues, (l = a.layout) == null ? void 0 : l.layoutBox));
  }
  t.x < oo && t.x > so && (t.x = 1), t.y < oo && t.y > so && (t.y = 1);
}
function Oe(e, t) {
  e.min += t, e.max += t;
}
function ao(e, t, n, r, s = 0.5) {
  const a = Z(e.min, e.max, s);
  ei(e, t, n, a, r);
}
function lo(e, t) {
  return typeof e == "string" ? parseFloat(e) / 100 * (t.max - t.min) : e;
}
function Dn(e, t, n) {
  const r = n ?? e;
  ao(e.x, lo(t.x, r.x), t.scaleX, t.scale, t.originX), ao(e.y, lo(t.y, r.y), t.scaleY, t.scale, t.originY);
}
function ec(e, t) {
  return ql(zm(e.getBoundingClientRect(), t));
}
function jm(e, t, n) {
  const r = ec(e, n), { scroll: s } = t;
  return s && (Oe(r.x, s.offset.x), Oe(r.y, s.offset.y)), r;
}
const Fm = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, _m = Vt.length;
function Om(e, t, n) {
  let r = "", s = !0;
  for (let o = 0; o < _m; o++) {
    const l = Vt[o], c = e[l];
    if (c === void 0)
      continue;
    let d = !0;
    if (typeof c == "number")
      d = c === (l.startsWith("scale") ? 1 : 0);
    else {
      const u = parseFloat(c);
      d = l.startsWith("scale") ? u === 1 : u === 0;
    }
    if (!d || n) {
      const u = Jr(c, jn[l]);
      if (!d) {
        s = !1;
        const h = Fm[l] || l;
        r += `${h}(${u}) `;
      }
      n && (t[l] = u);
    }
  }
  const a = e.pathRotation;
  return a && (s = !1, r += `rotate(${Jr(a, jn.pathRotation)}) `), r = r.trim(), n ? r = n(t, s ? "" : r) : s && (r = "none"), r;
}
function Ui(e, t, n) {
  const { style: r, vars: s, transformOrigin: a } = e;
  let o = !1, l = !1;
  for (const c in t) {
    const d = t[c];
    if (Lt.has(c)) {
      o = !0;
      continue;
    } else if (ul(c)) {
      s[c] = d;
      continue;
    } else {
      const u = Jr(d, jn[c]);
      c.startsWith("origin") ? (l = !0, a[c] = u) : r[c] = u;
    }
  }
  if (t.transform || (o || n ? r.transform = Om(t, e.transform, n) : r.transform && (r.transform = "none")), l) {
    const { originX: c = "50%", originY: d = "50%", originZ: u = 0 } = a;
    r.transformOrigin = `${c} ${d} ${u}`;
  }
}
function tc(e, { style: t, vars: n }, r, s) {
  const a = e.style;
  let o;
  for (o in t)
    a[o] = t[o];
  s == null || s.applyProjectionStyles(a, r);
  for (o in n)
    a.setProperty(o, n[o]);
}
function co(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const zt = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (E.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = co(e, t.target.x), r = co(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, Hm = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, s = ze.parse(e);
    if (s.length > 5)
      return r;
    const a = ze.createTransformer(e), o = typeof s[0] != "number" ? 1 : 0, l = n.x.scale * t.x, c = n.y.scale * t.y;
    s[0 + o] /= l, s[1 + o] /= c;
    const d = Z(l, c, 0.5);
    return typeof s[2 + o] == "number" && (s[2 + o] /= d), typeof s[3 + o] == "number" && (s[3 + o] /= d), a(s);
  }
}, ti = {
  borderRadius: {
    ...zt,
    applyTo: [...Bi]
  },
  borderTopLeftRadius: zt,
  borderTopRightRadius: zt,
  borderBottomLeftRadius: zt,
  borderBottomRightRadius: zt,
  boxShadow: Hm
};
function nc(e, { layout: t, layoutId: n }) {
  return Lt.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!ti[e] || e === "opacity");
}
function Wi(e, t, n) {
  var o;
  const r = e.style, s = t == null ? void 0 : t.style, a = {};
  if (!r)
    return a;
  for (const l in r)
    (fe(r[l]) || s && fe(s[l]) || nc(l, e) || ((o = n == null ? void 0 : n.getValue(l)) == null ? void 0 : o.liveStyle) !== void 0) && (a[l] = r[l]);
  return a;
}
function $m(e) {
  return window.getComputedStyle(e);
}
class Um extends Zl {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = tc;
  }
  mount(t) {
    Ke(!!t.style, "motion.create() components must forward their ref to a HTML or SVG element", "custom-component-ref"), super.mount(t);
  }
  readValueFromInstance(t, n) {
    var r;
    if (Lt.has(n))
      return (r = this.projection) != null && r.isProjecting ? Or(n) : cp(t, n);
    {
      const s = $m(t), a = (ul(n) ? s.getPropertyValue(n) : s[n]) || 0;
      return typeof a == "string" ? a.trim() : a;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return ec(t, n);
  }
  build(t, n, r) {
    Ui(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Wi(t, n, r);
  }
}
const Wm = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Gm = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Km(e, t, n = 1, r = 0, s = !0) {
  e.pathLength = 1;
  const a = s ? Wm : Gm;
  e[a.offset] = `${-r}`, e[a.array] = `${t} ${n}`;
}
const Xm = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function rc(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: s,
  pathSpacing: a = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...l
}, c, d, u) {
  if (Ui(e, l, d), c) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: h, style: f } = e;
  h.transform && (f.transform = h.transform, delete h.transform), (f.transform || h.transformOrigin) && (f.transformOrigin = h.transformOrigin ?? "50% 50%", delete h.transformOrigin), f.transform && (f.transformBox = (u == null ? void 0 : u.transformBox) ?? "fill-box", delete h.transformBox);
  for (const y of Xm)
    h[y] !== void 0 && (f[y] = h[y], delete h[y]);
  t !== void 0 && (h.x = t), n !== void 0 && (h.y = n), r !== void 0 && (h.scale = r), s !== void 0 && Km(h, s, a, o, !1);
}
const ic = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), sc = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function Ym(e, t, n, r) {
  tc(e, t, void 0, r);
  for (const s in t.attrs)
    e.setAttribute(ic.has(s) ? s : zi(s), t.attrs[s]);
}
function oc(e, t, n) {
  const r = Wi(e, t, n);
  for (const s in e)
    if (fe(e[s]) || fe(t[s])) {
      const a = Vt.indexOf(s) !== -1 ? "attr" + s.charAt(0).toUpperCase() + s.substring(1) : s;
      r[a] = e[s];
    }
  return r;
}
class Zm extends Zl {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = ce;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Lt.has(n)) {
      const r = _l(n);
      return r && r.default || 0;
    }
    return n = ic.has(n) ? n : zi(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return oc(t, n, r);
  }
  build(t, n, r) {
    rc(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, s) {
    Ym(t, n, r, s);
  }
  mount(t) {
    this.isSVGTag = sc(t.tagName), super.mount(t);
  }
}
const qm = Hi.length;
function ac(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? ac(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < qm; n++) {
    const r = Hi[n], s = e.props[r];
    (Jt(s) || s === !1) && (t[r] = s);
  }
  return t;
}
function lc(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const Jm = [...Oi].reverse(), Qm = Oi.length;
function eg(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => qp(e, n, r)));
}
function tg(e) {
  let t = eg(e), n = uo(), r = !0, s = !1;
  const a = (d) => (u, h) => {
    var y;
    const f = ht(e, h, d === "exit" ? (y = e.presenceContext) == null ? void 0 : y.custom : void 0);
    if (f) {
      const { transition: p, transitionEnd: v, ...b } = f;
      u = { ...u, ...b, ...v };
    }
    return u;
  };
  function o(d) {
    t = d(e);
  }
  function l(d) {
    const { props: u } = e, h = ac(e.parent) || {}, f = [], y = /* @__PURE__ */ new Set();
    let p = {}, v = 1 / 0;
    for (let x = 0; x < Qm; x++) {
      const w = Jm[x], S = n[w], k = u[w] !== void 0 ? u[w] : h[w], N = Jt(k), A = w === d ? S.isActive : null;
      A === !1 && (v = x);
      let C = k === h[w] && k !== u[w] && N;
      if (C && (r || s) && e.manuallyAnimateOnMount && (C = !1), S.protectedKeys = { ...p }, // If it isn't active and hasn't *just* been set as inactive
      !S.isActive && A === null || // If we didn't and don't have any defined prop for this animation type
      !k && !S.prevProp || // Or if the prop doesn't define an animation
      Yn(k) || typeof k == "boolean")
        continue;
      if (w === "exit" && S.isActive && A !== !0) {
        S.prevResolvedValues && (p = {
          ...p,
          ...S.prevResolvedValues
        });
        continue;
      }
      const M = ng(S.prevProp, k);
      let R = M || // If we're making this variant active, we want to always make it active
      w === d && S.isActive && !C && N || // If we removed a higher-priority variant (i is in reverse order)
      x > v && N, D = !1;
      const V = Array.isArray(k) ? k : [k];
      let L = V.reduce(a(w), {});
      A === !1 && (L = {});
      const { prevResolvedValues: Q = {} } = S, le = {
        ...Q,
        ...L
      }, _ = (K) => {
        R = !0, y.has(K) && (D = !0, y.delete(K)), S.needsAnimating[K] = !0;
        const j = e.getValue(K);
        j && (j.liveStyle = !1);
      };
      for (const K in le) {
        const j = L[K], ie = Q[K];
        if (p.hasOwnProperty(K))
          continue;
        let ue = !1;
        Kr(j) && Kr(ie) ? ue = !lc(j, ie) || M : ue = j !== ie, ue ? j != null ? _(K) : y.add(K) : j !== void 0 && y.has(K) ? _(K) : S.protectedKeys[K] = !0;
      }
      S.prevProp = k, S.prevResolvedValues = L, S.isActive && (p = { ...p, ...L }), (r || s) && e.blockInitialAnimation && (R = !1);
      const G = C && M;
      R && (!G || D) && f.push(...V.map((K) => {
        const j = { type: w };
        if (typeof K == "string" && (r || s) && !G && e.manuallyAnimateOnMount && e.parent) {
          const { parent: ie } = e, ue = ht(ie, K);
          if (ie.enteringChildren && ue) {
            const { delayChildren: je } = ue.transition || {};
            j.delay = Al(ie.enteringChildren, e, je);
          }
        }
        return {
          animation: K,
          options: j
        };
      }));
    }
    if (y.size) {
      const x = {};
      if (typeof u.initial != "boolean") {
        const w = ht(e, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        w && w.transition && (x.transition = w.transition);
      }
      y.forEach((w) => {
        const S = e.getBaseTarget(w), k = e.getValue(w);
        k && (k.liveStyle = !0), x[w] = S ?? null;
      }), f.push({ animation: x });
    }
    let b = !!f.length;
    return r && (u.initial === !1 || u.initial === u.animate) && !e.manuallyAnimateOnMount && (b = !1), r = !1, s = !1, b ? t(f) : Promise.resolve();
  }
  function c(d, u) {
    var f;
    if (n[d].isActive === u)
      return Promise.resolve();
    (f = e.variantChildren) == null || f.forEach((y) => {
      var p;
      return (p = y.animationState) == null ? void 0 : p.setActive(d, u);
    }), n[d].isActive = u;
    const h = l(d);
    for (const y in n)
      n[y].protectedKeys = {};
    return h;
  }
  return {
    animateChanges: l,
    setActive: c,
    setAnimateFunction: o,
    getState: () => n,
    reset: () => {
      n = uo(), s = !0;
    }
  };
}
function ng(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !lc(t, e) : !1;
}
function st(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function uo() {
  return {
    animate: st(!0),
    whileInView: st(),
    whileHover: st(),
    whileTap: st(),
    whileDrag: st(),
    whileFocus: st(),
    exit: st()
  };
}
function ni(e, t) {
  e.min = t.min, e.max = t.max;
}
function Ve(e, t) {
  ni(e.x, t.x), ni(e.y, t.y);
}
function ho(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
const cc = 1e-4, rg = 1 - cc, ig = 1 + cc, dc = 0.01, sg = 0 - dc, og = 0 + dc;
function ve(e) {
  return e.max - e.min;
}
function ag(e, t, n) {
  return Math.abs(e - t) <= n;
}
function fo(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Z(t.min, t.max, e.origin), e.scale = ve(n) / ve(t), e.translate = Z(n.min, n.max, e.origin) - e.originPoint, (e.scale >= rg && e.scale <= ig || isNaN(e.scale)) && (e.scale = 1), (e.translate >= sg && e.translate <= og || isNaN(e.translate)) && (e.translate = 0);
}
function $t(e, t, n, r) {
  fo(e.x, t.x, n.x, r ? r.originX : void 0), fo(e.y, t.y, n.y, r ? r.originY : void 0);
}
function po(e, t, n, r = 0) {
  const s = r ? Z(n.min, n.max, r) : n.min;
  e.min = s + t.min, e.max = e.min + ve(t);
}
function lg(e, t, n, r) {
  po(e.x, t.x, n.x, r == null ? void 0 : r.x), po(e.y, t.y, n.y, r == null ? void 0 : r.y);
}
function mo(e, t, n, r = 0) {
  const s = r ? Z(n.min, n.max, r) : n.min;
  e.min = t.min - s, e.max = e.min + ve(t);
}
function Hn(e, t, n, r) {
  mo(e.x, t.x, n.x, r == null ? void 0 : r.x), mo(e.y, t.y, n.y, r == null ? void 0 : r.y);
}
function go(e, t, n, r, s) {
  return e -= t, e = On(e, 1 / n, r), s !== void 0 && (e = On(e, 1 / s, r)), e;
}
function cg(e, t = 0, n = 1, r = 0.5, s, a = e, o = e) {
  if ($e.test(t) && (t = parseFloat(t), t = Z(o.min, o.max, t / 100) - o.min), typeof t != "number")
    return;
  let l = Z(a.min, a.max, r);
  e === a && (l -= t), e.min = go(e.min, t, n, l, s), e.max = go(e.max, t, n, l, s);
}
function yo(e, t, [n, r, s], a, o) {
  cg(e, t[n], t[r], t[s], t.scale, a, o);
}
const dg = ["x", "scaleX", "originX"], ug = ["y", "scaleY", "originY"];
function vo(e, t, n, r) {
  yo(e.x, t, dg, n ? n.x : void 0, r ? r.x : void 0), yo(e.y, t, ug, n ? n.y : void 0, r ? r.y : void 0);
}
function bo(e) {
  return e.translate === 0 && e.scale === 1;
}
function uc(e) {
  return bo(e.x) && bo(e.y);
}
function xo(e, t) {
  return e.min === t.min && e.max === t.max;
}
function hg(e, t) {
  return xo(e.x, t.x) && xo(e.y, t.y);
}
function wo(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function hc(e, t) {
  return wo(e.x, t.x) && wo(e.y, t.y);
}
function ko(e) {
  return ve(e.x) / ve(e.y);
}
function So(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
function _e(e) {
  return [e("x"), e("y")];
}
function fg(e, t, n) {
  let r = "";
  const s = e.x.translate / t.x, a = e.y.translate / t.y, o = (n == null ? void 0 : n.z) || 0;
  if ((s || a || o) && (r = `translate3d(${s}px, ${a}px, ${o}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: d, rotate: u, pathRotation: h, rotateX: f, rotateY: y, skewX: p, skewY: v } = n;
    d && (r = `perspective(${d}px) ${r}`), u && (r += `rotate(${u}deg) `), h && (r += `rotate(${h}deg) `), f && (r += `rotateX(${f}deg) `), y && (r += `rotateY(${y}deg) `), p && (r += `skewX(${p}deg) `), v && (r += `skewY(${v}deg) `);
  }
  const l = e.x.scale * t.x, c = e.y.scale * t.y;
  return (l !== 1 || c !== 1) && (r += `scale(${l}, ${c})`), r || "none";
}
const pg = Bi.length, No = (e) => typeof e == "string" ? parseFloat(e) : e, To = (e) => typeof e == "number" || E.test(e);
function mg(e, t, n, r, s, a) {
  s ? (e.opacity = Z(0, n.opacity ?? 1, gg(r)), e.opacityExit = Z(t.opacity ?? 1, 0, yg(r))) : a && (e.opacity = Z(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let o = 0; o < pg; o++) {
    const l = Bi[o];
    let c = Co(t, l), d = Co(n, l);
    if (c === void 0 && d === void 0)
      continue;
    c || (c = 0), d || (d = 0), c === 0 || d === 0 || To(c) === To(d) ? (e[l] = Math.max(Z(No(c), No(d), r), 0), ($e.test(d) || $e.test(c)) && (e[l] += "%")) : e[l] = d;
  }
  (t.rotate || n.rotate) && (e.rotate = Z(t.rotate || 0, n.rotate || 0, r));
}
function Co(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const gg = /* @__PURE__ */ fc(0, 0.5, sl), yg = /* @__PURE__ */ fc(0.5, 0.95, De);
function fc(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ Zt(e, t, r));
}
function vg(e, t, n) {
  const r = fe(e) ? e : Dt(e);
  return r.start(Li("", r, t, n)), r.animation;
}
function Qt(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n, r);
}
const bg = (e, t) => e.depth - t.depth;
class xg {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    ki(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Vn(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(bg), this.isDirty = !1, this.children.forEach(t);
  }
}
function wg(e, t) {
  const n = ye.now(), r = ({ timestamp: s }) => {
    const a = s - n;
    a >= t && (Qe(r), e(a - t));
  };
  return q.setup(r, !0), () => Qe(r);
}
function In(e) {
  return fe(e) ? e.get() : e;
}
class kg {
  constructor() {
    this.members = [];
  }
  add(t) {
    ki(this.members, t);
    for (let n = this.members.length - 1; n >= 0; n--) {
      const r = this.members[n];
      if (r === t || r === this.lead || r === this.prevLead)
        continue;
      const s = r.instance;
      (!s || s.isConnected === !1) && !r.snapshot && (Vn(this.members, r), r.unmount());
    }
    t.scheduleRender();
  }
  remove(t) {
    if (Vn(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    var n;
    for (let r = this.members.indexOf(t) - 1; r >= 0; r--) {
      const s = this.members[r];
      if (s.isPresent !== !1 && ((n = s.instance) == null ? void 0 : n.isConnected) !== !1)
        return this.promote(s), !0;
    }
    return !1;
  }
  promote(t, n) {
    var s;
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.updateSnapshot(), t.scheduleRender();
      const { layoutDependency: a } = r.options, { layoutDependency: o } = t.options;
      (a === void 0 || a !== o) && (t.resumeFrom = r, n && (r.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), (s = t.root) != null && s.isUpdating && (t.isLayoutDirty = !0)), t.options.crossfade === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      var n, r, s, a, o;
      (r = (n = t.options).onExitComplete) == null || r.call(n), (o = (s = t.resumingFrom) == null ? void 0 : (a = s.options).onExitComplete) == null || o.call(a);
    });
  }
  scheduleRender() {
    this.members.forEach((t) => t.instance && t.scheduleRender(!1));
  }
  removeLeadSnapshot() {
    var t;
    (t = this.lead) != null && t.snapshot && (this.lead.snapshot = void 0);
  }
}
const An = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, vr = ["", "X", "Y", "Z"], Sg = 1e3;
let Ng = 0;
function br(e, t, n, r) {
  const { latestValues: s } = t;
  s[e] && (n[e] = s[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function pc(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = zl(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: s, layoutId: a } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", q, !(s || a));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && pc(r);
}
function mc({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: s }) {
  return class {
    constructor(o = {}, l = t == null ? void 0 : t()) {
      this.id = Ng++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(Mg), this.nodes.forEach(Vg), this.nodes.forEach(Lg), this.nodes.forEach(Pg);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = l ? l.root || l : this, this.path = l ? [...l.path, l] : [], this.parent = l, this.depth = l ? l.depth + 1 : 0;
      for (let c = 0; c < this.path.length; c++)
        this.path[c].shouldResetTransform = !0;
      this.root === this && (this.nodes = new xg());
    }
    addEventListener(o, l) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new Si()), this.eventHandlers.get(o).add(l);
    }
    notifyListeners(o, ...l) {
      const c = this.eventHandlers.get(o);
      c && c.notify(...l);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o) {
      if (this.instance)
        return;
      this.isSVG = _i(o) && !Mm(o), this.instance = o;
      const { layoutId: l, layout: c, visualElement: d } = this.options;
      if (d && !d.current && d.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (c || l) && (this.isLayoutDirty = !0), e) {
        let u, h = 0;
        const f = () => this.root.updateBlockedByResize = !1;
        q.read(() => {
          h = window.innerWidth;
        }), e(o, () => {
          const y = window.innerWidth;
          y !== h && (h = y, this.root.updateBlockedByResize = !0, u && u(), u = wg(f, 250), An.hasAnimatedSinceResize && (An.hasAnimatedSinceResize = !1, this.nodes.forEach(Do)));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && d && (l || c) && this.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: h, hasRelativeLayoutChanged: f, layout: y }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const p = this.options.transition || d.getDefaultTransition() || Fg, { onLayoutAnimationStart: v, onLayoutAnimationComplete: b } = d.getProps(), x = !this.targetLayout || !hc(this.targetLayout, y), w = !h && f;
        if (this.options.layoutRoot || this.resumeFrom || w || h && (x || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const S = {
            ...Vi(p, "layout"),
            onPlay: v,
            onComplete: b
          };
          (d.shouldReduceMotion || this.options.layoutRoot) && (S.delay = 0, S.type = !1), this.startAnimation(S), this.setAnimationOrigin(u, w, S.path);
        } else
          h || Do(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = y;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), Qe(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(Rg), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && pc(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const h = this.path[u];
        h.shouldResetTransform = !0, (typeof h.latestValues.x == "string" || typeof h.latestValues.y == "string") && (h.isLayoutDirty = !0), h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: l, layout: c } = this.options;
      if (l === void 0 && !c)
        return;
      const d = this.getTransformTemplate();
      this.prevTransformTemplateValue = d ? d(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        const c = this.updateBlockedByResize;
        this.unblockUpdate(), this.updateBlockedByResize = !1, this.clearAllSnapshots(), c && this.nodes.forEach(Ig), this.nodes.forEach(Mo);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(Po);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(Ag), this.nodes.forEach(Eg), this.nodes.forEach(Tg), this.nodes.forEach(Cg)) : this.nodes.forEach(Po), this.clearAllSnapshots();
      const l = ye.now();
      he.delta = Ge(0, 1e3 / 60, l - he.timestamp), he.timestamp = l, he.isProcessing = !0, dr.update.process(he), dr.preRender.process(he), dr.render.process(he), he.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, ji.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(Dg), this.sharedNodes.forEach(zg);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, q.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      q.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !ve(this.snapshot.measuredBox.x) && !ve(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let c = 0; c < this.path.length; c++)
          this.path[c].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected || (this.layoutCorrected = ce()), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: l } = this.options;
      l && l.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let l = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (l = !1), l && this.instance) {
        const c = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: c,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : c
        };
      }
    }
    resetTransform() {
      if (!s)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, l = this.projectionDelta && !uc(this.projectionDelta), c = this.getTransformTemplate(), d = c ? c(this.latestValues, "") : void 0, u = d !== this.prevTransformTemplateValue;
      o && this.instance && (l || ot(this.latestValues) || u) && (s(this.instance, d), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const l = this.measurePageBox();
      let c = this.removeElementScroll(l);
      return o && (c = this.removeTransform(c)), _g(c), {
        animationId: this.root.animationId,
        measuredBox: l,
        layoutBox: c,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var d;
      const { visualElement: o } = this.options;
      if (!o)
        return ce();
      const l = o.measureViewportBox();
      if (!(((d = this.scroll) == null ? void 0 : d.wasRoot) || this.path.some(Og))) {
        const { scroll: u } = this.root;
        u && (Oe(l.x, u.offset.x), Oe(l.y, u.offset.y));
      }
      return l;
    }
    removeElementScroll(o) {
      var c;
      const l = ce();
      if (Ve(l, o), (c = this.scroll) != null && c.wasRoot)
        return l;
      for (let d = 0; d < this.path.length; d++) {
        const u = this.path[d], { scroll: h, options: f } = u;
        u !== this.root && h && f.layoutScroll && (h.wasRoot && Ve(l, o), Oe(l.x, h.offset.x), Oe(l.y, h.offset.y));
      }
      return l;
    }
    applyTransform(o, l = !1, c) {
      var u, h;
      const d = c || ce();
      Ve(d, o);
      for (let f = 0; f < this.path.length; f++) {
        const y = this.path[f];
        !l && y.options.layoutScroll && y.scroll && y !== y.root && (Oe(d.x, -y.scroll.offset.x), Oe(d.y, -y.scroll.offset.y)), ot(y.latestValues) && Dn(d, y.latestValues, (u = y.layout) == null ? void 0 : u.layoutBox);
      }
      return ot(this.latestValues) && Dn(d, this.latestValues, (h = this.layout) == null ? void 0 : h.layoutBox), d;
    }
    removeTransform(o) {
      var c;
      const l = ce();
      Ve(l, o);
      for (let d = 0; d < this.path.length; d++) {
        const u = this.path[d];
        if (!ot(u.latestValues))
          continue;
        let h;
        u.instance && (Qr(u.latestValues) && u.updateSnapshot(), h = ce(), Ve(h, u.measurePageBox())), vo(l, u.latestValues, (c = u.snapshot) == null ? void 0 : c.layoutBox, h);
      }
      return ot(this.latestValues) && vo(l, this.latestValues), l;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== he.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var y;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== l;
      if (!(o || c && this.isSharedProjectionDirty || this.isProjectionDirty || (y = this.parent) != null && y.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: u, layoutId: h } = this.options;
      if (!this.layout || !(u || h))
        return;
      this.resolvedRelativeTargetAt = he.timestamp;
      const f = this.getClosestProjectingParent();
      f && this.linkedParentVersion !== f.layoutVersion && !f.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (this.options.layoutAnchor !== !1 && f && f.layout ? this.createRelativeTarget(f, this.layout.layoutBox, f.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = ce(), this.targetWithTransforms = ce()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), lg(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || void 0)) : this.targetDelta ? (this.resumingFrom ? this.applyTransform(this.layout.layoutBox, !1, this.target) : Ve(this.target, this.layout.layoutBox), Ql(this.target, this.targetDelta)) : Ve(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.options.layoutAnchor !== !1 && f && !!f.resumingFrom == !!this.resumingFrom && !f.options.layoutScroll && f.target && this.animationProgress !== 1 ? this.createRelativeTarget(f, this.target, f.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Qr(this.parent.latestValues) || Jl(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(o, l, c) {
      this.relativeParent = o, this.linkedParentVersion = o.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ce(), this.relativeTargetOrigin = ce(), Hn(this.relativeTargetOrigin, l, c, this.options.layoutAnchor || void 0), Ve(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      var p;
      const o = this.getLead(), l = !!this.resumingFrom || this !== o;
      let c = !0;
      if ((this.isProjectionDirty || (p = this.parent) != null && p.isProjectionDirty) && (c = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === he.timestamp && (c = !1), c)
        return;
      const { layout: d, layoutId: u } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(d || u))
        return;
      Ve(this.layoutCorrected, this.layout.layoutBox);
      const h = this.treeScale.x, f = this.treeScale.y;
      Bm(this.layoutCorrected, this.treeScale, this.path, l), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = ce());
      const { target: y } = o;
      if (!y) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (ho(this.prevProjectionDelta.x, this.projectionDelta.x), ho(this.prevProjectionDelta.y, this.projectionDelta.y)), $t(this.projectionDelta, this.layoutCorrected, y, this.latestValues), (this.treeScale.x !== h || this.treeScale.y !== f || !So(this.projectionDelta.x, this.prevProjectionDelta.x) || !So(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", y));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var l;
      if ((l = this.options.visualElement) == null || l.scheduleRender(), o) {
        const c = this.getStack();
        c && c.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Tt(), this.projectionDelta = Tt(), this.projectionDeltaWithTransform = Tt();
    }
    setAnimationOrigin(o, l = !1, c) {
      const d = this.snapshot, u = d ? d.latestValues : {}, h = { ...this.latestValues }, f = Tt();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !l;
      const y = ce(), p = d ? d.source : void 0, v = this.layout ? this.layout.source : void 0, b = p !== v, x = this.getStack(), w = !x || x.members.length <= 1, S = !!(b && !w && this.options.crossfade === !0 && !this.path.some(jg));
      this.animationProgress = 0;
      let k;
      const N = c == null ? void 0 : c.interpolateProjection(o);
      this.mixTargetDelta = (A) => {
        const C = A / 1e3, M = N == null ? void 0 : N(C);
        M ? (f.x.translate = M.x, f.x.scale = Z(o.x.scale, 1, C), f.x.origin = o.x.origin, f.x.originPoint = o.x.originPoint, f.y.translate = M.y, f.y.scale = Z(o.y.scale, 1, C), f.y.origin = o.y.origin, f.y.originPoint = o.y.originPoint) : (Io(f.x, o.x, C), Io(f.y, o.y, C)), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Hn(y, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || void 0), Bg(this.relativeTarget, this.relativeTargetOrigin, y, C), k && hg(this.relativeTarget, k) && (this.isProjectionDirty = !1), k || (k = ce()), Ve(k, this.relativeTarget)), b && (this.animationValues = h, mg(h, u, this.latestValues, C, S, w)), M && M.rotate !== void 0 && (this.animationValues || (this.animationValues = h), this.animationValues.pathRotation = M.rotate), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = C;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      var l, c, d;
      this.notifyListeners("animationStart"), (l = this.currentAnimation) == null || l.stop(), (d = (c = this.resumingFrom) == null ? void 0 : c.currentAnimation) == null || d.stop(), this.pendingAnimation && (Qe(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = q.update(() => {
        An.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Dt(0)), this.motionValue.jump(0, !1), this.currentAnimation = vg(this.motionValue, [0, 1e3], {
          ...o,
          velocity: 0,
          isSync: !0,
          onUpdate: (u) => {
            this.mixTargetDelta(u), o.onUpdate && o.onUpdate(u);
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Sg), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: l, target: c, layout: d, latestValues: u } = o;
      if (!(!l || !c || !d)) {
        if (this !== o && this.layout && d && gc(this.options.animationType, this.layout.layoutBox, d.layoutBox)) {
          c = this.target || ce();
          const h = ve(this.layout.layoutBox.x);
          c.x.min = o.target.x.min, c.x.max = c.x.min + h;
          const f = ve(this.layout.layoutBox.y);
          c.y.min = o.target.y.min, c.y.max = c.y.min + f;
        }
        Ve(l, c), Dn(l, u), $t(this.projectionDeltaWithTransform, this.layoutCorrected, l, u);
      }
    }
    registerSharedNode(o, l) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new kg()), this.sharedNodes.get(o).add(l);
      const d = l.options.initialPromotionConfig;
      l.promote({
        transition: d ? d.transition : void 0,
        preserveFollowOpacity: d && d.shouldPreserveFollowOpacity ? d.shouldPreserveFollowOpacity(l) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var l;
      const { layoutId: o } = this.options;
      return o ? ((l = this.getStack()) == null ? void 0 : l.lead) || this : this;
    }
    getPrevLead() {
      var l;
      const { layoutId: o } = this.options;
      return o ? (l = this.getStack()) == null ? void 0 : l.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: l, preserveFollowOpacity: c } = {}) {
      const d = this.getStack();
      d && d.promote(this, c), o && (this.projectionDelta = void 0, this.needsReset = !0), l && this.setOptions({ transition: l });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let l = !1;
      const { latestValues: c } = o;
      if ((c.z || c.rotate || c.rotateX || c.rotateY || c.rotateZ || c.skewX || c.skewY) && (l = !0), !l)
        return;
      const d = {};
      c.z && br("z", o, d, this.animationValues);
      for (let u = 0; u < vr.length; u++)
        br(`rotate${vr[u]}`, o, d, this.animationValues), br(`skew${vr[u]}`, o, d, this.animationValues);
      o.render();
      for (const u in d)
        o.setStaticValue(u, d[u]), this.animationValues && (this.animationValues[u] = d[u]);
      o.scheduleRender();
    }
    applyProjectionStyles(o, l) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        o.visibility = "hidden";
        return;
      }
      const c = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, o.visibility = "", o.opacity = "", o.pointerEvents = In(l == null ? void 0 : l.pointerEvents) || "", o.transform = c ? c(this.latestValues, "") : "none";
        return;
      }
      const d = this.getLead();
      if (!this.projectionDelta || !this.layout || !d.target) {
        this.options.layoutId && (o.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, o.pointerEvents = In(l == null ? void 0 : l.pointerEvents) || ""), this.hasProjected && !ot(this.latestValues) && (o.transform = c ? c({}, "") : "none", this.hasProjected = !1);
        return;
      }
      o.visibility = "";
      const u = d.animationValues || d.latestValues;
      this.applyTransformsToTarget();
      let h = fg(this.projectionDeltaWithTransform, this.treeScale, u);
      c && (h = c(u, h)), o.transform = h;
      const { x: f, y } = this.projectionDelta;
      o.transformOrigin = `${f.origin * 100}% ${y.origin * 100}% 0`, d.animationValues ? o.opacity = d === this ? u.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : u.opacityExit : o.opacity = d === this ? u.opacity !== void 0 ? u.opacity : "" : u.opacityExit !== void 0 ? u.opacityExit : 0;
      for (const p in ti) {
        if (u[p] === void 0)
          continue;
        const { correct: v, applyTo: b, isCSSVariable: x } = ti[p], w = h === "none" ? u[p] : v(u[p], d);
        if (b) {
          const S = b.length;
          for (let k = 0; k < S; k++)
            o[b[k]] = w;
        } else
          x ? this.options.visualElement.renderState.vars[p] = w : o[p] = w;
      }
      this.options.layoutId && (o.pointerEvents = d === this ? In(l == null ? void 0 : l.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var l;
        return (l = o.currentAnimation) == null ? void 0 : l.stop();
      }), this.root.nodes.forEach(Mo), this.root.sharedNodes.clear();
    }
  };
}
function Tg(e) {
  e.updateLayout();
}
function Cg(e) {
  var n;
  const t = ((n = e.resumeFrom) == null ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: s } = e.layout, { animationType: a } = e.options, o = t.source !== e.layout.source;
    if (a === "size")
      _e((h) => {
        const f = o ? t.measuredBox[h] : t.layoutBox[h], y = ve(f);
        f.min = r[h].min, f.max = f.min + y;
      });
    else if (a === "x" || a === "y") {
      const h = a === "x" ? "y" : "x";
      ni(o ? t.measuredBox[h] : t.layoutBox[h], r[h]);
    } else gc(a, t.layoutBox, r) && _e((h) => {
      const f = o ? t.measuredBox[h] : t.layoutBox[h], y = ve(r[h]);
      f.max = f.min + y, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[h].max = e.relativeTarget[h].min + y);
    });
    const l = Tt();
    $t(l, r, t.layoutBox);
    const c = Tt();
    o ? $t(c, e.applyTransform(s, !0), t.measuredBox) : $t(c, r, t.layoutBox);
    const d = !uc(l);
    let u = !1;
    if (!e.resumeFrom) {
      const h = e.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: f, layout: y } = h;
        if (f && y) {
          const p = e.options.layoutAnchor || void 0, v = ce();
          Hn(v, t.layoutBox, f.layoutBox, p);
          const b = ce();
          Hn(b, r, y.layoutBox, p), hc(v, b) || (u = !0), h.options.layoutRoot && (e.relativeTarget = b, e.relativeTargetOrigin = v, e.relativeParent = h);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: t,
      delta: c,
      layoutDelta: l,
      hasLayoutChanged: d,
      hasRelativeLayoutChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function Mg(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function Pg(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function Dg(e) {
  e.clearSnapshot();
}
function Mo(e) {
  e.clearMeasurements();
}
function Ig(e) {
  e.isLayoutDirty = !0, e.updateLayout();
}
function Po(e) {
  e.isLayoutDirty = !1;
}
function Ag(e) {
  e.isAnimationBlocked && e.layout && !e.isLayoutDirty && (e.snapshot = e.layout, e.isLayoutDirty = !0);
}
function Eg(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function Do(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function Vg(e) {
  e.resolveTargetDelta();
}
function Lg(e) {
  e.calcProjection();
}
function Rg(e) {
  e.resetSkewAndRotation();
}
function zg(e) {
  e.removeLeadSnapshot();
}
function Io(e, t, n) {
  e.translate = Z(t.translate, 0, n), e.scale = Z(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function Ao(e, t, n, r) {
  e.min = Z(t.min, n.min, r), e.max = Z(t.max, n.max, r);
}
function Bg(e, t, n, r) {
  Ao(e.x, t.x, n.x, r), Ao(e.y, t.y, n.y, r);
}
function jg(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const Fg = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Eo = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), Vo = Eo("applewebkit/") && !Eo("chrome/") ? Math.round : De;
function Lo(e) {
  e.min = Vo(e.min), e.max = Vo(e.max);
}
function _g(e) {
  Lo(e.x), Lo(e.y);
}
function gc(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !ag(ko(t), ko(n), 0.2);
}
function Og(e) {
  var t;
  return e !== e.root && ((t = e.scroll) == null ? void 0 : t.wasRoot);
}
const Hg = mc({
  attachResizeListener: (e, t) => Qt(e, "resize", t),
  measureScroll: () => {
    var e, t;
    return {
      x: document.documentElement.scrollLeft || ((e = document.body) == null ? void 0 : e.scrollLeft) || 0,
      y: document.documentElement.scrollTop || ((t = document.body) == null ? void 0 : t.scrollTop) || 0
    };
  },
  checkIsScrollRoot: () => !0
}), xr = {
  current: void 0
}, yc = mc({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!xr.current) {
      const e = new Hg({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), xr.current = e;
    }
    return xr.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), vc = It({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function $g(e = !0) {
  const t = xe(wi);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: s } = t, a = si();
  Ue(() => {
    if (e)
      return s(a);
  }, [e]);
  const o = Re(() => e && r && r(a), [a, r, e]);
  return !n && r ? [!1, o] : [!0];
}
const bc = It({ strict: !1 }), Ro = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let zo = !1;
function Ug() {
  if (zo)
    return;
  const e = {};
  for (const t in Ro)
    e[t] = {
      isEnabled: (n) => Ro[t].some((r) => !!n[r])
    };
  Yl(e), zo = !0;
}
function xc() {
  return Ug(), Vm();
}
function Wg(e) {
  const t = xc();
  for (const n in e)
    t[n] = {
      ...t[n],
      ...e[n]
    };
  Yl(t);
}
const Gg = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "propagate",
  "ignoreStrict",
  "viewport"
]);
function $n(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || Gg.has(e);
}
let wc = (e) => !$n(e);
function Kg(e) {
  typeof e == "function" && (wc = (t) => t.startsWith("on") ? !$n(t) : e(t));
}
try {
  Kg(require("@emotion/is-prop-valid").default);
} catch {
}
function Xg(e, t, n) {
  const r = {};
  for (const s in e)
    s === "values" && typeof e.values == "object" || fe(e[s]) || (wc(s) || n === !0 && $n(s) || !t && !$n(s) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && s.startsWith("onDrag")) && (r[s] = e[s]);
  return r;
}
const qn = /* @__PURE__ */ It({});
function Yg(e, t) {
  if (Zn(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || Jt(n) ? n : void 0,
      animate: Jt(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function Zg(e) {
  const { initial: t, animate: n } = Yg(e, xe(qn));
  return en(() => ({ initial: t, animate: n }), [Bo(t), Bo(n)]);
}
function Bo(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Gi = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function kc(e, t, n) {
  for (const r in t)
    !fe(t[r]) && !nc(r, n) && (e[r] = t[r]);
}
function qg({ transformTemplate: e }, t) {
  return en(() => {
    const n = Gi();
    return Ui(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function Jg(e, t) {
  const n = e.style || {}, r = {};
  return kc(r, n, e), Object.assign(r, qg(e, t)), r;
}
function Qg(e, t) {
  const n = {}, r = Jg(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const Sc = () => ({
  ...Gi(),
  attrs: {}
});
function ey(e, t, n, r) {
  const s = en(() => {
    const a = Sc();
    return rc(a, t, sc(r), e.transformTemplate, e.style), {
      ...a.attrs,
      style: { ...a.style }
    };
  }, [t]);
  if (e.style) {
    const a = {};
    kc(a, e.style, e), s.style = { ...a, ...s.style };
  }
  return s;
}
const ty = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Ki(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(ty.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function ny(e, t, n, { latestValues: r }, s, a = !1, o) {
  const c = (o ?? Ki(e) ? ey : Qg)(t, r, s, e), d = Xg(t, typeof e == "string", a), u = e !== ra ? { ...d, ...c, ref: n } : {}, { children: h } = t, f = en(() => fe(h) ? h.get() : h, [h]);
  return ld(e, {
    ...u,
    children: f
  });
}
function ry({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, s) {
  return {
    latestValues: iy(n, r, s, e),
    renderState: t()
  };
}
function iy(e, t, n, r) {
  const s = {}, a = r(e, {});
  for (const f in a)
    s[f] = In(a[f]);
  let { initial: o, animate: l } = e;
  const c = Zn(e), d = Kl(e);
  t && d && !c && e.inherit !== !1 && (o === void 0 && (o = t.initial), l === void 0 && (l = t.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || o === !1;
  const h = u ? l : o;
  if (h && typeof h != "boolean" && !Yn(h)) {
    const f = Array.isArray(h) ? h : [h];
    for (let y = 0; y < f.length; y++) {
      const p = Ri(e, f[y]);
      if (p) {
        const { transitionEnd: v, transition: b, ...x } = p;
        for (const w in x) {
          let S = x[w];
          if (Array.isArray(S)) {
            const k = u ? S.length - 1 : 0;
            S = S[k];
          }
          S !== null && (s[w] = S);
        }
        for (const w in v)
          s[w] = v[w];
      }
    }
  }
  return s;
}
const Nc = (e) => (t, n) => {
  const r = xe(qn), s = xe(wi), a = () => ry(e, t, r, s);
  return n ? a() : nf(a);
}, sy = /* @__PURE__ */ Nc({
  scrapeMotionValuesFromProps: Wi,
  createRenderState: Gi
}), oy = /* @__PURE__ */ Nc({
  scrapeMotionValuesFromProps: oc,
  createRenderState: Sc
}), ay = Symbol.for("motionComponentSymbol");
function ly(e, t, n) {
  const r = Me(n);
  ia(() => {
    r.current = n;
  });
  const s = Me(null);
  return Re((a) => {
    var l;
    a && ((l = e.onMount) == null || l.call(e, a)), t && (a ? t.mount(a) : t.unmount());
    const o = r.current;
    if (typeof o == "function")
      if (a) {
        const c = o(a);
        typeof c == "function" && (s.current = c);
      } else s.current ? (s.current(), s.current = null) : o(a);
    else o && (o.current = a);
  }, [t]);
}
const Tc = It({});
function wt(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function cy(e, t, n, r, s, a) {
  var S, k;
  const { visualElement: o } = xe(qn), l = xe(bc), c = xe(wi), d = xe(vc), u = d.reducedMotion, h = d.skipAnimations, f = Me(null), y = Me(!1);
  r = r || l.renderer, !f.current && r && (f.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceContext: c,
    blockInitialAnimation: c ? c.initial === !1 : !1,
    reducedMotionConfig: u,
    skipAnimations: h,
    isSVG: a
  }), y.current && f.current && (f.current.manuallyAnimateOnMount = !0));
  const p = f.current, v = xe(Tc);
  p && !p.projection && s && (p.type === "html" || p.type === "svg") && dy(f.current, n, s, v);
  const b = Me(!1);
  ia(() => {
    p && b.current && p.update(n, c);
  });
  const x = n[Rl], w = Me(!!x && typeof window < "u" && !((S = window.MotionHandoffIsComplete) != null && S.call(window, x)) && ((k = window.MotionHasOptimisedAnimation) == null ? void 0 : k.call(window, x)));
  return sf(() => {
    y.current = !0, p && (b.current = !0, window.MotionIsMounted = !0, p.updateFeatures(), p.scheduleRenderMicrotask(), w.current && p.animationState && p.animationState.animateChanges());
  }), Ue(() => {
    p && (!w.current && p.animationState && p.animationState.animateChanges(), w.current && (queueMicrotask(() => {
      var N;
      (N = window.MotionHandoffMarkAsComplete) == null || N.call(window, x);
    }), w.current = !1), p.enteringChildren = void 0);
  }), p;
}
function dy(e, t, n, r) {
  const { layoutId: s, layout: a, drag: o, dragConstraints: l, layoutScroll: c, layoutRoot: d, layoutAnchor: u, layoutCrossfade: h } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : Cc(e.parent)), e.projection.setOptions({
    layoutId: s,
    layout: a,
    alwaysMeasureLayout: !!o || l && wt(l),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: r,
    crossfade: h,
    layoutScroll: c,
    layoutRoot: d,
    layoutAnchor: u
  });
}
function Cc(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : Cc(e.parent);
}
function wr(e, { forwardMotionProps: t = !1, type: n } = {}, r, s) {
  r && Wg(r);
  const a = n ? n === "svg" : Ki(e), o = a ? oy : sy;
  function l(d, u) {
    let h;
    const f = {
      ...xe(vc),
      ...d,
      layoutId: uy(d)
    }, { isStatic: y } = f, p = Zg(d), v = o(d, y);
    if (!y && typeof window < "u") {
      hy(f, r);
      const b = fy(f);
      h = b.MeasureLayout, p.visualElement = cy(e, v, f, s, b.ProjectionNode, a);
    }
    return m(qn.Provider, { value: p, children: [h && p.visualElement ? i(h, { visualElement: p.visualElement, ...f }) : null, ny(e, d, ly(v, p.visualElement, u), v, y, t, a)] });
  }
  l.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const c = cd(l);
  return c[ay] = e, c;
}
function uy({ layoutId: e }) {
  const t = xe(Ka).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function hy(e, t) {
  const n = xe(bc).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? At(!1, r, "lazy-strict-mode") : Ke(!1, r, "lazy-strict-mode");
  }
}
function fy(e) {
  const t = xc(), { drag: n, layout: r } = t;
  if (!n && !r)
    return {};
  const s = { ...n, ...r };
  return {
    MeasureLayout: n != null && n.isEnabled(e) || r != null && r.isEnabled(e) ? s.MeasureLayout : void 0,
    ProjectionNode: s.ProjectionNode
  };
}
function py(e, t) {
  if (typeof Proxy > "u")
    return wr;
  const n = /* @__PURE__ */ new Map(), r = (a, o) => wr(a, o, e, t), s = (a, o) => (process.env.NODE_ENV !== "production" && Kn(!1, "motion() is deprecated. Use motion.create() instead."), r(a, o));
  return new Proxy(s, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (a, o) => o === "create" ? r : (n.has(o) || n.set(o, wr(o, void 0, e, t)), n.get(o))
  });
}
const my = (e, t) => t.isSVG ?? Ki(e) ? new Zm(t) : new Um(t, {
  allowProjection: e !== ra
});
class gy extends et {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = tg(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    Yn(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let yy = 0;
class vy extends et {
  constructor() {
    super(...arguments), this.id = yy++, this.isExitComplete = !1;
  }
  update() {
    var a;
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    if (t && r === !1) {
      if (this.isExitComplete) {
        const { initial: o, custom: l } = this.node.getProps();
        if (typeof o == "string" || typeof o == "object" && o !== null && !Array.isArray(o)) {
          const c = ht(this.node, o, l);
          if (c) {
            const { transition: d, transitionEnd: u, ...h } = c;
            for (const f in h)
              (a = this.node.getValue(f)) == null || a.jump(h[f]);
          }
        }
        this.node.animationState.reset(), this.node.animationState.animateChanges();
      } else
        this.node.animationState.setActive("exit", !1);
      this.isExitComplete = !1;
      return;
    }
    const s = this.node.animationState.setActive("exit", !t);
    n && !t && s.then(() => {
      this.isExitComplete = !0, n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const by = {
  animation: {
    Feature: gy
  },
  exit: {
    Feature: vy
  }
};
function on(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const xy = (e) => (t) => Fi(t) && e(t, on(t));
function Ut(e, t, n, r) {
  return Qt(e, t, xy(n), r);
}
const Mc = ({ current: e }) => e ? e.ownerDocument.defaultView : null, jo = (e, t) => Math.abs(e - t);
function wy(e, t) {
  const n = jo(e.x, t.x), r = jo(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
const Fo = /* @__PURE__ */ new Set(["auto", "scroll"]);
class Pc {
  constructor(t, n, { transformPagePoint: r, contextWindow: s = window, dragSnapToOrigin: a = !1, distanceThreshold: o = 3, element: l } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.lastRawMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (p) => {
      this.handleScroll(p.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      this.lastRawMoveEventInfo && (this.lastMoveEventInfo = Sn(this.lastRawMoveEventInfo, this.transformPagePoint));
      const p = kr(this.lastMoveEventInfo, this.history), v = this.startEvent !== null, b = wy(p.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!v && !b)
        return;
      const { point: x } = p, { timestamp: w } = he;
      this.history.push({ ...x, timestamp: w });
      const { onStart: S, onMove: k } = this.handlers;
      v || (S && S(this.lastMoveEvent, p), this.startEvent = this.lastMoveEvent), k && k(this.lastMoveEvent, p);
    }, this.handlePointerMove = (p, v) => {
      this.lastMoveEvent = p, this.lastRawMoveEventInfo = v, this.lastMoveEventInfo = Sn(v, this.transformPagePoint), q.update(this.updatePoint, !0);
    }, this.handlePointerUp = (p, v) => {
      this.end();
      const { onEnd: b, onSessionEnd: x, resumeAnimation: w } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && w && w(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const S = kr(p.type === "pointercancel" ? this.lastMoveEventInfo : Sn(v, this.transformPagePoint), this.history);
      this.startEvent && b && b(p, S), x && x(p, S);
    }, !Fi(t))
      return;
    this.dragSnapToOrigin = a, this.handlers = n, this.transformPagePoint = r, this.distanceThreshold = o, this.contextWindow = s || window;
    const c = on(t), d = Sn(c, this.transformPagePoint), { point: u } = d, { timestamp: h } = he;
    this.history = [{ ...u, timestamp: h }];
    const { onSessionStart: f } = n;
    f && f(t, kr(d, this.history));
    const y = { passive: !0, capture: !0 };
    this.removeListeners = nn(Ut(this.contextWindow, "pointermove", this.handlePointerMove, y), Ut(this.contextWindow, "pointerup", this.handlePointerUp, y), Ut(this.contextWindow, "pointercancel", this.handlePointerUp, y)), l && this.startScrollTracking(l);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(t) {
    let n = t.parentElement;
    for (; n; ) {
      const r = getComputedStyle(n);
      (Fo.has(r.overflowX) || Fo.has(r.overflowY)) && this.scrollPositions.set(n, {
        x: n.scrollLeft,
        y: n.scrollTop
      }), n = n.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0
    }), window.addEventListener("scroll", this.onWindowScroll), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(t) {
    const n = this.scrollPositions.get(t);
    if (!n)
      return;
    const r = t === window, s = r ? { x: window.scrollX, y: window.scrollY } : {
      x: t.scrollLeft,
      y: t.scrollTop
    }, a = { x: s.x - n.x, y: s.y - n.y };
    a.x === 0 && a.y === 0 || (r ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += a.x, this.lastMoveEventInfo.point.y += a.y) : this.history.length > 0 && (this.history[0].x -= a.x, this.history[0].y -= a.y), this.scrollPositions.set(t, s), q.update(this.updatePoint, !0));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), Qe(this.updatePoint);
  }
}
function Sn(e, t) {
  return t ? { point: t(e.point) } : e;
}
function _o(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function kr({ point: e }, t) {
  return {
    point: e,
    delta: _o(e, Dc(t)),
    offset: _o(e, ky(t)),
    velocity: Sy(t, 0.1)
  };
}
function ky(e) {
  return e[0];
}
function Dc(e) {
  return e[e.length - 1];
}
function Sy(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const s = Dc(e);
  for (; n >= 0 && (r = e[n], !(s.timestamp - r.timestamp > /* @__PURE__ */ we(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  r === e[0] && e.length > 2 && s.timestamp - r.timestamp > /* @__PURE__ */ we(t) * 2 && (r = e[1]);
  const a = /* @__PURE__ */ Pe(s.timestamp - r.timestamp);
  if (a === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (s.x - r.x) / a,
    y: (s.y - r.y) / a
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function Ny(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Z(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Z(n, e, r.max) : Math.min(e, n)), e;
}
function Oo(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function Ty(e, { top: t, left: n, bottom: r, right: s }) {
  return {
    x: Oo(e.x, n, s),
    y: Oo(e.y, t, r)
  };
}
function Ho(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function Cy(e, t) {
  return {
    x: Ho(e.x, t.x),
    y: Ho(e.y, t.y)
  };
}
function My(e, t) {
  let n = 0.5;
  const r = ve(e), s = ve(t);
  return s > r ? n = /* @__PURE__ */ Zt(t.min, t.max - r, e.min) : r > s && (n = /* @__PURE__ */ Zt(e.min, e.max - s, t.min)), Ge(0, 1, n);
}
function Py(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const ri = 0.35;
function Dy(e = ri) {
  return e === !1 ? e = 0 : e === !0 && (e = ri), {
    x: $o(e, "left", "right"),
    y: $o(e, "top", "bottom")
  };
}
function $o(e, t, n) {
  return {
    min: Uo(e, t),
    max: Uo(e, n)
  };
}
function Uo(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const Iy = /* @__PURE__ */ new WeakMap();
class Ay {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ce(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1, distanceThreshold: r } = {}) {
    const { presenceContext: s } = this.visualElement;
    if (s && s.isPresent === !1)
      return;
    const a = (h) => {
      n && this.snapToCursor(on(h).point), this.stopAnimation();
    }, o = (h, f) => {
      const { drag: y, dragPropagation: p, onDragStart: v } = this.getProps();
      if (y && !p && (this.openDragLock && this.openDragLock(), this.openDragLock = dm(y), !this.openDragLock))
        return;
      this.latestPointerEvent = h, this.latestPanInfo = f, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), _e((x) => {
        let w = this.getAxisMotionValue(x).get() || 0;
        if ($e.test(w)) {
          const { projection: S } = this.visualElement;
          if (S && S.layout) {
            const k = S.layout.layoutBox[x];
            k && (w = ve(k) * (parseFloat(w) / 100));
          }
        }
        this.originPoint[x] = w;
      }), v && q.update(() => v(h, f), !1, !0), Xr(this.visualElement, "transform");
      const { animationState: b } = this.visualElement;
      b && b.setActive("whileDrag", !0);
    }, l = (h, f) => {
      this.latestPointerEvent = h, this.latestPanInfo = f;
      const { dragPropagation: y, dragDirectionLock: p, onDirectionLock: v, onDrag: b } = this.getProps();
      if (!y && !this.openDragLock)
        return;
      const { offset: x } = f;
      if (p && this.currentDirection === null) {
        this.currentDirection = Vy(x), this.currentDirection !== null && v && v(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, x), this.updateAxis("y", f.point, x), this.visualElement.render(), b && q.update(() => b(h, f), !1, !0);
    }, c = (h, f) => {
      this.latestPointerEvent = h, this.latestPanInfo = f, this.stop(h, f), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, d = () => {
      const { dragSnapToOrigin: h } = this.getProps();
      (h || this.constraints) && this.startAnimation({ x: 0, y: 0 });
    }, { dragSnapToOrigin: u } = this.getProps();
    this.panSession = new Pc(t, {
      onSessionStart: a,
      onStart: o,
      onMove: l,
      onSessionEnd: c,
      resumeAnimation: d
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: u,
      distanceThreshold: r,
      contextWindow: Mc(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(t, n) {
    const r = t || this.latestPointerEvent, s = n || this.latestPanInfo, a = this.isDragging;
    if (this.cancel(), !a || !s || !r)
      return;
    const { velocity: o } = s;
    this.startAnimation(o);
    const { onDragEnd: l } = this.getProps();
    l && q.postRender(() => l(r, s));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(t, n, r) {
    const { drag: s } = this.getProps();
    if (!r || !Nn(t, s, this.currentDirection))
      return;
    const a = this.getAxisMotionValue(t);
    let o = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (o = Ny(o, this.constraints[t], this.elastic[t])), a.set(o);
  }
  resolveConstraints() {
    var a;
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (a = this.visualElement.projection) == null ? void 0 : a.layout, s = this.constraints;
    t && wt(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = Ty(r.layoutBox, t) : this.constraints = !1, this.elastic = Dy(n), s !== this.constraints && !wt(t) && r && this.constraints && !this.hasMutatedConstraints && _e((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = Py(r.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !wt(t))
      return !1;
    const r = t.current;
    Ke(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: s } = this.visualElement;
    if (!s || !s.layout)
      return !1;
    s.root && (s.root.scroll = void 0, s.root.updateScroll());
    const a = jm(r, s.root, this.visualElement.getTransformPagePoint());
    let o = Cy(s.layout.layoutBox, a);
    if (n) {
      const l = n(Rm(o));
      this.hasMutatedConstraints = !!l, l && (o = ql(l));
    }
    return o;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: s, dragTransition: a, dragSnapToOrigin: o, onDragTransitionEnd: l } = this.getProps(), c = this.constraints || {}, d = _e((u) => {
      if (!Nn(u, n, this.currentDirection))
        return;
      let h = c && c[u] || {};
      (o === !0 || o === u) && (h = { min: 0, max: 0 });
      const f = s ? 200 : 1e6, y = s ? 40 : 1e7, p = {
        type: "inertia",
        velocity: r ? t[u] : 0,
        bounceStiffness: f,
        bounceDamping: y,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...a,
        ...h
      };
      return this.startAxisValueAnimation(u, p);
    });
    return Promise.all(d).then(l);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return Xr(this.visualElement, t), r.start(Li(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    _e((t) => this.getAxisMotionValue(t).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, s = this.visualElement.getProps()[n];
    return s || this.visualElement.getValue(t, this.visualElement.latestValues[t] ?? 0);
  }
  snapToCursor(t) {
    _e((n) => {
      const { drag: r } = this.getProps();
      if (!Nn(n, r, this.currentDirection))
        return;
      const { projection: s } = this.visualElement, a = this.getAxisMotionValue(n);
      if (s && s.layout) {
        const { min: o, max: l } = s.layout.layoutBox[n], c = a.get() || 0;
        a.set(t[n] - Z(o, l, 0.5) + c);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!wt(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const s = { x: 0, y: 0 };
    _e((o) => {
      const l = this.getAxisMotionValue(o);
      if (l && this.constraints !== !1) {
        const c = l.get();
        s[o] = My({ min: c, max: c }, this.constraints[o]);
      }
    });
    const { transformTemplate: a } = this.visualElement.getProps();
    this.visualElement.current.style.transform = a ? a({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.constraints = !1, this.resolveConstraints(), _e((o) => {
      if (!Nn(o, t, null))
        return;
      const l = this.getAxisMotionValue(o), { min: c, max: d } = this.constraints[o];
      l.set(Z(c, d, s[o]));
    }), this.visualElement.render();
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Iy.set(this.visualElement, this);
    const t = this.visualElement.current, n = Ut(t, "pointerdown", (d) => {
      const { drag: u, dragListener: h = !0 } = this.getProps(), f = d.target, y = f !== t && gm(f);
      u && h && !y && this.start(d);
    });
    let r;
    const s = () => {
      const { dragConstraints: d } = this.getProps();
      wt(d) && d.current && (this.constraints = this.resolveRefConstraints(), r || (r = Ey(t, d.current, () => this.scalePositionWithinConstraints())));
    }, { projection: a } = this.visualElement, o = a.addEventListener("measure", s);
    a && !a.layout && (a.root && a.root.updateScroll(), a.updateLayout()), q.read(s);
    const l = Qt(window, "resize", () => this.scalePositionWithinConstraints()), c = a.addEventListener("didUpdate", (({ delta: d, hasLayoutChanged: u }) => {
      this.isDragging && u && (_e((h) => {
        const f = this.getAxisMotionValue(h);
        f && (this.originPoint[h] += d[h].translate, f.set(f.get() + d[h].translate));
      }), this.visualElement.render());
    }));
    return () => {
      l(), n(), o(), c && c(), r && r();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: s = !1, dragConstraints: a = !1, dragElastic: o = ri, dragMomentum: l = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: s,
      dragConstraints: a,
      dragElastic: o,
      dragMomentum: l
    };
  }
}
function Wo(e) {
  let t = !0;
  return () => {
    if (t) {
      t = !1;
      return;
    }
    e();
  };
}
function Ey(e, t, n) {
  const r = Qs(e, Wo(n)), s = Qs(t, Wo(n));
  return () => {
    r(), s();
  };
}
function Nn(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function Vy(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class Ly extends et {
  constructor(t) {
    super(t), this.removeGroupControls = De, this.removeListeners = De, this.controls = new Ay(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || De;
  }
  update() {
    const { dragControls: t } = this.node.getProps(), { dragControls: n } = this.node.prevProps || {};
    t !== n && (this.removeGroupControls(), t && (this.removeGroupControls = t.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const Sr = (e) => (t, n) => {
  e && q.update(() => e(t, n), !1, !0);
};
class Ry extends et {
  constructor() {
    super(...arguments), this.removePointerDownListener = De;
  }
  onPointerDown(t) {
    this.session = new Pc(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Mc(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: s } = this.node.getProps();
    return {
      onSessionStart: Sr(t),
      onStart: Sr(n),
      onMove: Sr(r),
      onEnd: (a, o) => {
        delete this.session, s && q.postRender(() => s(a, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Ut(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let Nr = !1;
class zy extends dd {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: s } = this.props, { projection: a } = t;
    a && (n.group && n.group.add(a), r && r.register && s && r.register(a), Nr && a.root.didUpdate(), a.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), a.setOptions({
      ...a.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), An.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: s, isPresent: a } = this.props, { projection: o } = r;
    return o && (o.isPresent = a, t.layoutDependency !== n && o.setOptions({
      ...o.options,
      layoutDependency: n
    }), Nr = !0, s || t.layoutDependency !== n || n === void 0 || t.isPresent !== a ? o.willUpdate() : this.safeToRemove(), t.isPresent !== a && (a ? o.promote() : o.relegate() || q.postRender(() => {
      const l = o.getStack();
      (!l || !l.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { visualElement: t, layoutAnchor: n } = this.props, { projection: r } = t;
    r && (r.options.layoutAnchor = n, r.root.didUpdate(), ji.postRender(() => {
      !r.currentAnimation && r.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: s } = t;
    Nr = !0, s && (s.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(s), r && r.deregister && r.deregister(s));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function Ic(e) {
  const [t, n] = $g(), r = xe(Ka);
  return i(zy, { ...e, layoutGroup: r, switchLayoutGroup: xe(Tc), isPresent: t, safeToRemove: n });
}
const By = {
  pan: {
    Feature: Ry
  },
  drag: {
    Feature: Ly,
    ProjectionNode: yc,
    MeasureLayout: Ic
  }
};
function Go(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const s = "onHover" + n, a = r[s];
  a && q.postRender(() => a(t, on(t)));
}
class jy extends et {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = hm(t, (n, r) => (Go(this.node, r, "Start"), (s) => Go(this.node, s, "End"))));
  }
  unmount() {
  }
}
class Fy extends et {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = nn(Qt(this.node.current, "focus", () => this.onFocus()), Qt(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Ko(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const s = "onTap" + (n === "End" ? "" : n), a = r[s];
  a && q.postRender(() => a(t, on(t)));
}
class _y extends et {
  mount() {
    const { current: t } = this.node;
    if (!t)
      return;
    const { globalTapTarget: n, propagate: r } = this.node.props;
    this.unmount = vm(t, (s, a) => (Ko(this.node, a, "Start"), (o, { success: l }) => Ko(this.node, o, l ? "End" : "Cancel")), {
      useGlobalTarget: n,
      stopPropagation: (r == null ? void 0 : r.tap) === !1
    });
  }
  unmount() {
  }
}
const ii = /* @__PURE__ */ new WeakMap(), Tr = /* @__PURE__ */ new WeakMap(), Oy = (e) => {
  const t = ii.get(e.target);
  t && t(e);
}, Hy = (e) => {
  e.forEach(Oy);
};
function $y({ root: e, ...t }) {
  const n = e || document;
  Tr.has(n) || Tr.set(n, {});
  const r = Tr.get(n), s = JSON.stringify(t);
  return r[s] || (r[s] = new IntersectionObserver(Hy, { root: e, ...t })), r[s];
}
function Uy(e, t, n) {
  const r = $y(t);
  return ii.set(e, n), r.observe(e), () => {
    ii.delete(e), r.unobserve(e);
  };
}
const Wy = {
  some: 0,
  all: 1
};
class Gy extends et {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    var c;
    (c = this.stopObserver) == null || c.call(this);
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: s = "some", once: a } = t, o = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof s == "number" ? s : Wy[s]
    }, l = (d) => {
      const { isIntersecting: u } = d;
      if (this.isInView === u || (this.isInView = u, a && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: h, onViewportLeave: f } = this.node.getProps(), y = u ? h : f;
      y && y(d);
    };
    this.stopObserver = Uy(this.node.current, o, l);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(Ky(t, n)) && this.startObserver();
  }
  unmount() {
    var t;
    (t = this.stopObserver) == null || t.call(this), this.hasEnteredView = !1, this.isInView = !1;
  }
}
function Ky({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const Xy = {
  inView: {
    Feature: Gy
  },
  tap: {
    Feature: _y
  },
  focus: {
    Feature: Fy
  },
  hover: {
    Feature: jy
  }
}, Yy = {
  layout: {
    ProjectionNode: yc,
    MeasureLayout: Ic
  }
}, Zy = {
  ...by,
  ...Xy,
  ...By,
  ...Yy
}, Ac = /* @__PURE__ */ py(Zy, my);
function qy() {
  !$i.current && Xl();
  const [e] = ne(Fn.current);
  return process.env.NODE_ENV !== "production" && Kn(e !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), e;
}
function Jy({ children: e }) {
  return /* @__PURE__ */ i("div", { className: "flex flex-col items-center justify-between w-full", children: e });
}
function Qy({
  onRefetch: e,
  filterRevealComponent: t,
  hasExpandableRows: n = !1,
  showMyRecords: r = !1,
  onToggleMyRecords: s,
  isFilterPanelVisible: a,
  expandedRows: o,
  onCollapseAllRows: l,
  onSearch: c,
  onClear: d,
  searchLabel: u = "Search",
  clearLabel: h = "Clear",
  additionalActions: f
}) {
  const [y] = ne(!0), p = a ?? y, v = H((k) => k.isTunecore), b = o !== void 0 && Object.keys(o).length > 0;
  return /* @__PURE__ */ i(re, { children: /* @__PURE__ */ i("div", { className: "flex flex-row items-center justify-between w-full", children: /* @__PURE__ */ i("div", { className: "flex flex-row w-full", children: /* @__PURE__ */ i(t0, { isVisible: p, isTunecore: v, children: /* @__PURE__ */ m(
    "form",
    {
      className: "flex flex-col gap-4 p-2",
      onSubmit: (k) => {
        k.preventDefault(), c == null || c();
      },
      children: [
        /* @__PURE__ */ i("div", { className: "grid items-start flex-1 min-w-0 gap-4 px-4 grid-cols-[repeat(auto-fit,minmax(200px,1fr))]", children: t }),
        (!!s || !!e || n && b && !!l || !!f || (!!d || !!c)) && /* @__PURE__ */ m("div", { className: "flex flex-row items-center self-center gap-2 w-min", children: [
          s != null && /* @__PURE__ */ i(
            O,
            {
              type: "button",
              label: r ? /* @__PURE__ */ i(eu, { size: "md", className: v ? "stroke-white" : "stroke-ink-primary" }) : /* @__PURE__ */ i(Qd, { size: "md", className: v ? "stroke-white" : "stroke-ink-primary" }),
              onClick: () => s(!r),
              tooltip: !0,
              tooltipText: r ? "Show All Records" : "Show My Records",
              variant: v ? "primary" : "iconAction",
              className: g(v && "p-2 bg-layer-raised")
            }
          ),
          e != null && /* @__PURE__ */ i(
            O,
            {
              type: "button",
              label: /* @__PURE__ */ i(Xd, { size: "md", className: v ? "stroke-white" : "stroke-ink-primary" }),
              tooltip: !0,
              tooltipText: "Refetch Data",
              onClick: e,
              variant: v ? "primary" : "iconAction",
              className: g(v && "p-2 bg-layer-raised")
            }
          ),
          n && b && l != null && /* @__PURE__ */ i(
            O,
            {
              type: "button",
              label: /* @__PURE__ */ i(_t, { size: "md", className: g("rotate-180", v ? "stroke-white" : "stroke-ink-primary") }),
              tooltip: !0,
              tooltipText: "Collapse All Table Rows",
              variant: v ? "primary" : "iconAction",
              onClick: l,
              className: g(v && "p-2 bg-layer-raised")
            }
          ),
          f,
          d != null && /* @__PURE__ */ i(
            O,
            {
              type: "button",
              label: h,
              onClick: d,
              variant: "secondary"
            }
          ),
          c != null && /* @__PURE__ */ i(
            O,
            {
              type: "submit",
              label: u,
              variant: "primary"
            }
          )
        ] })
      ]
    }
  ) }) }) }) });
}
const e0 = {
  open: {
    height: "auto",
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 700,
      damping: 45,
      duration: 0.15
    }
  },
  closed: {
    height: 0,
    opacity: 0,
    transition: {
      type: "spring",
      stiffness: 700,
      damping: 45,
      duration: 0.15
    }
  }
};
function t0({ children: e, isVisible: t, isTunecore: n = !1 }) {
  return /* @__PURE__ */ i(
    Ac.div,
    {
      initial: t ? "open" : "closed",
      animate: t ? "open" : "closed",
      variants: e0,
      className: "w-full overflow-hidden",
      children: /* @__PURE__ */ i("div", { className: g("flex flex-col w-full gap-4", n ? "bg-layer-inverse" : "bg-layer-default"), children: e })
    }
  );
}
const Ec = [10, 25, 50, 100, 250, 500];
function Vc(e, t) {
  const [n, r] = ne(""), s = e.getState().pagination.pageIndex + 1, a = e.getState().pagination.pageSize, o = e.getPageCount(), l = typeof o == "number" && o > 0, c = l ? o : 1;
  return {
    currentPage: s,
    currentPageSize: a,
    effectivePageCount: c,
    controlsDisabled: t || !l,
    jumpToPage: n,
    setJumpToPage: r,
    commitJumpToPage: () => {
      const h = Number(n);
      Number.isInteger(h) && h >= 1 && h <= c && e.setPageIndex(h - 1), r("");
    },
    changePageSize: (h) => {
      const f = Number(h);
      setTimeout(() => {
        e.setPageSize(f);
      }, 0);
    }
  };
}
function Xo({ table: e, isLoading: t = !1 }) {
  const n = H((p) => p.isTunecore), r = si(), {
    currentPage: s,
    currentPageSize: a,
    effectivePageCount: o,
    controlsDisabled: l,
    jumpToPage: c,
    setJumpToPage: d,
    commitJumpToPage: u,
    changePageSize: h
  } = Vc(e, t), f = n ? "secondary" : "iconAction", y = n ? "stroke-white" : "stroke-ink-primary";
  return /* @__PURE__ */ m(
    "nav",
    {
      "aria-label": "Table pagination, bottom",
      "data-slot": "table-pagination",
      className: "relative z-10 flex flex-col items-center justify-between w-full gap-2 mt-2 sm:flex-row",
      children: [
        /* @__PURE__ */ i("div", { className: "p-1", children: /* @__PURE__ */ m(
          Fa,
          {
            value: String(a),
            onValueChange: h,
            disabled: t,
            children: [
              /* @__PURE__ */ i(vi, { className: "w-auto", children: /* @__PURE__ */ i(_a, { placeholder: `Show ${a} rows` }) }),
              /* @__PURE__ */ i(bi, { children: Ec.map((p) => /* @__PURE__ */ m(xi, { value: String(p), children: [
                "Show",
                " ",
                p,
                " ",
                "rows"
              ] }, p)) })
            ]
          }
        ) }),
        /* @__PURE__ */ m("div", { className: "flex flex-col items-center gap-2 sm:flex-row", children: [
          /* @__PURE__ */ m(
            "div",
            {
              className: g(
                "flex h-8 items-center gap-1 whitespace-nowrap text-ink-primary",
                n ? "font-tunecore" : "font-sentric-alt",
                l && "opacity-60"
              ),
              children: [
                /* @__PURE__ */ i(B, { as: "bodySm", children: "Page" }),
                /* @__PURE__ */ i("label", { htmlFor: r, className: "sr-only", children: "Go to page" }),
                /* @__PURE__ */ i(
                  "input",
                  {
                    id: r,
                    type: "number",
                    min: 1,
                    max: o,
                    step: 1,
                    value: c,
                    onChange: (p) => d(p.target.value),
                    onKeyDown: (p) => {
                      p.key === "Enter" && u();
                    },
                    placeholder: String(s),
                    disabled: l,
                    className: g(
                      "h-8 w-10 rounded-sm border px-1 text-center text-xs outline-none transition-all disabled:cursor-not-allowed disabled:opacity-40 sm:text-sm",
                      "[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
                      n ? "font-tunecore border-stroke-subtle" : "font-sentric-alt border-stroke-heavy",
                      "bg-layer-default text-ink-primary placeholder:text-ink-secondary focus:border-stroke-primary"
                    )
                  }
                ),
                /* @__PURE__ */ m(B, { as: "bodySm", children: [
                  "of",
                  " ",
                  o.toLocaleString()
                ] })
              ]
            }
          ),
          /* @__PURE__ */ m("div", { className: "flex gap-2 mr-2", children: [
            /* @__PURE__ */ i(
              O,
              {
                variant: f,
                onClick: () => e.firstPage(),
                disabled: l || e.getCanPreviousPage() === !1,
                "aria-label": "Go to first page",
                label: /* @__PURE__ */ i(_d, { size: "md", className: y })
              }
            ),
            /* @__PURE__ */ i(
              O,
              {
                variant: f,
                onClick: () => e.previousPage(),
                disabled: l || e.getCanPreviousPage() === !1,
                "aria-label": "Go to previous page",
                label: /* @__PURE__ */ i($d, { size: "md", className: y })
              }
            ),
            /* @__PURE__ */ i(
              O,
              {
                variant: f,
                onClick: () => e.nextPage(),
                disabled: l || e.getCanNextPage() === !1,
                "aria-label": "Go to next page",
                label: /* @__PURE__ */ i(Hd, { size: "md", className: y })
              }
            ),
            /* @__PURE__ */ i(
              O,
              {
                variant: f,
                onClick: () => e.lastPage(),
                disabled: l || e.getCanNextPage() === !1,
                "aria-label": "Go to last page",
                label: /* @__PURE__ */ i(Od, { size: "md", className: y })
              }
            )
          ] })
        ] })
      ]
    }
  );
}
const n0 = ["w-3/4", "w-1/2", "w-2/3"], r0 = Array.from({ length: 20 }, (e, t) => `skeleton-row-${t}`);
function i0({
  visibleColumns: e,
  rowCount: t = 5,
  density: n = "roomy"
}) {
  return /* @__PURE__ */ i(re, { children: r0.slice(0, t).map((r, s) => /* @__PURE__ */ i("tr", { className: He[n].rowHeight, children: e.map((a, o) => /* @__PURE__ */ i("td", { className: He[n].cellPadding, children: /* @__PURE__ */ i(Xh, { className: g("h-4", n0[(s + o) % 3]) }) }, a.id)) }, r)) });
}
function s0({ table: e, isLoading: t = !1 }) {
  const n = H((f) => f.isTunecore), r = si(), {
    currentPage: s,
    currentPageSize: a,
    effectivePageCount: o,
    controlsDisabled: l,
    jumpToPage: c,
    setJumpToPage: d,
    commitJumpToPage: u,
    changePageSize: h
  } = Vc(e, t);
  return /* @__PURE__ */ m(
    "nav",
    {
      "aria-label": "Table pagination, top",
      "data-slot": "table-top-pagination",
      className: "flex flex-wrap items-center justify-end gap-2 sm:gap-3",
      children: [
        /* @__PURE__ */ m(Fa, { value: String(a), onValueChange: h, disabled: t, children: [
          /* @__PURE__ */ i(vi, { customWidth: !0, smallFont: !0, className: "hidden min-w-35 bg-layer-default lg:flex", children: /* @__PURE__ */ i(_a, { placeholder: `Show ${a} rows` }) }),
          /* @__PURE__ */ i(bi, { children: Ec.map((f) => /* @__PURE__ */ m(xi, { value: String(f), children: [
            "Show",
            " ",
            f,
            " ",
            "rows"
          ] }, f)) })
        ] }),
        /* @__PURE__ */ m(
          "div",
          {
            className: g(
              "flex h-8 items-center gap-1 whitespace-nowrap text-ink-primary",
              n ? "font-tunecore" : "font-sentric-alt",
              l && "opacity-60"
            ),
            children: [
              /* @__PURE__ */ i(B, { as: "bodySm", children: "Page" }),
              /* @__PURE__ */ i("label", { htmlFor: r, className: "sr-only", children: "Go to page" }),
              /* @__PURE__ */ i(
                "input",
                {
                  id: r,
                  type: "number",
                  min: 1,
                  max: o,
                  step: 1,
                  value: c,
                  onChange: (f) => d(f.target.value),
                  onKeyDown: (f) => {
                    f.key === "Enter" && u();
                  },
                  placeholder: String(s),
                  disabled: l,
                  className: g(
                    "h-8 w-10 rounded-sm border px-1 text-center text-xs outline-none transition-all disabled:cursor-not-allowed disabled:opacity-40 sm:text-sm",
                    "[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
                    n ? "border-stroke-subtle" : "border-stroke-heavy",
                    "bg-layer-default text-ink-primary placeholder:text-ink-secondary focus:border-stroke-primary"
                  )
                }
              ),
              /* @__PURE__ */ m(B, { as: "bodySm", children: [
                "of",
                " ",
                o.toLocaleString()
              ] })
            ]
          }
        ),
        /* @__PURE__ */ m("div", { className: "flex items-center gap-1", children: [
          /* @__PURE__ */ i(
            O,
            {
              type: "button",
              "aria-label": "Go to previous page",
              onClick: () => e.previousPage(),
              disabled: l || e.getCanPreviousPage() === !1,
              variant: "iconAction",
              label: /* @__PURE__ */ i(li, { size: "md", className: "stroke-ink-primary" })
            }
          ),
          /* @__PURE__ */ i(
            O,
            {
              type: "button",
              "aria-label": "Go to next page",
              onClick: () => e.nextPage(),
              disabled: l || e.getCanNextPage() === !1,
              variant: "iconAction",
              label: /* @__PURE__ */ i(ci, { size: "md", className: "stroke-ink-primary" })
            }
          )
        ] })
      ]
    }
  );
}
const He = {
  roomy: {
    rowHeight: "h-12",
    cellPadding: "py-2 px-3",
    fontSize: "text-lg"
  },
  compact: {
    rowHeight: "h-12",
    cellPadding: "py-2 px-3",
    fontSize: "text-xs"
  },
  condensed: {
    rowHeight: "h-10",
    fontSize: "text-lg",
    cellPadding: "py-1 px-2"
  },
  expanded: {
    rowHeight: "h-10 max-h-24",
    cellPadding: "p-4",
    fontSize: "text-xs"
  }
}, Yo = {
  roomy: 56,
  compact: 48,
  condensed: 40,
  expanded: 56
}, o0 = [], a0 = () => null, l0 = () => !1;
function c0() {
}
const d0 = () => !1;
function Lc(e) {
  return e.column.columnDef.meta ?? {};
}
function u0(e) {
  return e ?? {};
}
function h0(e, t, n) {
  return e ? g(
    "[--fade-color-solid:var(--color-layer-inverse)]",
    "even:[--fade-color-solid:var(--color-layer-raised)]",
    t && "[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-inverse))]",
    t && "even:[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-inverse))]",
    n && "hover:[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-inverse))]",
    n && "hover:even:[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-inverse))]"
  ) : g(
    t ? [
      "[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-default))]",
      "even:[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-default))]"
    ] : [
      "[--fade-color-solid:var(--color-layer-default)]",
      "even:[--fade-color-solid:var(--color-layer-raised)]"
    ],
    n && "hover:[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-default))]",
    n && "hover:even:[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-default))]"
  );
}
function f0(e) {
  if (e == null)
    return null;
  const t = String(e);
  return t === "" ? null : t;
}
function Cr({ cell: e, isTunecore: t, className: n }) {
  const {
    copyable: r = !1,
    getCopyValue: s,
    copyTooltipText: a = "Copy",
    copySuccessText: o = "Copied to clipboard",
    copyErrorText: l = "Failed to copy to clipboard"
  } = Lc(e);
  if (!r)
    return null;
  const c = e.getValue(), d = f0(
    (s == null ? void 0 : s(e)) ?? (typeof c == "string" || typeof c == "number" || typeof c == "boolean" ? c : null)
  );
  if (d == null)
    return null;
  const u = async (h) => {
    var f;
    h.preventDefault(), h.stopPropagation();
    try {
      if (typeof navigator > "u" || ((f = navigator.clipboard) == null ? void 0 : f.writeText) == null)
        throw new Error("Clipboard API unavailable");
      await navigator.clipboard.writeText(d), Ss.success(o);
    } catch {
      Ss.error(l);
    }
  };
  return /* @__PURE__ */ i(Gt, { children: /* @__PURE__ */ m(Kt, { delayDuration: 200, children: [
    /* @__PURE__ */ i(Xt, { asChild: !0, children: /* @__PURE__ */ i(
      "button",
      {
        type: "button",
        "aria-label": a,
        className: g(
          n,
          "copy-cell-btn z-10 flex h-6 w-6 shrink-0 items-center justify-center opacity-0 transition-opacity duration-150 focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stroke-primary group-hover:opacity-100"
        ),
        onMouseDown: (h) => h.stopPropagation(),
        onClick: (h) => {
          u(h);
        },
        children: /* @__PURE__ */ i(
          ou,
          {
            className: g(
              "h-3.5 w-3.5",
              t ? "stroke-white" : "stroke-ink-primary dark:stroke-white"
            )
          }
        )
      }
    ) }),
    /* @__PURE__ */ i(Mt, { side: "top", children: /* @__PURE__ */ i(B, { className: "max-w-72", children: a }) })
  ] }) });
}
function p0({
  row: e,
  isExpanded: t,
  density: n,
  isTunecore: r,
  enableVirtualization: s,
  virtualStart: a,
  virtualSize: o,
  getRowCanExpand: l,
  isRowClickable: c,
  onRowClick: d,
  renderSubComponent: u,
  handleMouseDown: h,
  handleMouseUp: f,
  isTextSelectedRef: y,
  rowOriginalsSignature: p,
  darkMode: v = !0,
  enableColumnResizing: b = !0,
  hasPinnedActionFade: x = !0
}) {
  const w = l(e), S = c(e.original), k = S, N = e.index % 2 === 1, A = Y.useMemo(() => {
    if (S)
      return () => {
        y.current || d(e.original), y.current = !1;
      };
  }, [S, e, d, y]);
  return /* @__PURE__ */ m(Y.Fragment, { children: [
    /* @__PURE__ */ i(
      "tr",
      {
        onMouseDown: h,
        onMouseUp: f,
        onClick: A,
        className: g(
          "even:bg-layer-raised",
          t && "bg-ink-secondary/50!",
          x && h0(r, t, k),
          He[n].rowHeight,
          k && "cursor-pointer hover:bg-ink-secondary/50 even:hover:bg-ink-secondary/50",
          s && "absolute w-full block"
        ),
        style: s ? {
          transform: `translateY(${a}px)`,
          height: `${o}px`
        } : void 0,
        children: e.getVisibleCells().map((C) => {
          const M = C.column.getIsPinned(), R = Lc(C), D = R.pinnedBackground, V = !!M && !D && R.pinnedActionFade !== !1;
          return /* @__PURE__ */ i(
            "td",
            {
              className: g(
                "group relative",
                "text-xs md:text-sm font-sentric-alt",
                r ? "text-white stroke-white" : t ? v ? "transition-colors duration-300 ease-in-out text-ink-primary stroke-ink-primary" : "transition-colors duration-500 ease-out text-ink-primary stroke-ink-primary" : "text-ink-primary stroke-ink-primary",
                V ? "p-0" : He[n].cellPadding,
                M === "left" && "sticky left-0 z-15",
                M === "right" && "sticky right-0 z-15",
                !!M && !!D && (r ? "bg-layer-inverse" : "bg-layer-default"),
                // pinnedActionFade cells own their own colour via --fade-color-solid.
                !!M && t && !V && "bg-ink-secondary/50",
                b && C.column.getCanResize() && "overflow-hidden"
              ),
              style: {
                width: C.column.getSize(),
                minWidth: b && C.column.getCanResize() ? void 0 : C.column.columnDef.minSize,
                maxWidth: C.column.columnDef.maxSize,
                left: M === "left" ? `${C.column.getStart()}px` : void 0,
                right: M === "right" ? `${C.column.getAfter()}px` : void 0
              },
              children: V ? (
                // --fade-color-solid is set on the <tr> (getActionFadeVarClasses) and
                // inherits down here via CSS custom property inheritance.
                // Stops propagation so the gradient's empty space (and any padding not
                // already covered by the consumer's own cell content) can't bubble up
                // to the row's onClick/onMouseDown and trigger navigation or expand.
                /* @__PURE__ */ i(
                  "div",
                  {
                    className: "relative z-10 flex h-full w-full",
                    onClick: (L) => L.stopPropagation(),
                    onMouseDown: (L) => L.stopPropagation(),
                    children: M === "left" ? /* @__PURE__ */ m(re, { children: [
                      /* @__PURE__ */ m("div", { className: "flex w-fit shrink-0 items-center gap-2 px-2 bg-(--fade-color-solid)", children: [
                        Ft(C.column.columnDef.cell, C.getContext()),
                        /* @__PURE__ */ i(Cr, { cell: C, isTunecore: r, className: "" })
                      ] }),
                      /* @__PURE__ */ i("div", { className: "flex-1 bg-[linear-gradient(90deg,var(--fade-color-solid)_0%,color-mix(in_srgb,var(--fade-color-solid)_75%,transparent)_18%,color-mix(in_srgb,var(--fade-color-solid)_30%,transparent)_45%,transparent_100%)]" })
                    ] }) : /* @__PURE__ */ m(re, { children: [
                      /* @__PURE__ */ i("div", { className: "flex-1 bg-[linear-gradient(90deg,transparent_0%,color-mix(in_srgb,var(--fade-color-solid)_30%,transparent)_55%,color-mix(in_srgb,var(--fade-color-solid)_75%,transparent)_82%,var(--fade-color-solid)_100%)]" }),
                      /* @__PURE__ */ m("div", { className: "flex w-fit shrink-0 items-center gap-2 px-2 bg-(--fade-color-solid)", children: [
                        Ft(C.column.columnDef.cell, C.getContext()),
                        /* @__PURE__ */ i(Cr, { cell: C, isTunecore: r, className: "" })
                      ] })
                    ] })
                  }
                )
              ) : /* @__PURE__ */ m(
                "span",
                {
                  className: g(
                    // copy to clipboard border styles over text in cell
                    "inline-flex w-full max-w-full items-center gap-2 rounded-md px-1.5 py-1 transition-[background-color,box-shadow,transform] duration-50 has-[button:active]:scale-[0.98]",
                    r ? "has-[.copy-cell-btn:hover]:bg-layer-inverse/15 has-[.copy-cell-btn:hover]:ring-1 has-[.copy-cell-btn:hover]:ring-layer-inverse has-[.copy-cell-btn:active]:bg-layer-inverse/25 has-[.copy-cell-btn:focus-visible]:ring-2 has-[.copy-cell-btn:focus-visible]:ring-stroke-primary" : N ? "has-[.copy-cell-btn:hover]:bg-layer-strong has-[.copy-cell-btn:hover]:ring-1 has-[.copy-cell-btn:hover]:ring-stroke-strong has-[.copy-cell-btn:active]:bg-layer-strong has-[.copy-cell-btn:focus-visible]:ring-2 has-[.copy-cell-btn:focus-visible]:ring-stroke-primary" : "has-[.copy-cell-btn:hover]:bg-layer-raised/50 has-[.copy-cell-btn:hover]:ring-1 has-[.copy-cell-btn:hover]:ring-stroke-subtle has-[.copy-cell-btn:active]:bg-layer-raised/70 has-[.copy-cell-btn:focus-visible]:ring-2 has-[.copy-cell-btn:focus-visible]:ring-stroke-primary",
                    k && "cursor-text",
                    b && C.column.getCanResize() && "overflow-hidden"
                  ),
                  children: [
                    /* @__PURE__ */ i(
                      "span",
                      {
                        className: g(
                          b && C.column.getCanResize() && "min-w-0 overflow-hidden text-ellipsis whitespace-nowrap"
                        ),
                        children: Ft(C.column.columnDef.cell, C.getContext())
                      }
                    ),
                    /* @__PURE__ */ i(Cr, { cell: C, isTunecore: r, className: "" })
                  ]
                }
              )
            },
            C.id
          );
        })
      }
    ),
    w && t && /* @__PURE__ */ i("tr", { className: "transition-opacity duration-150 ease-in-out", children: /* @__PURE__ */ i("td", { colSpan: e.getVisibleCells().length, children: u({ row: e }) }) })
  ] });
}
const Zo = Y.memo(
  p0,
  (e, t) => e.row.original === t.row.original && e.isExpanded === t.isExpanded && e.isSelected === t.isSelected && e.density === t.density && e.isTunecore === t.isTunecore && e.enableVirtualization === t.enableVirtualization && e.virtualStart === t.virtualStart && e.virtualSize === t.virtualSize && e.rowOriginalsSignature === t.rowOriginalsSignature && e.darkMode === t.darkMode && e.hasPinnedActionFade === t.hasPinnedActionFade
);
function I1({
  data: e,
  pageCount: t,
  paginationComponent: n = !0,
  columns: r,
  noDataMessage: s = "No data",
  statsBlock: a = o0,
  renderSubComponent: o = a0,
  getRowCanExpand: l = l0,
  getRowId: c,
  onRowClick: d = c0,
  isRowClickable: u = d0,
  isRefetchingData: h = !1,
  pagination: f,
  onPaginationChange: y,
  hasFilters: p = !0,
  isFilterPanelVisible: v,
  onToggleFilterPanel: b,
  filterContent: x,
  filterToggleStyle: w = "default",
  onRefetch: S,
  showMyRecords: k,
  onToggleMyRecords: N,
  expandedRows: A,
  onCollapseAllRows: C,
  hasExpandableRows: M,
  onSearch: R,
  hasActiveFilters: D = !0,
  onClear: V,
  additionalActions: L,
  tableTopContent: Q,
  searchLabel: le = "Search",
  clearLabel: _ = "Clear",
  fetchingLabel: G = "Fetching...",
  noResultsTitle: me = "No results found",
  noResultsDescription: K = "No records match the currently applied filters.",
  noResultsClearLabel: j = "Clear filters",
  noDataAvailableLabel: ie = "No Data Available",
  canExpandToDialog: ue = !1,
  dialogTitle: je,
  dialogDensity: ke = "expanded",
  enableVirtualization: Ie = !1,
  estimatedRowHeight: mt = 48,
  enableColumnPinning: se = !0,
  height: tt,
  highlightColour: an = "#EC542E",
  sorting: nt,
  onSortingChange: gt,
  manualSorting: Ae = !1,
  expanded: Se,
  onExpandedChange: ge,
  clearExpandedOnDataChange: yt = !0,
  tableId: rt,
  enableColumnResizing: Ne = !0,
  isLoading: Te = !1,
  skeletonRowCount: X,
  elevation: U = "default",
  rowSelection: de,
  onRowSelectionChange: z,
  defaultPageSize: $ = 50,
  paginationPosition: Ce = "both"
}) {
  var ys;
  const pe = H((I) => I.isTunecore), [zc, Bc] = ne({
    pageIndex: 0,
    pageSize: $
  }), Jn = f ?? zc, jc = Math.min(X ?? Jn.pageSize, 20), Fc = (I) => {
    const F = typeof I == "function" ? I(Jn) : I;
    (y ?? Bc)(F);
  }, [_c, Oc] = ne([]), Xi = nt ?? _c, Hc = (I) => {
    const F = typeof I == "function" ? I(Xi) : I;
    (gt ?? Oc)(F);
  }, [$c, Yi] = ne({}), ln = Se ?? $c, cn = ge ?? Yi, Uc = Y.useCallback(
    (I) => {
      if (typeof I == "function") {
        const F = I(ln);
        cn(typeof F == "boolean" ? {} : F);
      } else
        cn(typeof I == "boolean" ? {} : I);
    },
    [ln, cn]
  ), Zi = Y.useCallback(() => {
    Yi({});
  }, []);
  Y.useEffect(() => {
    yt && Se === void 0 && Zi();
  }, [e, yt, Se, Zi]);
  const [Wc, Gc] = ne(!0), vt = v ?? Wc, Qn = b ?? (() => Gc((I) => !I)), [qi, Ji] = ne(!1), Kc = () => {
    Ji(!0), R == null || R();
  }, Qi = () => {
    Ji(!1), V == null || V();
  }, Xc = Y.useMemo(() => {
    const I = [], F = [];
    return r.forEach((W) => {
      var Fe;
      W.enablePinning && typeof W.id == "string" && W.id.length > 0 && (((Fe = W.meta) == null ? void 0 : Fe.pinSide) === "right" ? F.push(W.id) : I.push(W.id));
    }), { left: I, right: F };
  }, [r]), [Yc, Zc] = ne(Xc), dn = Me(!1), qc = Me({ x: 0, y: 0 }), es = Me(null), [ts, ns] = ne(48);
  Ue(() => {
    const I = es.current;
    if (I == null)
      return;
    const F = new ResizeObserver(() => {
      ns(I.getBoundingClientRect().height);
    });
    return F.observe(I), ns(I.getBoundingClientRect().height), () => F.disconnect();
  }, []);
  const rs = (I) => {
    qc.current = { x: I.clientX, y: I.clientY }, dn.current = !1;
  }, is = () => {
    const I = window.getSelection();
    I && I.toString().length > 0 && (dn.current = !0);
  }, bt = rt != null ? `tableColumnSizing:${rt}` : null, [un, Jc] = ne(() => {
    if (bt == null)
      return {};
    try {
      const I = localStorage.getItem(bt);
      return I == null ? {} : JSON.parse(I);
    } catch {
      return {};
    }
  }), [ss, hn] = ne(!1), Qc = Y.useCallback(
    (I) => {
      Jc((F) => typeof I == "function" ? I(F) : I);
    },
    []
  );
  Y.useEffect(() => {
    if (!ss && bt != null)
      try {
        Object.keys(un).length > 0 ? localStorage.setItem(bt, JSON.stringify(un)) : localStorage.removeItem(bt);
      } catch {
      }
  }, [ss, un, bt]);
  const fn = Me(!1), os = Y.useMemo(
    () => r.some((I) => {
      const F = I.meta;
      return !!(F != null && F.pinSide) && !(F != null && F.pinnedBackground) && (F == null ? void 0 : F.pinnedActionFade) !== !1;
    }),
    [r]
  ), be = kd({
    data: e,
    columns: Ne ? r.map((I) => ({ ...I, minSize: I.minSize != null ? Math.min(I.minSize, 50) : void 0 })) : r,
    manualPagination: !!f,
    manualSorting: Ae,
    pageCount: t,
    getRowId: c,
    autoResetPageIndex: !1,
    state: {
      pagination: Jn,
      expanded: ln,
      sorting: Xi,
      columnPinning: se ? Yc : void 0,
      columnSizing: Ne ? un : {},
      rowSelection: de ?? {}
    },
    onPaginationChange: Fc,
    onExpandedChange: Uc,
    onSortingChange: Hc,
    onColumnPinningChange: se ? Zc : void 0,
    enableColumnResizing: Ne,
    columnResizeMode: "onChange",
    onColumnSizingChange: Ne ? Qc : void 0,
    enableColumnPinning: se,
    enableRowSelection: z !== void 0 || de !== void 0,
    onRowSelectionChange: z !== void 0 ? (I) => z(
      typeof I == "function" ? I(de ?? {}) : I
    ) : void 0,
    getCoreRowModel: Cd(),
    getSortedRowModel: Ae ? void 0 : Td(),
    getPaginationRowModel: n ? Nd() : void 0,
    getExpandedRowModel: Sd(),
    getRowCanExpand: l
  }), xt = "roomy", as = Y.useRef(null), pn = Y.useMemo(
    () => Yo[xt],
    [mt]
  ), ls = Md({
    count: be.getRowModel().rows.length,
    getScrollElement: () => as.current,
    estimateSize: () => pn,
    overscan: 10,
    enabled: Ie
  }), Rt = Ie ? ls.getVirtualItems() : be.getRowModel().rows.map((I, F) => ({
    index: F,
    start: F * pn,
    size: pn,
    row: I
  })), cs = Y.useMemo(
    () => be.getRowModel().rows.map((I) => I.original),
    [be]
  ), er = Ie ? ((ys = Rt == null ? void 0 : Rt[0]) == null ? void 0 : ys.start) ?? 0 : 0, ds = Ie ? ls.getTotalSize() - (er + Rt.length * pn) : 0, us = (I) => be.getHeaderGroups().map((F) => /* @__PURE__ */ i("tr", { className: He[I].rowHeight, children: F.headers.map((W) => {
    const Fe = W.column.getIsPinned(), vs = u0(W.column.columnDef.meta).pinnedBackground, ir = Ne && W.column.getCanResize();
    return /* @__PURE__ */ m(
      "th",
      {
        onClick: (Ee) => {
          var Ye;
          if (fn.current) {
            fn.current = !1;
            return;
          }
          W.column.columnDef.enableSorting !== !1 && ((Ye = W.column.getToggleSortingHandler()) == null || Ye(Ee));
        },
        className: g(
          "py-2 px-2 text-left text-sm font-medium",
          He[I].cellPadding,
          W.column.columnDef.enableSorting !== !1 && [
            "cursor-pointer",
            "hover:underline",
            "transition-colors duration-150"
          ],
          Fe === "left" && "sticky left-0 z-10",
          Fe === "right" && "sticky right-0 z-10",
          !!Fe && !!vs && "bg-layer-raised",
          ir && "relative overflow-hidden"
        ),
        style: {
          width: W.getSize(),
          minWidth: Ne ? void 0 : W.column.columnDef.minSize,
          maxWidth: W.column.columnDef.maxSize,
          left: Fe === "left" ? `${W.column.getStart()}px` : void 0,
          right: Fe === "right" ? `${W.column.getAfter()}px` : void 0
        },
        children: [
          W.isPlaceholder ? null : /* @__PURE__ */ m(
            "div",
            {
              className: g(
                "flex items-center",
                ir && "overflow-hidden whitespace-nowrap"
              ),
              children: [
                Ft(W.column.columnDef.header, W.getContext()),
                /* @__PURE__ */ i("span", { className: "inline-flex w-4 ml-1", children: W.column.getIsSorted() === "asc" ? /* @__PURE__ */ i(ua, { size: "md", className: pe ? "stroke-white" : "stroke-ink-primary" }) : W.column.getIsSorted() === "desc" ? /* @__PURE__ */ i(_t, { size: "md", className: pe ? "stroke-white" : "stroke-ink-primary" }) : /* @__PURE__ */ i(_t, { size: "md", className: "invisible" }) })
              ]
            }
          ),
          ir && /* @__PURE__ */ i(
            "div",
            {
              onMouseDown: (Ee) => {
                Ee.stopPropagation(), W.getResizeHandler()(Ee), hn(!0), fn.current = !0;
                const Ye = () => {
                  hn(!1), document.removeEventListener("mouseup", Ye);
                };
                document.addEventListener("mouseup", Ye);
              },
              onTouchStart: (Ee) => {
                Ee.stopPropagation(), W.getResizeHandler()(Ee), hn(!0), fn.current = !0;
                const Ye = () => {
                  hn(!1), document.removeEventListener("touchend", Ye);
                };
                document.addEventListener("touchend", Ye);
              },
              onClick: (Ee) => {
                Ee.stopPropagation();
              },
              onDoubleClick: (Ee) => {
                Ee.stopPropagation(), W.column.resetSize();
              },
              className: g(
                "absolute top-0 right-0 w-0.75 h-full cursor-col-resize select-none touch-none transition-colors duration-150",
                W.column.getIsResizing() ? "bg-action-primary" : pe ? "bg-layer-inverse/50 hover:bg-action-primary" : "bg-ink-secondary/40 hover:bg-action-primary"
              ),
              role: "separator",
              "aria-orientation": "vertical",
              tabIndex: -1
            }
          )
        ]
      },
      W.id
    );
  }) }, F.id)), hs = () => be.getFooterGroups().map((I) => /* @__PURE__ */ i("tr", { children: I.headers.map((F) => {
    const W = F.isPlaceholder ? null : Ft(F.column.columnDef.footer, F.getContext()), Fe = W == null || typeof W == "string" && W.trim() === "";
    return /* @__PURE__ */ i("th", { className: "px-4 py-2", children: Fe ? /* @__PURE__ */ i("span", { className: "sr-only", children: "Empty footer cell" }) : W }, F.id);
  }) }, I.id)), tr = x != null, nr = n && (Ce === "top" || Ce === "both"), fs = n && (Ce === "bottom" || Ce === "both"), rr = a.length > 0 || p || tr || ue || nr, ps = s === "No data" || s === "No Data", mn = qi && D && ps && V != null, ms = !qi, gs = (I) => /* @__PURE__ */ i("div", { className: "flex min-h-32 flex-col items-center justify-center gap-2 px-4 py-4 text-center", children: I ? /* @__PURE__ */ m(re, { children: [
    /* @__PURE__ */ i(Wd, { size: "xl", className: "stroke-ink-secondary" }),
    /* @__PURE__ */ i(B, { as: "subtitle", children: me }),
    /* @__PURE__ */ i(B, { as: "p", className: "max-w-md text-ink-secondary", children: K }),
    /* @__PURE__ */ i(
      O,
      {
        type: "button",
        label: j,
        variant: "secondary",
        onClick: Qi,
        className: "mt-2"
      }
    )
  ] }) : /* @__PURE__ */ m(re, { children: [
    /* @__PURE__ */ i(Gd, { size: "xl", className: "stroke-ink-secondary" }),
    /* @__PURE__ */ i(B, { as: "subtitle", children: ps ? ie : s })
  ] }) });
  return /* @__PURE__ */ m("div", { className: "flex w-full flex-col", children: [
    /* @__PURE__ */ m(
      "div",
      {
        "data-slot": "table-surface",
        className: g(
          "flex w-full flex-col rounded-sm",
          U === "default" && "shadow-md",
          U === "system" && "shadow-system"
        ),
        children: [
          rr && /* @__PURE__ */ m(
            "div",
            {
              className: g(
                "flex w-full flex-col items-stretch gap-2 rounded-t-sm p-2 md:flex-row md:items-center md:gap-0",
                "bg-layer-raised"
              ),
              children: [
                a.length > 0 && /* @__PURE__ */ i("div", { className: "flex min-w-0 w-full flex-wrap gap-x-8 gap-y-2 md:w-auto", children: a.map((I) => /* @__PURE__ */ m(
                  B,
                  {
                    as: "bodySm",
                    className: g(
                      "font-semibold uppercase text-ink-primary",
                      pe ? "font-tunecore" : "font-sentric"
                    ),
                    children: [
                      /* @__PURE__ */ m("span", { className: "block sm:inline", children: [
                        I.title,
                        ": "
                      ] }),
                      /* @__PURE__ */ i("span", { style: { color: I.highlight ? an : "" }, children: I.value })
                    ]
                  },
                  I.title
                )) }),
                /* @__PURE__ */ m("div", { className: "flex w-full shrink-0 flex-wrap items-center justify-end gap-2 md:ml-auto md:w-auto md:flex-nowrap", children: [
                  nr && /* @__PURE__ */ i(s0, { table: be, isLoading: Te }),
                  ue && /* @__PURE__ */ m(ba, { children: [
                    /* @__PURE__ */ i(Lu, { asChild: !0, children: /* @__PURE__ */ i(
                      O,
                      {
                        label: /* @__PURE__ */ i(
                          qd,
                          {
                            size: "md",
                            className: g(
                              "transition-colors duration-300",
                              pe ? "stroke-white group-hover:stroke-action-primary" : "stroke-black group-hover:stroke-black"
                            )
                          }
                        ),
                        "aria-label": "Expand table",
                        tooltip: !0,
                        tooltipText: "Expand table",
                        variant: "primary",
                        size: "icon-sm",
                        className: "p-1 ring-0"
                      }
                    ) }),
                    /* @__PURE__ */ m(hi, { className: "max-w-[95vw] max-h-[95vh] w-full h-full", children: [
                      je != null && je !== "" && /* @__PURE__ */ i(fi, { children: /* @__PURE__ */ i(pi, { children: /* @__PURE__ */ i(B, { as: "subtitle", children: je }) }) }),
                      /* @__PURE__ */ m("div", { className: "flex flex-col w-full h-full pt-4 shadow-md", children: [
                        /* @__PURE__ */ i("div", { className: "w-0 min-w-full overflow-x-auto overflow-y-auto rounded-lg", children: /* @__PURE__ */ m("table", { className: "w-full bg-layer-default table-fixed", children: [
                          /* @__PURE__ */ i(
                            "thead",
                            {
                              className: g(
                                "sticky top-0 z-20 uppercase font-sentric-alt text-nowrap bg-layer-raised text-ink-primary"
                              ),
                              children: us(ke)
                            }
                          ),
                          /* @__PURE__ */ m("tbody", { children: [
                            be.getRowModel().rows.map((I) => /* @__PURE__ */ i(
                              Zo,
                              {
                                row: I,
                                isExpanded: I.getIsExpanded(),
                                isSelected: I.getIsSelected(),
                                density: ke,
                                isTunecore: pe,
                                enableVirtualization: !1,
                                virtualStart: 0,
                                virtualSize: Yo[ke] ?? mt,
                                getRowCanExpand: l,
                                isRowClickable: u,
                                onRowClick: d,
                                renderSubComponent: o,
                                handleMouseDown: rs,
                                handleMouseUp: is,
                                isTextSelectedRef: dn,
                                rowOriginalsSignature: cs,
                                darkMode: !1,
                                enableColumnResizing: Ne,
                                hasPinnedActionFade: os
                              },
                              I.id
                            )),
                            e.length === 0 && /* @__PURE__ */ i("tr", { className: He[ke].rowHeight, children: /* @__PURE__ */ i(
                              "td",
                              {
                                colSpan: be.getAllColumns().length,
                                className: g(
                                  "text-center font-sentric text-ink-primary",
                                  He[ke].cellPadding
                                ),
                                children: mn || ms ? gs(mn) : s
                              }
                            ) })
                          ] }),
                          /* @__PURE__ */ i(
                            "tfoot",
                            {
                              className: g(
                                "uppercase text-ink-primary bg-layer-raised",
                                pe ? "font-tunecore" : "font-sentric"
                              ),
                              children: hs()
                            }
                          )
                        ] }) }),
                        (nr || fs) && /* @__PURE__ */ i(Xo, { table: be, isLoading: Te })
                      ] })
                    ] })
                  ] }),
                  (p || tr) && (w === "chevron" ? /* @__PURE__ */ m(
                    "button",
                    {
                      type: "button",
                      "aria-label": vt ? "Hide filters" : "Show filters",
                      "aria-expanded": vt,
                      onClick: Qn,
                      className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-transparent hover:bg-layer-raised/80 focus-visible:outline-none",
                      children: [
                        /* @__PURE__ */ i(
                          _t,
                          {
                            size: "md",
                            className: g(
                              "transition-transform duration-200 stroke-ink-primary",
                              !vt && "rotate-180"
                            )
                          }
                        ),
                        /* @__PURE__ */ i("span", { className: "sr-only", children: vt ? "Hide filters" : "Show filters" })
                      ]
                    }
                  ) : /* @__PURE__ */ i(
                    O,
                    {
                      label: /* @__PURE__ */ i(Yd, { size: "md", className: g("transition-colors duration-300", pe ? "stroke-white group-hover:stroke-action-primary" : "stroke-ink-on-accent") }),
                      "aria-label": vt ? "Hide filters" : "Show filters",
                      variant: pe ? "primary" : "iconAction",
                      onClick: Qn,
                      className: g(pe ? "p-1" : "bg-action-primary border-action-primary hover:bg-action-primary-hover hover:border-action-primary-hover active:bg-action-primary-pressed active:border-action-primary-pressed")
                    }
                  ))
                ] })
              ]
            }
          ),
          tr && /* @__PURE__ */ i(Jy, { children: /* @__PURE__ */ i(
            Qy,
            {
              filterRevealComponent: x,
              isFilterPanelVisible: vt,
              onToggleFilterPanel: Qn,
              onRefetch: S,
              showMyRecords: k,
              onToggleMyRecords: N,
              expandedRows: A ?? (M ? ln : void 0),
              onCollapseAllRows: C ?? (M ? () => cn({}) : void 0),
              onSearch: Kc,
              onClear: Qi,
              searchLabel: le,
              clearLabel: _,
              hasExpandableRows: M === !0 || A !== void 0,
              additionalActions: L
            }
          ) }),
          Q != null && /* @__PURE__ */ i("div", { className: g("px-2 py-1.5 border-stroke-subtle bg-layer-default", !rr && "rounded-t-sm"), children: Q }),
          /* @__PURE__ */ m(
            ui,
            {
              className: g(
                // w-0 min-w-full (not w-full): zeroes this box's max-content contribution so
                // a flex/grid ancestor can't be floored by the table's own width, then
                // stretches back to the available space. Matches the dialog-mode wrapper.
                "w-0 min-w-full overflow-hidden",
                rr || Q != null ? "rounded-b-sm" : "rounded-sm"
              ),
              style: tt != null && tt !== "" ? { height: tt } : { maxHeight: "100%" },
              showScrollIndicators: !0,
              indicatorOrientation: "horizontal",
              indicatorTopInset: ts,
              indicatorBottomInset: 0,
              children: [
                h && !Te && /* @__PURE__ */ i(
                  "div",
                  {
                    className: g(
                      "absolute inset-0 z-10 flex items-center justify-center backdrop-blur-sm",
                      pe ? "bg-layer-inverse/75" : "bg-layer-default/75"
                    ),
                    children: /* @__PURE__ */ i(B, { as: "bodyLg", className: "text-ink-primary", children: G })
                  }
                ),
                /* @__PURE__ */ m("table", { className: g("w-full table-fixed", pe ? "bg-layer-inverse" : "bg-layer-default"), children: [
                  /* @__PURE__ */ i(
                    "thead",
                    {
                      ref: es,
                      className: g(
                        "sticky top-0 z-20 uppercase font-sentric-alt text-nowrap bg-layer-raised text-ink-primary"
                      ),
                      children: us(xt)
                    }
                  ),
                  /* @__PURE__ */ i(
                    "tbody",
                    {
                      ref: as,
                      className: g(
                        "relative",
                        Ie && "w-full block"
                      ),
                      children: Te ? /* @__PURE__ */ i(
                        i0,
                        {
                          visibleColumns: be.getVisibleLeafColumns(),
                          rowCount: jc,
                          density: xt
                        }
                      ) : /* @__PURE__ */ m(re, { children: [
                        er > 0 && /* @__PURE__ */ i("tr", { children: /* @__PURE__ */ i("td", { style: { height: `${er}px` } }) }),
                        Rt.map((I) => {
                          const F = Ie && !("row" in I) ? be.getRowModel().rows[I.index] : I.row;
                          return /* @__PURE__ */ i(
                            Zo,
                            {
                              row: F,
                              isExpanded: F.getIsExpanded(),
                              isSelected: F.getIsSelected(),
                              density: xt,
                              isTunecore: pe,
                              enableVirtualization: Ie,
                              virtualStart: I.start,
                              virtualSize: I.size,
                              getRowCanExpand: l,
                              isRowClickable: u,
                              onRowClick: d,
                              renderSubComponent: o,
                              handleMouseDown: rs,
                              handleMouseUp: is,
                              isTextSelectedRef: dn,
                              rowOriginalsSignature: cs,
                              darkMode: !0,
                              enableColumnResizing: Ne,
                              hasPinnedActionFade: os
                            },
                            F.id
                          );
                        }),
                        ds > 0 && /* @__PURE__ */ i("tr", { children: /* @__PURE__ */ i("td", { style: { height: `${ds}px` } }) }),
                        e.length === 0 && /* @__PURE__ */ i("tr", { className: He[xt].rowHeight, children: /* @__PURE__ */ i(
                          "td",
                          {
                            colSpan: be.getAllColumns().length,
                            className: g(
                              "text-center font-sentric text-ink-primary",
                              He[xt].cellPadding
                            ),
                            children: mn || ms ? gs(mn) : s
                          }
                        ) })
                      ] })
                    }
                  ),
                  /* @__PURE__ */ i(
                    "tfoot",
                    {
                      className: g(
                        "border-none uppercase text-ink-primary",
                        pe ? "font-tunecore" : "font-sentric"
                      ),
                      children: hs()
                    }
                  )
                ] }),
                /* @__PURE__ */ i(En, { orientation: "horizontal" }),
                /* @__PURE__ */ i(En, { orientation: "vertical", className: "z-10", style: { top: ts } })
              ]
            }
          )
        ]
      }
    ),
    fs && /* @__PURE__ */ i(Xo, { table: be, isLoading: Te })
  ] });
}
const qo = {
  default: "bg-layer-raised",
  primary: "bg-action-primary",
  secondary: "bg-canvas-secondary",
  success: "bg-layer-success",
  warning: "bg-canvas-secondary",
  danger: "bg-action-primary",
  info: "bg-action-secondary",
  neutral: "bg-ink-secondary",
  muted: "bg-ink-secondary",
  outline: "bg-transparent border border-stroke-subtle"
};
function m0({ label: e, children: t, disabled: n = !1 }) {
  return n ? /* @__PURE__ */ i(
    Wn,
    {
      disabled: !0,
      className: "opacity-50 cursor-not-allowed",
      children: e
    }
  ) : /* @__PURE__ */ m(Uu, { children: [
    /* @__PURE__ */ i(Sa, { className: "cursor-pointer", children: e }),
    /* @__PURE__ */ i(Na, { className: "bg-layer-default border border-stroke-subtle", children: t })
  ] });
}
function A1({ label: e, onClick: t, statusVariant: n }) {
  return /* @__PURE__ */ m(
    Wn,
    {
      onClick: t,
      className: "flex items-center gap-2 cursor-pointer",
      children: [
        n && /* @__PURE__ */ i(
          "span",
          {
            className: `w-3 h-3 rounded-full shrink-0 ${qo[n] ?? qo.default}`
          }
        ),
        e
      ]
    }
  );
}
const E1 = ({ children: e, ariaLabel: t, disabled: n = !1, onOpenChange: r }) => {
  const [s, a] = Y.useState(!1), o = (u) => {
    a(u), r == null || r(u);
  }, l = (u) => {
    u.stopPropagation();
  }, d = (Array.isArray(e) ? e.flat() : [e]).map((u, h) => {
    if (!Y.isValidElement(u))
      return null;
    if (u.type === m0)
      return u;
    const f = u.props;
    if (f.variant === "dropdown") {
      const y = !!f.disabled, p = f.iconPosition === "right", v = f.icon;
      return /* @__PURE__ */ m(
        Wn,
        {
          disabled: y,
          onClick: y ? void 0 : f.onClick,
          className: y ? void 0 : "cursor-pointer",
          children: [
            v != null && !p && /* @__PURE__ */ i("span", { className: "mr-2", children: v }),
            f.label,
            v != null && p && /* @__PURE__ */ i("span", { className: "ml-2", children: v })
          ]
        },
        h
      );
    }
    return u;
  });
  return /* @__PURE__ */ i("div", { className: "flex justify-end w-full group", children: /* @__PURE__ */ m(Hu, { open: s, onOpenChange: o, children: [
    /* @__PURE__ */ i($u, { asChild: !0, children: /* @__PURE__ */ i(
      O,
      {
        label: /* @__PURE__ */ i(Zd, { size: "md" }),
        disabled: n,
        variant: "iconAction",
        "aria-label": t,
        onClick: l
      }
    ) }),
    /* @__PURE__ */ i(Ta, { align: "end", children: d })
  ] }) });
};
function V1({ isExpanded: e, onToggle: t, className: n }) {
  const r = H((a) => a.isTunecore), s = e ? ua : _t;
  return /* @__PURE__ */ i(
    "button",
    {
      type: "button",
      "aria-label": e ? "Collapse row" : "Expand row",
      "aria-expanded": e,
      onClick: (a) => {
        a.stopPropagation(), t();
      },
      onMouseDown: (a) => a.stopPropagation(),
      className: g(
        "inline-flex h-4 w-4 shrink-0 cursor-pointer items-center justify-center rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stroke-primary",
        n
      ),
      children: /* @__PURE__ */ i(s, { className: g("h-4 w-4", r ? "stroke-white" : "stroke-ink-primary") })
    }
  );
}
const g0 = {
  roomy: {
    subcomponentContainer: "py-6 px-10 gap-6",
    subcomponentColGap: "gap-4",
    fieldsGap: "gap-4"
  },
  compact: {
    subcomponentContainer: "py-5 px-6 gap-4",
    subcomponentColGap: "gap-3",
    fieldsGap: "gap-3"
  },
  condensed: {
    subcomponentContainer: "py-4 px-4 gap-3",
    subcomponentColGap: "gap-2",
    fieldsGap: "gap-2"
  }
}, L1 = ({
  children: e,
  density: t = "roomy"
}) => /* @__PURE__ */ i(
  "div",
  {
    className: g(
      "flex flex-col p-4 transition-all duration-150 ease-in-out bg-layer-raised/50 rounded-md",
      g0[t].subcomponentContainer
    ),
    children: e
  }
);
function R1({ position: e = "top-center", ...t }) {
  const n = H((a) => a.isTunecore);
  return /* @__PURE__ */ m(re, { children: [
    /* @__PURE__ */ i("style", { children: `
          [data-sonner-toaster] [data-type="success"] {
            background-color: var(--success-bg) !important;
            border-color: var(--success-border) !important;
            color: var(--success-text) !important;
          }

          [data-sonner-toaster] [data-type="error"] {
            background-color: var(--error-bg) !important;
            border-color: var(--error-border) !important;
            color: var(--error-text) !important;
          }

          [data-sonner-toaster] [data-type="warning"] {
            background-color: var(--warning-bg) !important;
            border-color: var(--warning-border) !important;
            color: var(--warning-text) !important;
          }

          [data-sonner-toaster] [data-type="info"] {
            background-color: var(--normal-bg) !important;
            border-color: var(--normal-border) !important;
            color: var(--normal-text) !important;
          }

          [data-sonner-toaster] [data-type="default"] {
            background-color: var(--normal-bg) !important;
            border-color: var(--normal-border) !important;
            color: var(--normal-text) !important;
          }

          /* sonner's built-in theme="dark" stylesheet sets [data-description] to a
             fixed light grey (hsl(0, 0%, 91%)), overriding the colours above on the
             description child regardless of our per-type background. Force it back
             to match the title on every type. */
          [data-sonner-toaster] [data-type="success"] [data-description] {
            color: var(--success-text) !important;
          }

          [data-sonner-toaster] [data-type="error"] [data-description] {
            color: var(--error-text) !important;
          }

          [data-sonner-toaster] [data-type="warning"] [data-description] {
            color: var(--warning-text) !important;
          }

          [data-sonner-toaster] [data-type="info"] [data-description] {
            color: var(--normal-text) !important;
          }

          [data-sonner-toaster] [data-type="default"] [data-description] {
            color: var(--normal-text) !important;
          }
        ` }),
    /* @__PURE__ */ i(
      Pd,
      {
        theme: n ? "dark" : "light",
        className: `toaster group ${n ? "font-tunecore" : "font-sentric-alt"}`,
        style: n ? {
          "--normal-bg": "#282828",
          // tunecore-dark-element
          "--normal-text": "#fff",
          "--normal-border": "#555555",
          // tunecore-light-grey
          "--success-bg": "#00ef86",
          // tunecore-green
          "--success-text": "#000",
          "--success-border": "#00ef86",
          "--error-bg": "#F44336",
          // tunecore-error-red
          "--error-text": "#000",
          "--error-border": "#F44336",
          "--warning-bg": "#EE9E26",
          // tunecore-warning-orange
          "--warning-text": "#000",
          "--warning-border": "#EE9E26"
        } : {
          "--normal-bg": "#E9E8E8",
          // sentric-rebrand-light-grey
          "--normal-text": "#231F20",
          // sentric-rebrand-dark-grey
          "--normal-border": "#D9D9D9",
          // sentric-rebrand-mid-grey
          "--success-bg": "#25BCBB",
          // sentric-teal
          "--success-text": "#000",
          "--success-border": "#25BCBB",
          "--error-bg": "#ef4444",
          "--error-text": "#000",
          "--error-border": "#ef4444",
          "--warning-bg": "#fb923c",
          "--warning-text": "#000",
          "--warning-border": "#fb923c"
        },
        position: e,
        ...t
      }
    )
  ] });
}
const y0 = Be(
  "isolate inline-grid shrink-0 grid-flow-col auto-cols-[minmax(max-content,1fr)] items-center overflow-hidden rounded-full border border-stroke-default bg-layer-disabled gap-0.5 shadow-[inset_0_1px_9.7px_var(--color-layer-disabled)]",
  {
    variants: {
      size: {
        sm: "h-6 p-0.5",
        lg: "h-8 p-1"
      }
    },
    defaultVariants: {
      size: "sm"
    }
  }
), v0 = Be(
  "relative flex h-full items-center justify-center transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-action-primary",
  {
    variants: {
      size: {
        sm: "min-w-18 px-3",
        lg: "min-w-22 px-4"
      },
      state: {
        active: "text-ink-on-accent cursor-default rounded-full",
        inactive: "text-ink-secondary hover:text-ink-primary cursor-pointer rounded",
        activeDisabled: "text-ink-disabled cursor-default opacity-50 rounded-full",
        inactiveDisabled: "text-ink-disabled cursor-not-allowed rounded"
      },
      hasIcon: {
        true: "gap-1.5",
        false: ""
      }
    },
    defaultVariants: {
      size: "sm",
      state: "inactive",
      hasIcon: !1
    }
  }
);
function z1({
  value: e,
  onChange: t,
  options: n,
  disabled: r,
  size: s,
  className: a,
  ariaLabel: o = "Toggle",
  label: l,
  smallFont: c
}) {
  const d = T.useId(), u = /* @__PURE__ */ i(
    "div",
    {
      role: "radiogroup",
      "aria-labelledby": l !== void 0 && l !== "" ? d : void 0,
      "aria-label": l !== void 0 && l !== "" ? void 0 : o,
      className: g(y0({ size: s }), a),
      children: n.map((h) => /* @__PURE__ */ i(
        b0,
        {
          option: h,
          isSelected: e === h.value,
          isDisabled: r ?? h.disabled,
          onChange: t,
          pillLayoutId: `${d}-pill`,
          size: s
        },
        h.value
      ))
    }
  );
  return l === void 0 || l === "" ? u : /* @__PURE__ */ m("div", { className: "flex flex-col items-start gap-1", children: [
    /* @__PURE__ */ i(B, { as: c ? "label" : "bodySm", id: d, className: "font-medium", children: l }),
    u
  ] });
}
const Rc = T.forwardRef(({ option: e, isSelected: t, isDisabled: n, onChange: r, onClick: s, pillLayoutId: a, size: o, ...l }, c) => {
  const d = qy(), u = !t && (n === !1 || n === void 0), h = t ? n === !0 ? "activeDisabled" : "active" : n === !0 ? "inactiveDisabled" : "inactive", f = e.icon !== void 0 && e.icon !== null, y = (e.label === void 0 || e.label === null || e.label === "") && e.tooltip !== void 0 && e.tooltip !== null && e.tooltip !== "" ? e.tooltip : void 0;
  return /* @__PURE__ */ m(
    "button",
    {
      ...l,
      ref: c,
      type: "button",
      role: "radio",
      "aria-checked": t,
      "aria-disabled": n === !0 || void 0,
      "aria-label": y,
      tabIndex: u ? 0 : -1,
      onClick: (v) => {
        v.stopPropagation(), s == null || s(v), u && r(e.value);
      },
      className: g(v0({ size: o, state: h, hasIcon: f })),
      children: [
        t && /* @__PURE__ */ i(
          Ac.span,
          {
            layoutId: a,
            transition: d === !0 ? { duration: 0 } : { type: "tween", duration: 0.5, ease: [0.65, 0, 0.35, 1] },
            className: "absolute inset-0 -z-10 rounded-full bg-action-primary shadow-small-orange"
          }
        ),
        e.icon !== void 0 && e.icon !== null && /* @__PURE__ */ i("span", { className: "flex items-center", children: e.icon }),
        e.label !== void 0 && e.label !== null && e.label !== "" && /* @__PURE__ */ i(
          B,
          {
            as: "label",
            className: "whitespace-nowrap text-inherit [text-box-edge:cap_alphabetic] [text-box-trim:trim-both]",
            children: e.label
          }
        )
      ]
    }
  );
});
Rc.displayName = "ToggleButtonInner";
function b0({
  option: e,
  isSelected: t,
  isDisabled: n,
  onChange: r,
  pillLayoutId: s,
  size: a
}) {
  const o = /* @__PURE__ */ i(
    Rc,
    {
      option: e,
      isSelected: t,
      isDisabled: n,
      onChange: r,
      pillLayoutId: s,
      size: a
    }
  );
  return e.tooltip !== void 0 && e.tooltip !== "" ? /* @__PURE__ */ i(Gt, { children: /* @__PURE__ */ m(Kt, { children: [
    /* @__PURE__ */ i(Xt, { asChild: !0, children: o }),
    /* @__PURE__ */ i(Mt, { children: /* @__PURE__ */ i("p", { children: e.tooltip }) })
  ] }) }) : o;
}
const x0 = T.forwardRef(
  ({
    label: e = "",
    value: t,
    onChange: n,
    column: r = !0,
    smallFont: s = !1,
    className: a,
    labelClassName: o,
    id: l,
    hasError: c = !1,
    readOnly: d = !1,
    disabled: u = !1,
    showTooltip: h = !0,
    tooltipContentClassName: f,
    tooltipSideOffset: y = 4,
    binaryOnly: p = !1,
    ...v
  }, b) => {
    const x = T.useId(), w = l ?? `triStateCheckbox-${x}`, S = Re((L) => p ? L === "Y" ? "N" : "Y" : L === "N" ? "Y" : L === "Y" ? null : "N", [p]), k = Re(() => {
      d || u || n(S(t));
    }, [d, u, n, S, t]), N = Re((L) => {
      (L.key === " " || L.key === "Enter") && (L.preventDefault(), !d && !u && n(S(t)));
    }, [d, u, n, S, t]), A = () => t === "Y" ? "Y" : t === "N" ? "N" : "??", C = () => t === "Y" ? "true" : t === "N" ? "false" : "mixed", M = (L) => L === "Y" ? "Yes" : L === "N" ? "No" : "Value is not defined (empty or null)", R = u || d, D = `${e ? `${e}: ` : ""}${M(t)}`, V = /* @__PURE__ */ m(
      "div",
      {
        className: g(
          r ? "flex flex-col-reverse justify-evenly" : "flex items-center gap-2"
        ),
        children: [
          /* @__PURE__ */ m(
            "button",
            {
              ref: b,
              id: w,
              type: "button",
              role: "checkbox",
              "aria-checked": C(),
              "aria-readonly": d,
              "aria-disabled": R,
              "aria-label": e || `Checkbox state: ${M(t)}`,
              onClick: k,
              onKeyDown: N,
              disabled: R,
              tabIndex: R ? -1 : 0,
              className: g(
                "h-6 w-6 shrink-0 font-sentric-alt rounded border-stroke-heavy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-action-primary flex items-center justify-center",
                {
                  "bg-action-secondary text-ink-primary": t === "Y",
                  "bg-action-primary text-ink-primary": t === "N",
                  "bg-layer-raised text-ink-primary": t === null
                },
                R && "opacity-50 cursor-not-allowed",
                a
              ),
              ...v,
              children: [
                /* @__PURE__ */ i("span", { className: "font-bold select-none text-md", "aria-hidden": "true", children: A() }),
                /* @__PURE__ */ m("span", { className: "sr-only", children: [
                  e ? `${e}: ` : "",
                  M(t),
                  d ? " (read-only)" : ""
                ] })
              ]
            }
          ),
          e && /* @__PURE__ */ i(
            "label",
            {
              htmlFor: w,
              onClick: R ? void 0 : k,
              className: g(
                "whitespace-nowrap text-ink-primary font-sentric-alt",
                s ? "text-xs" : "text-sm",
                R ? "cursor-not-allowed opacity-50" : "hover:cursor-pointer active:cursor-pointer",
                o,
                c && "text-red-800 font-semibold dark:text-red-500"
              ),
              children: e
            }
          )
        ]
      }
    );
    return h ? /* @__PURE__ */ i(Gt, { children: /* @__PURE__ */ m(Kt, { children: [
      /* @__PURE__ */ i(Xt, { asChild: !0, children: V }),
      /* @__PURE__ */ i(
        Mt,
        {
          sideOffset: y,
          className: f,
          children: /* @__PURE__ */ i("p", { children: D })
        }
      )
    ] }) }) : V;
  }
);
x0.displayName = "TriStateCheckbox";
export {
  O0 as Accordion,
  Ed as AccordionContent,
  Id as AccordionItem,
  Vd as AccordionItemNumber,
  Ad as AccordionTrigger,
  da as Alert,
  Dr as AlertDescription,
  Pr as AlertTitle,
  jd as Badge,
  _v as Breadcrumb,
  Gv as BreadcrumbEllipsis,
  Hv as BreadcrumbItem,
  $v as BreadcrumbLink,
  Ov as BreadcrumbList,
  Uv as BreadcrumbPage,
  Wv as BreadcrumbSeparator,
  O as Button,
  Kv as ButtonGroup,
  Yv as ButtonGroupSeparator,
  Xv as ButtonGroupText,
  Ot as Calendar,
  du as CancelButton,
  qv as CategoryCards,
  Cu as ChartContainer,
  Qv as ChartLegend,
  Du as ChartLegendContent,
  Mu as ChartStyle,
  Jv as ChartTooltip,
  Pu as ChartTooltipContent,
  Ar as Chip,
  Ms as ChunkedUploadPlugin,
  Au as CodedInput,
  i1 as Combobox,
  ka as Command,
  t1 as CommandDialog,
  Fu as CommandEmpty,
  sr as CommandGroup,
  Bu as CommandInput,
  or as CommandItem,
  ju as CommandList,
  n1 as CommandSeparator,
  r1 as CommandShortcut,
  cu as ConfirmButton,
  Ou as Container,
  ev as DarkModeIcon,
  s1 as DatePicker,
  o1 as DateRangePicker,
  pu as DeleteButton,
  ba as Dialog,
  e1 as DialogClose,
  hi as DialogContent,
  wa as DialogDescription,
  zu as DialogFooter,
  fi as DialogHeader,
  xa as DialogOverlay,
  Ru as DialogPortal,
  pi as DialogTitle,
  Lu as DialogTrigger,
  ma as Divider,
  Hu as DropdownMenu,
  Wu as DropdownMenuCheckboxItem,
  Ta as DropdownMenuContent,
  a1 as DropdownMenuGroup,
  Wn as DropdownMenuItem,
  Ku as DropdownMenuLabel,
  l1 as DropdownMenuPortal,
  c1 as DropdownMenuRadioGroup,
  Gu as DropdownMenuRadioItem,
  Xu as DropdownMenuSeparator,
  Yu as DropdownMenuShortcut,
  Uu as DropdownMenuSub,
  Na as DropdownMenuSubContent,
  Sa as DropdownMenuSubTrigger,
  $u as DropdownMenuTrigger,
  zd as ErrorContainer,
  ah as FileDropzone,
  d1 as Form,
  Vr as FormCheckbox,
  uh as FormControl,
  hh as FormDescription,
  u1 as FormField,
  yh as FormInput,
  ch as FormItem,
  dh as FormLabel,
  fh as FormMessage,
  bh as FormMultipleInput,
  xh as FormNumberInput,
  wh as FormTextarea,
  ca as Heading,
  X0 as IconAccounting,
  $0 as IconAccounts,
  K0 as IconAcknowledgements,
  nu as IconAlert,
  eu as IconAllUsers,
  vv as IconArchive,
  Lv as IconBan,
  pa as IconBin,
  Ev as IconCW,
  _t as IconChevronDown,
  li as IconChevronLeft,
  ci as IconChevronRight,
  ua as IconChevronUp,
  iu as IconCircleAlert,
  Iv as IconCircleCheckBig,
  fv as IconCircleDashed,
  U0 as IconClientSetup,
  Dv as IconClock,
  fa as IconClose,
  q0 as IconCompanySettings,
  Nv as IconCopy,
  ou as IconCopyTableMeta,
  dv as IconCreate,
  ha as IconCross,
  sv as IconDownloadFile,
  Zd as IconEdit,
  tu as IconEllipsis,
  qd as IconExpand,
  gv as IconEyes,
  Ns as IconFileText,
  Gd as IconFileX,
  Yd as IconFilter,
  Rv as IconGigs,
  iv as IconHamburger,
  ru as IconInfo,
  H0 as IconInputFile,
  Ud as IconInputSearch,
  ov as IconLine,
  Tv as IconLock,
  Cv as IconLogOut,
  kv as IconMapMinus,
  wv as IconMapPinMinus,
  xv as IconMapPinPlus,
  bv as IconMapPlus,
  Fv as IconMatch,
  Sv as IconModernisation,
  av as IconPagePrev,
  Jd as IconPlus,
  Kd as IconPrimaryButtonArrow,
  Y0 as IconPublishers,
  Xd as IconRefresh,
  Vv as IconRefreshCWOff,
  G0 as IconRegistration,
  mv as IconRestartList,
  jv as IconSave,
  Wd as IconSearchX,
  Av as IconSend,
  nv as IconSideBarClose,
  rv as IconSideBarOpen,
  Mv as IconSlidersHorizontal,
  W0 as IconSongManagement,
  pv as IconSpotify,
  yv as IconSquarePen,
  J0 as IconSystemConfig,
  Od as IconTablePageEnd,
  Hd as IconTablePageNext,
  $d as IconTablePagePrev,
  _d as IconTablePageStart,
  Q0 as IconTestFeatures,
  dt as IconTick,
  Pv as IconUnlock,
  zv as IconUpdateStatus,
  su as IconUpload,
  Qd as IconUser,
  uv as IconUserEdit,
  Z0 as IconUserManagement,
  lv as IconValidationErrors,
  cv as IconValidationErrorsCrossed,
  Bv as IconViewDetails,
  hv as IconWandSparkles,
  P as IconWrapper,
  Va as Label,
  Ma as LabeledProgressBar,
  tv as LightModeIcon,
  h1 as LoadingOverlay,
  T1 as MusicCardSkeleton,
  uu as NextButton,
  it as OverlaySkeleton,
  f1 as ParentBoundedLoadingOverlay,
  mi as Popover,
  Un as PopoverContent,
  gi as PopoverTrigger,
  hu as PreviousButton,
  Ca as ProgressBar,
  y1 as RadioGroup,
  v1 as RadioGroupItem,
  fu as SaveButton,
  ui as ScrollArea,
  En as ScrollBar,
  b1 as ScrollableListContainer,
  Fa as Select,
  bi as SelectContent,
  x1 as SelectGroup,
  xi as SelectItem,
  Eh as SelectLabel,
  Ha as SelectScrollDownButton,
  Oa as SelectScrollUpButton,
  Vh as SelectSeparator,
  vi as SelectTrigger,
  _a as SelectValue,
  p1 as SentricLogo,
  ja as SentricLogoLoader,
  w1 as Sheet,
  S1 as SheetClose,
  zh as SheetContent,
  _h as SheetDescription,
  jh as SheetFooter,
  Bh as SheetHeader,
  $a as SheetOverlay,
  Lh as SheetPortal,
  Fh as SheetTitle,
  k1 as SheetTrigger,
  Kh as SidebarFooter,
  N1 as SidebarProvider,
  Wh as SidebarRail,
  Gh as SidebarToggleButton,
  Xh as Skeleton,
  C1 as Spinner,
  M1 as Stepper,
  P1 as Switch,
  I1 as Table,
  E1 as TableActionsDropdown,
  m0 as TableActionsSubMenu,
  A1 as TableActionsSubMenuItem,
  V1 as TableExpandChevron,
  Jy as TableFiltersContainer,
  Qy as TableFiltersMain,
  t0 as TableFiltersReveal,
  Xo as TablePagination,
  L1 as TableRowSubComponent,
  Zv as Tabs,
  ga as TabsContent,
  xu as TabsList,
  wu as TabsTrigger,
  B as Text,
  R1 as Toaster,
  z1 as Toggle,
  Kt as Tooltip,
  Mt as TooltipContent,
  Gt as TooltipProvider,
  Xt as TooltipTrigger,
  x0 as TriStateCheckbox,
  g1 as Wizard,
  Ph as WizardNavigation,
  Ah as WizardProgress,
  Bd as badgeVariants,
  mu as buttonGroupVariants,
  Ir as buttonVariants,
  bu as chipVariants,
  g as cn,
  m1 as createWizardStore,
  Gn as useFormField,
  Vu as useScrollIndicators,
  Ga as useSidebar,
  H as useThemeStore
};
//# sourceMappingURL=index.js.map
